import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_engine_effect_proto from './dcei_engine_effect_proto';
export class TintColor {
  get descriptor() {
    return TintColor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasR = false;
    this._r = null;
    this._hasG = false;
    this._g = null;
    this._hasB = false;
    this._b = null;
  }
  isEmpty() {
    if (this._hasR) return false;
    if (this._hasG) return false;
    if (this._hasB) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TintColor) {
      return value;
    }
    return TintColor.fromJson(value);
  }
  static fromJson(json) {
    const result = new TintColor();
    if (json.r != null) {
      result._hasR = true;
      result._r = JsonToInt32.fromJson(json.r);
    }
    if (json.g != null) {
      result._hasG = true;
      result._g = JsonToInt32.fromJson(json.g);
    }
    if (json.b != null) {
      result._hasB = true;
      result._b = JsonToInt32.fromJson(json.b);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasR) {
      result.r = JsonToInt32.toJson(this._r);
    }
    if (this._hasG) {
      result.g = JsonToInt32.toJson(this._g);
    }
    if (this._hasB) {
      result.b = JsonToInt32.toJson(this._b);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get r() {
    return this._hasR ? this._r : JsonToInt32.default;
  }
  get hasR() {
    return this._hasR;
  }
  setR(path, value) {
    return {type: 'SET', path: path.concat(['r']), value};
  }
  deleteR(path) {
    return {type: 'DELETE', path: path.concat(['r'])};
  }
  /**
   * @returns {number}
   */
  get g() {
    return this._hasG ? this._g : JsonToInt32.default;
  }
  get hasG() {
    return this._hasG;
  }
  setG(path, value) {
    return {type: 'SET', path: path.concat(['g']), value};
  }
  deleteG(path) {
    return {type: 'DELETE', path: path.concat(['g'])};
  }
  /**
   * @returns {number}
   */
  get b() {
    return this._hasB ? this._b : JsonToInt32.default;
  }
  get hasB() {
    return this._hasB;
  }
  setB(path, value) {
    return {type: 'SET', path: path.concat(['b']), value};
  }
  deleteB(path) {
    return {type: 'DELETE', path: path.concat(['b'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "r": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TintColor(this);
              copy._hasR = true;
              copy._r = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasR) {
                return this;
              }
              const copy = new TintColor(this);
              copy._hasR = false;
              copy._r = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "g": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TintColor(this);
              copy._hasG = true;
              copy._g = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasG) {
                return this;
              }
              const copy = new TintColor(this);
              copy._hasG = false;
              copy._g = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "b": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TintColor(this);
              copy._hasB = true;
              copy._b = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasB) {
                return this;
              }
              const copy = new TintColor(this);
              copy._hasB = false;
              copy._b = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TintColor} other
   * @returns {TintColor}
   */
  merge(other) {
    const copy = new TintColor(this);
    if (other._hasR) {
      copy._hasR = true;
      copy._r = other._r;
    }
    if (other._hasG) {
      copy._hasG = true;
      copy._g = other._g;
    }
    if (other._hasB) {
      copy._hasB = true;
      copy._b = other._b;
    }
    return copy;
  }
}
TintColor.default = new TintColor();
class TintColor_Builder {
  constructor(value) {
    this._value = new TintColor(value);
  }
  build() {
    return new TintColor(this._value);
  }
  setR(value) {
    this._value._hasR = true;
    this._value._r = value;
    return this;
  }
  deleteR() {
    this._value._hasR = false;
    this._value._r = null;
    return this;
  }
  setG(value) {
    this._value._hasG = true;
    this._value._g = value;
    return this;
  }
  deleteG() {
    this._value._hasG = false;
    this._value._g = null;
    return this;
  }
  setB(value) {
    this._value._hasB = true;
    this._value._b = value;
    return this;
  }
  deleteB() {
    this._value._hasB = false;
    this._value._b = null;
    return this;
  }
}
TintColor.Builder = TintColor_Builder;
class TintColor_WithParent {
  /**
   * @param {TintColor} value
   * @param {TintColor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TintColor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasR() {
    if (this._cachedHasR === undefined) {
      if (this._value.hasR) {
        this._cachedHasR = true;
      } else {
        this._cachedHasR = this._parent ? this._parent.hasR : false;
      }
    }
    return this._cachedHasR;
  }
  get r() {
    if (this._cachedR === undefined) {
      if (this._value.hasR) {
        this._cachedR = this._value.r;
      } else {
        this._cachedR = this._parent ? this._parent.r : this._value.r;
      }
    }
    return this._cachedR;
  }
  get hasG() {
    if (this._cachedHasG === undefined) {
      if (this._value.hasG) {
        this._cachedHasG = true;
      } else {
        this._cachedHasG = this._parent ? this._parent.hasG : false;
      }
    }
    return this._cachedHasG;
  }
  get g() {
    if (this._cachedG === undefined) {
      if (this._value.hasG) {
        this._cachedG = this._value.g;
      } else {
        this._cachedG = this._parent ? this._parent.g : this._value.g;
      }
    }
    return this._cachedG;
  }
  get hasB() {
    if (this._cachedHasB === undefined) {
      if (this._value.hasB) {
        this._cachedHasB = true;
      } else {
        this._cachedHasB = this._parent ? this._parent.hasB : false;
      }
    }
    return this._cachedHasB;
  }
  get b() {
    if (this._cachedB === undefined) {
      if (this._value.hasB) {
        this._cachedB = this._value.b;
      } else {
        this._cachedB = this._parent ? this._parent.b : this._value.b;
      }
    }
    return this._cachedB;
  }
  update(current, parent) {
    const result = new TintColor_WithParent(current, parent);
    return result;
  }
}
TintColor_WithParent.default = new TintColor_WithParent(TintColor.default, null);
TintColor.WithParent = TintColor_WithParent;
class TintColor_Descriptor {
  get r() {
    if (!this._r) {
      this._r = {
        name: "r",
        Name: "R",
        number: 1,
        protoType: 5,
        protoName: "r",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._r;
  }
  get g() {
    if (!this._g) {
      this._g = {
        name: "g",
        Name: "G",
        number: 2,
        protoType: 5,
        protoName: "g",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._g;
  }
  get b() {
    if (!this._b) {
      this._b = {
        name: "b",
        Name: "B",
        number: 3,
        protoType: 5,
        protoName: "b",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._b;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.r,
        this.g,
        this.b,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForR",
        Name: "DummyOneofForR",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForG",
        Name: "DummyOneofForG",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForB",
        Name: "DummyOneofForB",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
TintColor.descriptor = new TintColor_Descriptor();
class Unit_HealthBarOption_HealthBarType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "DEFAULT": return 0;
        case "GENERAL": return 1;
        case "SHIP": return 2;
        case "HERO": return 3;
        case "DOT_MANA": return 5;
        case "DOT_HEALTH": return 6;
        case "HEALTH_WITH_MANA": return 7;
        case "NONE": return 8;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return Unit_HealthBarOption_HealthBarType.fromJson(value);
  }
  static fromReact(e) {
    return Unit_HealthBarOption_HealthBarType.fromJson(e);
  }
}
Unit_HealthBarOption_HealthBarType.DEFAULT = 0;
Unit_HealthBarOption_HealthBarType.GENERAL = 1;
Unit_HealthBarOption_HealthBarType.SHIP = 2;
Unit_HealthBarOption_HealthBarType.HERO = 3;
Unit_HealthBarOption_HealthBarType.DOT_MANA = 5;
Unit_HealthBarOption_HealthBarType.DOT_HEALTH = 6;
Unit_HealthBarOption_HealthBarType.HEALTH_WITH_MANA = 7;
Unit_HealthBarOption_HealthBarType.NONE = 8;
Unit_HealthBarOption_HealthBarType.default = 0;
Unit_HealthBarOption_HealthBarType.values = {
  DEFAULT: 0,
  GENERAL: 1,
  SHIP: 2,
  HERO: 3,
  DOT_MANA: 5,
  DOT_HEALTH: 6,
  HEALTH_WITH_MANA: 7,
  NONE: 8,
};
Unit_HealthBarOption_HealthBarType.names = {
  0: "DEFAULT",
  1: "GENERAL",
  2: "SHIP",
  3: "HERO",
  5: "DOT_MANA",
  6: "DOT_HEALTH",
  7: "HEALTH_WITH_MANA",
  8: "NONE",
};
class Unit_HealthBarOption {
  get descriptor() {
    return Unit_HealthBarOption.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasType = false;
    this._type = null;
    this._hasShowWhenFull = false;
    this._showWhenFull = null;
  }
  isEmpty() {
    if (this._hasType) return false;
    if (this._hasShowWhenFull) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Unit_HealthBarOption) {
      return value;
    }
    return Unit_HealthBarOption.fromJson(value);
  }
  static fromJson(json) {
    const result = new Unit_HealthBarOption();
    if (json.type != null) {
      result._hasType = true;
      result._type = Unit_HealthBarOption_HealthBarType.fromJson(json.type);
    }
    if (json.showWhenFull != null) {
      result._hasShowWhenFull = true;
      result._showWhenFull = JsonToBoolean.fromJson(json.showWhenFull);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasType) {
      result.type = Unit_HealthBarOption_HealthBarType.toJson(this._type);
    }
    if (this._hasShowWhenFull) {
      result.showWhenFull = JsonToBoolean.toJson(this._showWhenFull);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get type() {
    return this._hasType ? this._type : Unit_HealthBarOption_HealthBarType.default;
  }
  get hasType() {
    return this._hasType;
  }
  setType(path, value) {
    return {type: 'SET', path: path.concat(['type']), value};
  }
  deleteType(path) {
    return {type: 'DELETE', path: path.concat(['type'])};
  }
  /**
   * @returns {boolean}
   */
  get showWhenFull() {
    return this._hasShowWhenFull ? this._showWhenFull : JsonToBoolean.default;
  }
  get hasShowWhenFull() {
    return this._hasShowWhenFull;
  }
  setShowWhenFull(path, value) {
    return {type: 'SET', path: path.concat(['showWhenFull']), value};
  }
  deleteShowWhenFull(path) {
    return {type: 'DELETE', path: path.concat(['showWhenFull'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "type": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit_HealthBarOption(this);
              copy._hasType = true;
              copy._type = Unit_HealthBarOption_HealthBarType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasType) {
                return this;
              }
              const copy = new Unit_HealthBarOption(this);
              copy._hasType = false;
              copy._type = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "showWhenFull": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit_HealthBarOption(this);
              copy._hasShowWhenFull = true;
              copy._showWhenFull = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowWhenFull) {
                return this;
              }
              const copy = new Unit_HealthBarOption(this);
              copy._hasShowWhenFull = false;
              copy._showWhenFull = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Unit_HealthBarOption} other
   * @returns {Unit_HealthBarOption}
   */
  merge(other) {
    const copy = new Unit_HealthBarOption(this);
    if (other._hasType) {
      copy._hasType = true;
      copy._type = other._type;
    }
    if (other._hasShowWhenFull) {
      copy._hasShowWhenFull = true;
      copy._showWhenFull = other._showWhenFull;
    }
    return copy;
  }
}
Unit_HealthBarOption.default = new Unit_HealthBarOption();
Unit_HealthBarOption.HealthBarType = Unit_HealthBarOption_HealthBarType;
class Unit_HealthBarOption_Builder {
  constructor(value) {
    this._value = new Unit_HealthBarOption(value);
  }
  build() {
    return new Unit_HealthBarOption(this._value);
  }
  setType(value) {
    this._value._hasType = true;
    this._value._type = value;
    return this;
  }
  deleteType() {
    this._value._hasType = false;
    this._value._type = null;
    return this;
  }
  setShowWhenFull(value) {
    this._value._hasShowWhenFull = true;
    this._value._showWhenFull = value;
    return this;
  }
  deleteShowWhenFull() {
    this._value._hasShowWhenFull = false;
    this._value._showWhenFull = null;
    return this;
  }
}
Unit_HealthBarOption.Builder = Unit_HealthBarOption_Builder;
class Unit_HealthBarOption_WithParent {
  /**
   * @param {Unit_HealthBarOption} value
   * @param {Unit_HealthBarOption_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Unit_HealthBarOption.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasType() {
    if (this._cachedHasType === undefined) {
      if (this._value.hasType) {
        this._cachedHasType = true;
      } else {
        this._cachedHasType = this._parent ? this._parent.hasType : false;
      }
    }
    return this._cachedHasType;
  }
  get type() {
    if (this._cachedType === undefined) {
      if (this._value.hasType) {
        this._cachedType = this._value.type;
      } else {
        this._cachedType = this._parent ? this._parent.type : this._value.type;
      }
    }
    return this._cachedType;
  }
  get hasShowWhenFull() {
    if (this._cachedHasShowWhenFull === undefined) {
      if (this._value.hasShowWhenFull) {
        this._cachedHasShowWhenFull = true;
      } else {
        this._cachedHasShowWhenFull = this._parent ? this._parent.hasShowWhenFull : false;
      }
    }
    return this._cachedHasShowWhenFull;
  }
  get showWhenFull() {
    if (this._cachedShowWhenFull === undefined) {
      if (this._value.hasShowWhenFull) {
        this._cachedShowWhenFull = this._value.showWhenFull;
      } else {
        this._cachedShowWhenFull = this._parent ? this._parent.showWhenFull : this._value.showWhenFull;
      }
    }
    return this._cachedShowWhenFull;
  }
  update(current, parent) {
    const result = new Unit_HealthBarOption_WithParent(current, parent);
    return result;
  }
}
Unit_HealthBarOption_WithParent.default = new Unit_HealthBarOption_WithParent(Unit_HealthBarOption.default, null);
Unit_HealthBarOption.WithParent = Unit_HealthBarOption_WithParent;
class Unit_HealthBarOption_Descriptor {
  get type() {
    if (!this._type) {
      this._type = {
        name: "type",
        Name: "Type",
        number: 1,
        protoType: 14,
        protoName: "type",
        type: Unit_HealthBarOption_HealthBarType,
        options: {
          skip: ["GENERAL"],
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._type;
  }
  get showWhenFull() {
    if (!this._showWhenFull) {
      this._showWhenFull = {
        name: "showWhenFull",
        Name: "ShowWhenFull",
        number: 2,
        protoType: 8,
        protoName: "show_when_full",
        type: JsonToBoolean,
        options: {
          comments: "Some health bars will automatically hide when the unit\'s health is full. Set this flag will override this behavior and make it always show.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showWhenFull;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.type,
        this.showWhenFull,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForType",
        Name: "DummyOneofForType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShowWhenFull",
        Name: "DummyOneofForShowWhenFull",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
Unit_HealthBarOption.descriptor = new Unit_HealthBarOption_Descriptor();
class Unit_MiniMapConfig_MiniMapTypeCircle {
  get descriptor() {
    return Unit_MiniMapConfig_MiniMapTypeCircle.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasRadius = false;
    this._radius = null;
  }
  isEmpty() {
    if (this._hasRadius) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Unit_MiniMapConfig_MiniMapTypeCircle) {
      return value;
    }
    return Unit_MiniMapConfig_MiniMapTypeCircle.fromJson(value);
  }
  static fromJson(json) {
    const result = new Unit_MiniMapConfig_MiniMapTypeCircle();
    if (json.radius != null) {
      result._hasRadius = true;
      result._radius = JsonToDouble.fromJson(json.radius);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasRadius) {
      result.radius = JsonToDouble.toJson(this._radius);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get radius() {
    return this._hasRadius ? this._radius : JsonToDouble.default;
  }
  get hasRadius() {
    return this._hasRadius;
  }
  setRadius(path, value) {
    return {type: 'SET', path: path.concat(['radius']), value};
  }
  deleteRadius(path) {
    return {type: 'DELETE', path: path.concat(['radius'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "radius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit_MiniMapConfig_MiniMapTypeCircle(this);
              copy._hasRadius = true;
              copy._radius = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRadius) {
                return this;
              }
              const copy = new Unit_MiniMapConfig_MiniMapTypeCircle(this);
              copy._hasRadius = false;
              copy._radius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Unit_MiniMapConfig_MiniMapTypeCircle} other
   * @returns {Unit_MiniMapConfig_MiniMapTypeCircle}
   */
  merge(other) {
    const copy = new Unit_MiniMapConfig_MiniMapTypeCircle(this);
    if (other._hasRadius) {
      copy._hasRadius = true;
      copy._radius = other._radius;
    }
    return copy;
  }
}
Unit_MiniMapConfig_MiniMapTypeCircle.default = new Unit_MiniMapConfig_MiniMapTypeCircle();
class Unit_MiniMapConfig_MiniMapTypeCircle_Builder {
  constructor(value) {
    this._value = new Unit_MiniMapConfig_MiniMapTypeCircle(value);
  }
  build() {
    return new Unit_MiniMapConfig_MiniMapTypeCircle(this._value);
  }
  setRadius(value) {
    this._value._hasRadius = true;
    this._value._radius = value;
    return this;
  }
  deleteRadius() {
    this._value._hasRadius = false;
    this._value._radius = null;
    return this;
  }
}
Unit_MiniMapConfig_MiniMapTypeCircle.Builder = Unit_MiniMapConfig_MiniMapTypeCircle_Builder;
class Unit_MiniMapConfig_MiniMapTypeCircle_WithParent {
  /**
   * @param {Unit_MiniMapConfig_MiniMapTypeCircle} value
   * @param {Unit_MiniMapConfig_MiniMapTypeCircle_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Unit_MiniMapConfig_MiniMapTypeCircle.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasRadius() {
    if (this._cachedHasRadius === undefined) {
      if (this._value.hasRadius) {
        this._cachedHasRadius = true;
      } else {
        this._cachedHasRadius = this._parent ? this._parent.hasRadius : false;
      }
    }
    return this._cachedHasRadius;
  }
  get radius() {
    if (this._cachedRadius === undefined) {
      if (this._value.hasRadius) {
        this._cachedRadius = this._value.radius;
      } else {
        this._cachedRadius = this._parent ? this._parent.radius : this._value.radius;
      }
    }
    return this._cachedRadius;
  }
  update(current, parent) {
    const result = new Unit_MiniMapConfig_MiniMapTypeCircle_WithParent(current, parent);
    return result;
  }
}
Unit_MiniMapConfig_MiniMapTypeCircle_WithParent.default = new Unit_MiniMapConfig_MiniMapTypeCircle_WithParent(Unit_MiniMapConfig_MiniMapTypeCircle.default, null);
Unit_MiniMapConfig_MiniMapTypeCircle.WithParent = Unit_MiniMapConfig_MiniMapTypeCircle_WithParent;
class Unit_MiniMapConfig_MiniMapTypeCircle_Descriptor {
  get radius() {
    if (!this._radius) {
      this._radius = {
        name: "radius",
        Name: "Radius",
        number: 1,
        protoType: 1,
        protoName: "radius",
        type: JsonToDouble,
        options: {
          comments: "The radius to use for the unit\'s minimap icon.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._radius;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.radius,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForRadius",
        Name: "DummyOneofForRadius",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
Unit_MiniMapConfig_MiniMapTypeCircle.descriptor = new Unit_MiniMapConfig_MiniMapTypeCircle_Descriptor();
class Unit_MiniMapConfig_MiniMapTypeSprite {
  get descriptor() {
    return Unit_MiniMapConfig_MiniMapTypeSprite.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasIcon = false;
    this._icon = null;
    this._hasSize = false;
    this._size = null;
  }
  isEmpty() {
    if (this._hasIcon) return false;
    if (this._hasSize) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Unit_MiniMapConfig_MiniMapTypeSprite) {
      return value;
    }
    return Unit_MiniMapConfig_MiniMapTypeSprite.fromJson(value);
  }
  static fromJson(json) {
    const result = new Unit_MiniMapConfig_MiniMapTypeSprite();
    if (json.icon != null) {
      result._hasIcon = true;
      result._icon = JsonToString.fromJson(json.icon);
    }
    if (json.size != null) {
      result._hasSize = true;
      result._size = JsonToDouble.fromJson(json.size);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasIcon) {
      result.icon = JsonToString.toJson(this._icon);
    }
    if (this._hasSize) {
      result.size = JsonToDouble.toJson(this._size);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get icon() {
    return this._hasIcon ? this._icon : JsonToString.default;
  }
  get hasIcon() {
    return this._hasIcon;
  }
  setIcon(path, value) {
    return {type: 'SET', path: path.concat(['icon']), value};
  }
  deleteIcon(path) {
    return {type: 'DELETE', path: path.concat(['icon'])};
  }
  /**
   * @returns {number}
   */
  get size() {
    return this._hasSize ? this._size : JsonToDouble.default;
  }
  get hasSize() {
    return this._hasSize;
  }
  setSize(path, value) {
    return {type: 'SET', path: path.concat(['size']), value};
  }
  deleteSize(path) {
    return {type: 'DELETE', path: path.concat(['size'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "icon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit_MiniMapConfig_MiniMapTypeSprite(this);
              copy._hasIcon = true;
              copy._icon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIcon) {
                return this;
              }
              const copy = new Unit_MiniMapConfig_MiniMapTypeSprite(this);
              copy._hasIcon = false;
              copy._icon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "size": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit_MiniMapConfig_MiniMapTypeSprite(this);
              copy._hasSize = true;
              copy._size = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSize) {
                return this;
              }
              const copy = new Unit_MiniMapConfig_MiniMapTypeSprite(this);
              copy._hasSize = false;
              copy._size = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Unit_MiniMapConfig_MiniMapTypeSprite} other
   * @returns {Unit_MiniMapConfig_MiniMapTypeSprite}
   */
  merge(other) {
    const copy = new Unit_MiniMapConfig_MiniMapTypeSprite(this);
    if (other._hasIcon) {
      copy._hasIcon = true;
      copy._icon = other._icon;
    }
    if (other._hasSize) {
      copy._hasSize = true;
      copy._size = other._size;
    }
    return copy;
  }
}
Unit_MiniMapConfig_MiniMapTypeSprite.default = new Unit_MiniMapConfig_MiniMapTypeSprite();
class Unit_MiniMapConfig_MiniMapTypeSprite_Builder {
  constructor(value) {
    this._value = new Unit_MiniMapConfig_MiniMapTypeSprite(value);
  }
  build() {
    return new Unit_MiniMapConfig_MiniMapTypeSprite(this._value);
  }
  setIcon(value) {
    this._value._hasIcon = true;
    this._value._icon = value;
    return this;
  }
  deleteIcon() {
    this._value._hasIcon = false;
    this._value._icon = null;
    return this;
  }
  setSize(value) {
    this._value._hasSize = true;
    this._value._size = value;
    return this;
  }
  deleteSize() {
    this._value._hasSize = false;
    this._value._size = null;
    return this;
  }
}
Unit_MiniMapConfig_MiniMapTypeSprite.Builder = Unit_MiniMapConfig_MiniMapTypeSprite_Builder;
class Unit_MiniMapConfig_MiniMapTypeSprite_WithParent {
  /**
   * @param {Unit_MiniMapConfig_MiniMapTypeSprite} value
   * @param {Unit_MiniMapConfig_MiniMapTypeSprite_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Unit_MiniMapConfig_MiniMapTypeSprite.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasIcon() {
    if (this._cachedHasIcon === undefined) {
      if (this._value.hasIcon) {
        this._cachedHasIcon = true;
      } else {
        this._cachedHasIcon = this._parent ? this._parent.hasIcon : false;
      }
    }
    return this._cachedHasIcon;
  }
  get icon() {
    if (this._cachedIcon === undefined) {
      if (this._value.hasIcon) {
        this._cachedIcon = this._value.icon;
      } else {
        this._cachedIcon = this._parent ? this._parent.icon : this._value.icon;
      }
    }
    return this._cachedIcon;
  }
  get hasSize() {
    if (this._cachedHasSize === undefined) {
      if (this._value.hasSize) {
        this._cachedHasSize = true;
      } else {
        this._cachedHasSize = this._parent ? this._parent.hasSize : false;
      }
    }
    return this._cachedHasSize;
  }
  get size() {
    if (this._cachedSize === undefined) {
      if (this._value.hasSize) {
        this._cachedSize = this._value.size;
      } else {
        this._cachedSize = this._parent ? this._parent.size : this._value.size;
      }
    }
    return this._cachedSize;
  }
  update(current, parent) {
    const result = new Unit_MiniMapConfig_MiniMapTypeSprite_WithParent(current, parent);
    return result;
  }
}
Unit_MiniMapConfig_MiniMapTypeSprite_WithParent.default = new Unit_MiniMapConfig_MiniMapTypeSprite_WithParent(Unit_MiniMapConfig_MiniMapTypeSprite.default, null);
Unit_MiniMapConfig_MiniMapTypeSprite.WithParent = Unit_MiniMapConfig_MiniMapTypeSprite_WithParent;
class Unit_MiniMapConfig_MiniMapTypeSprite_Descriptor {
  get icon() {
    if (!this._icon) {
      this._icon = {
        name: "icon",
        Name: "Icon",
        number: 1,
        protoType: 9,
        protoName: "icon",
        type: JsonToString,
        options: {
          comments: "The sprite name to use for the unit\'s minimap icon.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._icon;
  }
  get size() {
    if (!this._size) {
      this._size = {
        name: "size",
        Name: "Size",
        number: 2,
        protoType: 1,
        protoName: "size",
        type: JsonToDouble,
        options: {
          comments: "The size to use for the unit\'s minimap icon.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._size;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.icon,
        this.size,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForIcon",
        Name: "DummyOneofForIcon",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSize",
        Name: "DummyOneofForSize",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
Unit_MiniMapConfig_MiniMapTypeSprite.descriptor = new Unit_MiniMapConfig_MiniMapTypeSprite_Descriptor();
class Unit_MiniMapConfig {
  get descriptor() {
    return Unit_MiniMapConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasShowOnMiniMap = false;
    this._showOnMiniMap = null;
    this._miniMapUiTypeCase = 0;
    this._miniMapUiTypeValue = null;
    this._hasRenderPriority = false;
    this._renderPriority = null;
    this._hasTintColor = false;
    this._tintColor = null;
  }
  isEmpty() {
    if (this._hasShowOnMiniMap) return false;
    if (this._miniMapUiTypeCase !== 0) return false;
    if (this._hasRenderPriority) return false;
    if (this._hasTintColor && !this._tintColor.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Unit_MiniMapConfig) {
      return value;
    }
    return Unit_MiniMapConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new Unit_MiniMapConfig();
    if (json.showOnMiniMap != null) {
      result._hasShowOnMiniMap = true;
      result._showOnMiniMap = JsonToBoolean.fromJson(json.showOnMiniMap);
    }
    if (json.circle != null) {
      result._miniMapUiTypeCase = 101;
      result._miniMapUiTypeValue = Unit_MiniMapConfig_MiniMapTypeCircle.fromJson(json.circle);
    }
    if (json.sprite != null) {
      result._miniMapUiTypeCase = 102;
      result._miniMapUiTypeValue = Unit_MiniMapConfig_MiniMapTypeSprite.fromJson(json.sprite);
    }
    if (json.renderPriority != null) {
      result._hasRenderPriority = true;
      result._renderPriority = JsonToInt32.fromJson(json.renderPriority);
    }
    if (json.tintColor != null) {
      result._hasTintColor = true;
      result._tintColor = TintColor.fromJson(json.tintColor);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasShowOnMiniMap) {
      result.showOnMiniMap = JsonToBoolean.toJson(this._showOnMiniMap);
    }
    switch (this._miniMapUiTypeCase) {
      case 101:
        result.circle = Unit_MiniMapConfig_MiniMapTypeCircle.toJson(this._miniMapUiTypeValue);
        break;
      case 102:
        result.sprite = Unit_MiniMapConfig_MiniMapTypeSprite.toJson(this._miniMapUiTypeValue);
        break;
      default:
        break;
    }
    if (this._hasRenderPriority) {
      result.renderPriority = JsonToInt32.toJson(this._renderPriority);
    }
    if (this._hasTintColor && !this._tintColor.isEmpty()) {
      result.tintColor = TintColor.toJson(this._tintColor);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get showOnMiniMap() {
    return this._hasShowOnMiniMap ? this._showOnMiniMap : JsonToBoolean.default;
  }
  get hasShowOnMiniMap() {
    return this._hasShowOnMiniMap;
  }
  setShowOnMiniMap(path, value) {
    return {type: 'SET', path: path.concat(['showOnMiniMap']), value};
  }
  deleteShowOnMiniMap(path) {
    return {type: 'DELETE', path: path.concat(['showOnMiniMap'])};
  }
  get miniMapUiTypeCase() {
    return this._miniMapUiTypeCase;
  }
  deleteMiniMapUiType(path) {
    switch (this._miniMapUiTypeCase) {
      default:
      case 101: {
        return {type: 'DELETE', path: path.concat(['circle'])};
      }
      case 102: {
        return {type: 'DELETE', path: path.concat(['sprite'])};
      }
    }
  }
  /**
   * @returns {Unit_MiniMapConfig_MiniMapTypeCircle}
   */
  get circle() {
    return this._miniMapUiTypeCase === 101 ? this._miniMapUiTypeValue : Unit_MiniMapConfig_MiniMapTypeCircle.default;
  }
  setCircle(path, value) {
    return {type: 'SET', path: path.concat(['circle']), value: value.toJson()};
  }
  deleteCircle(path) {
    return {type: 'DELETE', path: path.concat(['circle'])};
  }
  /**
   * @returns {Unit_MiniMapConfig_MiniMapTypeSprite}
   */
  get sprite() {
    return this._miniMapUiTypeCase === 102 ? this._miniMapUiTypeValue : Unit_MiniMapConfig_MiniMapTypeSprite.default;
  }
  setSprite(path, value) {
    return {type: 'SET', path: path.concat(['sprite']), value: value.toJson()};
  }
  deleteSprite(path) {
    return {type: 'DELETE', path: path.concat(['sprite'])};
  }
  /**
   * @returns {number}
   */
  get renderPriority() {
    return this._hasRenderPriority ? this._renderPriority : JsonToInt32.default;
  }
  get hasRenderPriority() {
    return this._hasRenderPriority;
  }
  setRenderPriority(path, value) {
    return {type: 'SET', path: path.concat(['renderPriority']), value};
  }
  deleteRenderPriority(path) {
    return {type: 'DELETE', path: path.concat(['renderPriority'])};
  }
  /**
   * @returns {TintColor}
   */
  get tintColor() {
    return this._hasTintColor ? this._tintColor : TintColor.default;
  }
  get hasTintColor() {
    return this._hasTintColor;
  }
  setTintColor(path, value) {
    return {type: 'SET', path: path.concat(['tintColor']), value: value.toJson()};
  }
  deleteTintColor(path) {
    return {type: 'DELETE', path: path.concat(['tintColor'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "showOnMiniMap": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit_MiniMapConfig(this);
              copy._hasShowOnMiniMap = true;
              copy._showOnMiniMap = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowOnMiniMap) {
                return this;
              }
              const copy = new Unit_MiniMapConfig(this);
              copy._hasShowOnMiniMap = false;
              copy._showOnMiniMap = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "circle": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit_MiniMapConfig(this);
              copy._miniMapUiTypeCase = 101;
              copy._miniMapUiTypeValue = Unit_MiniMapConfig_MiniMapTypeCircle.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._miniMapUiTypeCase !== 101) {
                return this;
              }
              const copy = new Unit_MiniMapConfig(this);
              copy._miniMapUiTypeCase = 0;
              copy._miniMapUiTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._miniMapUiTypeCase !== 101) {
            const copy = new Unit_MiniMapConfig(this);
            copy._miniMapUiTypeCase = 101;
            copy._miniMapUiTypeValue = Unit_MiniMapConfig_MiniMapTypeCircle.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.circle.apply(type, path.slice(1), value);
          if (newValue === this.circle) {
            return this;
          }
          const copy = new Unit_MiniMapConfig(this);
          copy._miniMapUiTypeCase = 101;
          copy._miniMapUiTypeValue = newValue;
          return copy;
        }
      }
      case "sprite": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit_MiniMapConfig(this);
              copy._miniMapUiTypeCase = 102;
              copy._miniMapUiTypeValue = Unit_MiniMapConfig_MiniMapTypeSprite.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._miniMapUiTypeCase !== 102) {
                return this;
              }
              const copy = new Unit_MiniMapConfig(this);
              copy._miniMapUiTypeCase = 0;
              copy._miniMapUiTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._miniMapUiTypeCase !== 102) {
            const copy = new Unit_MiniMapConfig(this);
            copy._miniMapUiTypeCase = 102;
            copy._miniMapUiTypeValue = Unit_MiniMapConfig_MiniMapTypeSprite.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.sprite.apply(type, path.slice(1), value);
          if (newValue === this.sprite) {
            return this;
          }
          const copy = new Unit_MiniMapConfig(this);
          copy._miniMapUiTypeCase = 102;
          copy._miniMapUiTypeValue = newValue;
          return copy;
        }
      }
      case "renderPriority": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit_MiniMapConfig(this);
              copy._hasRenderPriority = true;
              copy._renderPriority = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRenderPriority) {
                return this;
              }
              const copy = new Unit_MiniMapConfig(this);
              copy._hasRenderPriority = false;
              copy._renderPriority = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tintColor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit_MiniMapConfig(this);
              copy._hasTintColor = true;
              copy._tintColor = TintColor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTintColor) {
                return this;
              }
              const copy = new Unit_MiniMapConfig(this);
              copy._hasTintColor = false;
              copy._tintColor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTintColor) {
            const copy = new Unit_MiniMapConfig(this);
            copy._hasTintColor = true;
            copy._tintColor = TintColor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._tintColor.apply(type, path.slice(1), value);
          if (newValue === this._tintColor) {
            return this;
          }
          const copy = new Unit_MiniMapConfig(this);
          copy._tintColor = copy._tintColor.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Unit_MiniMapConfig} other
   * @returns {Unit_MiniMapConfig}
   */
  merge(other) {
    const copy = new Unit_MiniMapConfig(this);
    if (other._hasShowOnMiniMap) {
      copy._hasShowOnMiniMap = true;
      copy._showOnMiniMap = other._showOnMiniMap;
    }
    if (other._miniMapUiTypeCase === 101) {
      if (this._miniMapUiTypeCase === 101) {
        copy._miniMapUiTypeValue = copy._miniMapUiTypeValue.merge(other._miniMapUiTypeValue);
      } else {
        copy._miniMapUiTypeValue = other._miniMapUiTypeValue;
      }
      copy._miniMapUiTypeCase = 101;
    }
    if (other._miniMapUiTypeCase === 101) {
      if (this._miniMapUiTypeCase === 101) {
        copy._miniMapUiTypeValue = copy._miniMapUiTypeValue.merge(other._miniMapUiTypeValue);
      } else {
        copy._miniMapUiTypeValue = other._miniMapUiTypeValue;
      }
      copy._miniMapUiTypeCase = 101;
    }
    if (other._hasRenderPriority) {
      copy._hasRenderPriority = true;
      copy._renderPriority = other._renderPriority;
    }
    if (other._hasTintColor) {
      if (copy._hasTintColor) {
        copy._tintColor = copy.tintColor.merge(other.tintColor);
      } else {
        copy._tintColor = other._tintColor;
      }
      copy._hasTintColor = true;
    }
    return copy;
  }
}
Unit_MiniMapConfig.default = new Unit_MiniMapConfig();
Unit_MiniMapConfig.MiniMapTypeCircle = Unit_MiniMapConfig_MiniMapTypeCircle;
Unit_MiniMapConfig.MiniMapTypeSprite = Unit_MiniMapConfig_MiniMapTypeSprite;
class Unit_MiniMapConfig_Builder {
  constructor(value) {
    this._value = new Unit_MiniMapConfig(value);
  }
  build() {
    return new Unit_MiniMapConfig(this._value);
  }
  setShowOnMiniMap(value) {
    this._value._hasShowOnMiniMap = true;
    this._value._showOnMiniMap = value;
    return this;
  }
  deleteShowOnMiniMap() {
    this._value._hasShowOnMiniMap = false;
    this._value._showOnMiniMap = null;
    return this;
  }
  clearminiMapUiType() {
    this._value._miniMapUiTypeCase = 0;
    this._value._miniMapUiTypeValue = null;
    return this;
  }
  setCircle(value) {
    this._value._miniMapUiTypeCase = 101;
    this._value._miniMapUiTypeValue = value;
    return this;
  }
  setSprite(value) {
    this._value._miniMapUiTypeCase = 102;
    this._value._miniMapUiTypeValue = value;
    return this;
  }
  setRenderPriority(value) {
    this._value._hasRenderPriority = true;
    this._value._renderPriority = value;
    return this;
  }
  deleteRenderPriority() {
    this._value._hasRenderPriority = false;
    this._value._renderPriority = null;
    return this;
  }
  setTintColor(value) {
    this._value._hasTintColor = true;
    this._value._tintColor = value;
    return this;
  }
  deleteTintColor() {
    this._value._hasTintColor = false;
    this._value._tintColor = null;
    return this;
  }
}
Unit_MiniMapConfig.Builder = Unit_MiniMapConfig_Builder;
class Unit_MiniMapConfig_WithParent {
  /**
   * @param {Unit_MiniMapConfig} value
   * @param {Unit_MiniMapConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Unit_MiniMapConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasShowOnMiniMap() {
    if (this._cachedHasShowOnMiniMap === undefined) {
      if (this._value.hasShowOnMiniMap) {
        this._cachedHasShowOnMiniMap = true;
      } else {
        this._cachedHasShowOnMiniMap = this._parent ? this._parent.hasShowOnMiniMap : false;
      }
    }
    return this._cachedHasShowOnMiniMap;
  }
  get showOnMiniMap() {
    if (this._cachedShowOnMiniMap === undefined) {
      if (this._value.hasShowOnMiniMap) {
        this._cachedShowOnMiniMap = this._value.showOnMiniMap;
      } else {
        this._cachedShowOnMiniMap = this._parent ? this._parent.showOnMiniMap : this._value.showOnMiniMap;
      }
    }
    return this._cachedShowOnMiniMap;
  }
  get miniMapUiTypeCase() {
    if (this._cachedminiMapUiTypeCase === undefined) {
      if (this._value._miniMapUiTypeCase === 0) {
        this._cachedminiMapUiTypeCase = this._parent ? this._parent.miniMapUiTypeCase : 0;
      } else {
        this._cachedminiMapUiTypeCase = this._value._miniMapUiTypeCase;
      }
    }
    return this._cachedminiMapUiTypeCase;
  }
  get circle() {
    if (!this._cachedCircle) {
      if (this._value._miniMapUiTypeCase === 0) {
        this._cachedCircle = this._parent ? new Unit_MiniMapConfig_MiniMapTypeCircle.WithParent(Unit_MiniMapConfig_MiniMapTypeCircle.default, this._parent.circle) : this._value.circle;
      } else if (this._value._miniMapUiTypeCase === 101) {
        this._cachedCircle = new Unit_MiniMapConfig_MiniMapTypeCircle.WithParent(this._value.circle, this._parent && this._parent.miniMapUiTypeCase === 101 ? this._parent.circle : null);
      } else {
        this._cachedCircle = Unit_MiniMapConfig_MiniMapTypeCircle.WithParent.default;
      }
    }
    return this._cachedCircle;
  }
  get sprite() {
    if (!this._cachedSprite) {
      if (this._value._miniMapUiTypeCase === 0) {
        this._cachedSprite = this._parent ? new Unit_MiniMapConfig_MiniMapTypeSprite.WithParent(Unit_MiniMapConfig_MiniMapTypeSprite.default, this._parent.sprite) : this._value.sprite;
      } else if (this._value._miniMapUiTypeCase === 102) {
        this._cachedSprite = new Unit_MiniMapConfig_MiniMapTypeSprite.WithParent(this._value.sprite, this._parent && this._parent.miniMapUiTypeCase === 102 ? this._parent.sprite : null);
      } else {
        this._cachedSprite = Unit_MiniMapConfig_MiniMapTypeSprite.WithParent.default;
      }
    }
    return this._cachedSprite;
  }
  get hasRenderPriority() {
    if (this._cachedHasRenderPriority === undefined) {
      if (this._value.hasRenderPriority) {
        this._cachedHasRenderPriority = true;
      } else {
        this._cachedHasRenderPriority = this._parent ? this._parent.hasRenderPriority : false;
      }
    }
    return this._cachedHasRenderPriority;
  }
  get renderPriority() {
    if (this._cachedRenderPriority === undefined) {
      if (this._value.hasRenderPriority) {
        this._cachedRenderPriority = this._value.renderPriority;
      } else {
        this._cachedRenderPriority = this._parent ? this._parent.renderPriority : this._value.renderPriority;
      }
    }
    return this._cachedRenderPriority;
  }
  get hasTintColor() {
    if (this._cachedHasTintColor === undefined) {
      if (this._value.hasTintColor) {
        this._cachedHasTintColor = true;
      } else {
        this._cachedHasTintColor = this._parent ? this._parent.hasTintColor : false;
      }
    }
    return this._cachedHasTintColor;
  }
  get tintColor() {
    if (!this._cachedTintColor) {
      if (this._value.hasTintColor) {
        this._cachedTintColor = new TintColor.WithParent(this._value.tintColor, this._parent && this._parent.hasTintColor ? this._parent.tintColor : null);
      } else {
        this._cachedTintColor = this._parent ? new TintColor.WithParent(TintColor.default, this._parent.tintColor) : TintColor.WithParent.default;
      }
    }
    return this._cachedTintColor;
  }
  update(current, parent) {
    const result = new Unit_MiniMapConfig_WithParent(current, parent);
    if (this._cachedCircle && this._value._miniMapUiTypeCase === 101 && current._miniMapUiTypeCase === 101) {
      if (this._value.circle === current.circle && this._parent === parent) {
        result._cachedCircle = this._cachedCircle;
      } else {
        result._cachedCircle = this._cachedCircle.update(current.circle, parent && parent.miniMapUiTypeCase === 101 ? parent.circle : null);
      }
    }
    if (this._cachedSprite && this._value._miniMapUiTypeCase === 102 && current._miniMapUiTypeCase === 102) {
      if (this._value.sprite === current.sprite && this._parent === parent) {
        result._cachedSprite = this._cachedSprite;
      } else {
        result._cachedSprite = this._cachedSprite.update(current.sprite, parent && parent.miniMapUiTypeCase === 102 ? parent.sprite : null);
      }
    }
    if (this._cachedTintColor && this._value.hasTintColor && current.hasTintColor) {
      if (this._value.tintColor === current.tintColor && this._parent === parent) {
        result._cachedTintColor = this._cachedTintColor;
      } else {
        result._cachedTintColor = this._cachedTintColor.update(current.tintColor, parent && parent.hasTintColor ? parent.tintColor : null);
      }
    }
    return result;
  }
}
Unit_MiniMapConfig_WithParent.default = new Unit_MiniMapConfig_WithParent(Unit_MiniMapConfig.default, null);
Unit_MiniMapConfig.WithParent = Unit_MiniMapConfig_WithParent;
class Unit_MiniMapConfig_Descriptor {
  get showOnMiniMap() {
    if (!this._showOnMiniMap) {
      this._showOnMiniMap = {
        name: "showOnMiniMap",
        Name: "ShowOnMiniMap",
        number: 1,
        protoType: 8,
        protoName: "show_on_mini_map",
        type: JsonToBoolean,
        options: {
          comments: "When enabled, causes the unit to render on minimap frames.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showOnMiniMap;
  }
  get circle() {
    if (!this._circle) {
      this._circle = {
        name: "circle",
        Name: "Circle",
        number: 101,
        protoType: 11,
        protoName: "circle",
        oneofIndex: 1,
        type: Unit_MiniMapConfig_MiniMapTypeCircle,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._circle;
  }
  get sprite() {
    if (!this._sprite) {
      this._sprite = {
        name: "sprite",
        Name: "Sprite",
        number: 102,
        protoType: 11,
        protoName: "sprite",
        oneofIndex: 1,
        type: Unit_MiniMapConfig_MiniMapTypeSprite,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._sprite;
  }
  get renderPriority() {
    if (!this._renderPriority) {
      this._renderPriority = {
        name: "renderPriority",
        Name: "RenderPriority",
        number: 2,
        protoType: 5,
        protoName: "render_priority",
        type: JsonToInt32,
        options: {
          comments: "Higher render priority units will display above lower priority ones in the minimap.",
          max: 99,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._renderPriority;
  }
  get tintColor() {
    if (!this._tintColor) {
      this._tintColor = {
        name: "tintColor",
        Name: "TintColor",
        number: 3,
        protoType: 11,
        protoName: "tint_color",
        type: TintColor,
        options: {
          comments: "Sets the tint color of the unit\'s minimap render using RGB values.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tintColor;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.showOnMiniMap,
        this.circle,
        this.sprite,
        this.renderPriority,
        this.tintColor,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForShowOnMiniMap",
        Name: "DummyOneofForShowOnMiniMap",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "miniMapUiType",
        Name: "MiniMapUiType",
        fields: [
          this.fields[1],
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRenderPriority",
        Name: "DummyOneofForRenderPriority",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTintColor",
        Name: "DummyOneofForTintColor",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
Unit_MiniMapConfig.descriptor = new Unit_MiniMapConfig_Descriptor();
export class Unit {
  get descriptor() {
    return Unit.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPrefix = false;
    this._prefix = null;
    this._hasTemplate = false;
    this._template = null;
    this._hasComment = false;
    this._comment = null;
    this._hasParent = false;
    this._baseUnit = null;
    this._hasComponents = false;
    this._components = null;
    this._hasReferences = false;
    this._references = null;
    this._hasLevel = false;
    this._level = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasHideUnitStatusBar = false;
    this._hideUnitStatusBar = null;
    this._hasIngameIcon = false;
    this._ingameIcon = null;
    this._hasBindAbilityUi = false;
    this._bindAbilityUi = null;
    this._hasHealthBar = false;
    this._healthBar = null;
    this._dependentUnits = [];
    this._dependentEffects = [];
    this._dependentBehaviors = [];
    this._dependentSpriteAssets = [];
    this._hasMiniMapConfig = false;
    this._miniMapConfig = null;
    this._hasCardId = false;
    this._cardId = null;
    this._hasAffinityIndex = false;
    this._affinityIndex = null;
    this._hasCardName = false;
    this._cardName = null;
  }
  isEmpty() {
    if (this._hasPrefix) return false;
    if (this._hasTemplate) return false;
    if (this._hasComment) return false;
    if (this._hasParent) return false;
    if (this._hasComponents && !this._components.isEmpty()) return false;
    if (this._hasReferences && !this._references.isEmpty()) return false;
    if (this._hasLevel) return false;
    if (this._hasDisplayName) return false;
    if (this._hasHideUnitStatusBar) return false;
    if (this._hasIngameIcon) return false;
    if (this._hasBindAbilityUi) return false;
    if (this._hasHealthBar && !this._healthBar.isEmpty()) return false;
    if (this._dependentUnits.length > 0) return false;
    if (this._dependentEffects.length > 0) return false;
    if (this._dependentBehaviors.length > 0) return false;
    if (this._dependentSpriteAssets.length > 0) return false;
    if (this._hasMiniMapConfig && !this._miniMapConfig.isEmpty()) return false;
    if (this._hasCardId) return false;
    if (this._hasAffinityIndex) return false;
    if (this._hasCardName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Unit) {
      return value;
    }
    return Unit.fromJson(value);
  }
  static fromJson(json) {
    const result = new Unit();
    if (json.prefix != null) {
      result._hasPrefix = true;
      result._prefix = JsonToString.fromJson(json.prefix);
    }
    if (json.template != null) {
      result._hasTemplate = true;
      result._template = JsonToBoolean.fromJson(json.template);
    }
    if (json.comment != null) {
      result._hasComment = true;
      result._comment = JsonToString.fromJson(json.comment);
    }
    if (json.baseUnit != null) {
      result._hasParent = true;
      result._baseUnit = JsonToString.fromJson(json.baseUnit);
    }
    if (json.components != null) {
      result._hasComponents = true;
      result._components = UnitComponents.fromJson(json.components);
    }
    if (json.references != null) {
      result._hasReferences = true;
      result._references = UnitReferences.fromJson(json.references);
    }
    if (json.level != null) {
      result._hasLevel = true;
      result._level = JsonToInt32.fromJson(json.level);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.hideUnitStatusBar != null) {
      result._hasHideUnitStatusBar = true;
      result._hideUnitStatusBar = JsonToBoolean.fromJson(json.hideUnitStatusBar);
    }
    if (json.ingameIcon != null) {
      result._hasIngameIcon = true;
      result._ingameIcon = JsonToString.fromJson(json.ingameIcon);
    }
    if (json.bindAbilityUi != null) {
      result._hasBindAbilityUi = true;
      result._bindAbilityUi = JsonToBoolean.fromJson(json.bindAbilityUi);
    }
    if (json.healthBar != null) {
      result._hasHealthBar = true;
      result._healthBar = Unit_HealthBarOption.fromJson(json.healthBar);
    }
    result._dependentUnits = JsonToList(json.dependentUnits, JsonToString);
    result._dependentEffects = JsonToList(json.dependentEffects, JsonToString);
    result._dependentBehaviors = JsonToList(json.dependentBehaviors, JsonToString);
    result._dependentSpriteAssets = JsonToList(json.dependentSpriteAssets, JsonToString);
    if (json.miniMapConfig != null) {
      result._hasMiniMapConfig = true;
      result._miniMapConfig = Unit_MiniMapConfig.fromJson(json.miniMapConfig);
    }
    if (json.cardId != null) {
      result._hasCardId = true;
      result._cardId = JsonToInt32.fromJson(json.cardId);
    }
    if (json.affinityIndex != null) {
      result._hasAffinityIndex = true;
      result._affinityIndex = JsonToInt32.fromJson(json.affinityIndex);
    }
    if (json.cardName != null) {
      result._hasCardName = true;
      result._cardName = JsonToString.fromJson(json.cardName);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPrefix) {
      result.prefix = JsonToString.toJson(this._prefix);
    }
    if (this._hasTemplate) {
      result.template = JsonToBoolean.toJson(this._template);
    }
    if (this._hasComment) {
      result.comment = JsonToString.toJson(this._comment);
    }
    if (this._hasParent) {
      result.baseUnit = JsonToString.toJson(this._baseUnit);
    }
    if (this._hasComponents && !this._components.isEmpty()) {
      result.components = UnitComponents.toJson(this._components);
    }
    if (this._hasReferences && !this._references.isEmpty()) {
      result.references = UnitReferences.toJson(this._references);
    }
    if (this._hasLevel) {
      result.level = JsonToInt32.toJson(this._level);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasHideUnitStatusBar) {
      result.hideUnitStatusBar = JsonToBoolean.toJson(this._hideUnitStatusBar);
    }
    if (this._hasIngameIcon) {
      result.ingameIcon = JsonToString.toJson(this._ingameIcon);
    }
    if (this._hasBindAbilityUi) {
      result.bindAbilityUi = JsonToBoolean.toJson(this._bindAbilityUi);
    }
    if (this._hasHealthBar && !this._healthBar.isEmpty()) {
      result.healthBar = Unit_HealthBarOption.toJson(this._healthBar);
    }
    if (this._dependentUnits.length > 0) {
      result.dependentUnits = ArrayToJson(this._dependentUnits, JsonToString);
    }
    if (this._dependentEffects.length > 0) {
      result.dependentEffects = ArrayToJson(this._dependentEffects, JsonToString);
    }
    if (this._dependentBehaviors.length > 0) {
      result.dependentBehaviors = ArrayToJson(this._dependentBehaviors, JsonToString);
    }
    if (this._dependentSpriteAssets.length > 0) {
      result.dependentSpriteAssets = ArrayToJson(this._dependentSpriteAssets, JsonToString);
    }
    if (this._hasMiniMapConfig && !this._miniMapConfig.isEmpty()) {
      result.miniMapConfig = Unit_MiniMapConfig.toJson(this._miniMapConfig);
    }
    if (this._hasCardId) {
      result.cardId = JsonToInt32.toJson(this._cardId);
    }
    if (this._hasAffinityIndex) {
      result.affinityIndex = JsonToInt32.toJson(this._affinityIndex);
    }
    if (this._hasCardName) {
      result.cardName = JsonToString.toJson(this._cardName);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get prefix() {
    return this._hasPrefix ? this._prefix : JsonToString.default;
  }
  get hasPrefix() {
    return this._hasPrefix;
  }
  setPrefix(path, value) {
    return {type: 'SET', path: path.concat(['prefix']), value};
  }
  deletePrefix(path) {
    return {type: 'DELETE', path: path.concat(['prefix'])};
  }
  /**
   * @returns {boolean}
   */
  get template() {
    return this._hasTemplate ? this._template : JsonToBoolean.default;
  }
  get hasTemplate() {
    return this._hasTemplate;
  }
  setTemplate(path, value) {
    return {type: 'SET', path: path.concat(['template']), value};
  }
  deleteTemplate(path) {
    return {type: 'DELETE', path: path.concat(['template'])};
  }
  /**
   * @returns {string}
   */
  get comment() {
    return this._hasComment ? this._comment : JsonToString.default;
  }
  get hasComment() {
    return this._hasComment;
  }
  setComment(path, value) {
    return {type: 'SET', path: path.concat(['comment']), value};
  }
  deleteComment(path) {
    return {type: 'DELETE', path: path.concat(['comment'])};
  }
  /**
   * @returns {string}
   */
  get baseUnit() {
    return this._hasParent ? this._baseUnit : JsonToString.default;
  }
  get hasParent() {
    return this._hasParent;
  }
  setParent(path, value) {
    return {type: 'SET', path: path.concat(['baseUnit']), value};
  }
  deleteParent(path) {
    return {type: 'DELETE', path: path.concat(['baseUnit'])};
  }
  /**
   * @returns {UnitComponents}
   */
  get components() {
    return this._hasComponents ? this._components : UnitComponents.default;
  }
  get hasComponents() {
    return this._hasComponents;
  }
  setComponents(path, value) {
    return {type: 'SET', path: path.concat(['components']), value: value.toJson()};
  }
  deleteComponents(path) {
    return {type: 'DELETE', path: path.concat(['components'])};
  }
  /**
   * @returns {UnitReferences}
   */
  get references() {
    return this._hasReferences ? this._references : UnitReferences.default;
  }
  get hasReferences() {
    return this._hasReferences;
  }
  setReferences(path, value) {
    return {type: 'SET', path: path.concat(['references']), value: value.toJson()};
  }
  deleteReferences(path) {
    return {type: 'DELETE', path: path.concat(['references'])};
  }
  /**
   * @returns {number}
   */
  get level() {
    return this._hasLevel ? this._level : JsonToInt32.default;
  }
  get hasLevel() {
    return this._hasLevel;
  }
  setLevel(path, value) {
    return {type: 'SET', path: path.concat(['level']), value};
  }
  deleteLevel(path) {
    return {type: 'DELETE', path: path.concat(['level'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {boolean}
   */
  get hideUnitStatusBar() {
    return this._hasHideUnitStatusBar ? this._hideUnitStatusBar : JsonToBoolean.default;
  }
  get hasHideUnitStatusBar() {
    return this._hasHideUnitStatusBar;
  }
  setHideUnitStatusBar(path, value) {
    return {type: 'SET', path: path.concat(['hideUnitStatusBar']), value};
  }
  deleteHideUnitStatusBar(path) {
    return {type: 'DELETE', path: path.concat(['hideUnitStatusBar'])};
  }
  /**
   * @returns {string}
   */
  get ingameIcon() {
    return this._hasIngameIcon ? this._ingameIcon : JsonToString.default;
  }
  get hasIngameIcon() {
    return this._hasIngameIcon;
  }
  setIngameIcon(path, value) {
    return {type: 'SET', path: path.concat(['ingameIcon']), value};
  }
  deleteIngameIcon(path) {
    return {type: 'DELETE', path: path.concat(['ingameIcon'])};
  }
  /**
   * @returns {boolean}
   */
  get bindAbilityUi() {
    return this._hasBindAbilityUi ? this._bindAbilityUi : JsonToBoolean.default;
  }
  get hasBindAbilityUi() {
    return this._hasBindAbilityUi;
  }
  setBindAbilityUi(path, value) {
    return {type: 'SET', path: path.concat(['bindAbilityUi']), value};
  }
  deleteBindAbilityUi(path) {
    return {type: 'DELETE', path: path.concat(['bindAbilityUi'])};
  }
  /**
   * @returns {Unit_HealthBarOption}
   */
  get healthBar() {
    return this._hasHealthBar ? this._healthBar : Unit_HealthBarOption.default;
  }
  get hasHealthBar() {
    return this._hasHealthBar;
  }
  setHealthBar(path, value) {
    return {type: 'SET', path: path.concat(['healthBar']), value: value.toJson()};
  }
  deleteHealthBar(path) {
    return {type: 'DELETE', path: path.concat(['healthBar'])};
  }
  /**
   * @returns {string[]}
   */
  get dependentUnits() {
    return this._dependentUnits;
  }
  addDependentUnits(path, value) {
    return {type: 'ADD', path: path.concat(['dependentUnits']), value};
  }
  setDependentUnits(path, value) {
    return {type: 'SET', path: path.concat(['dependentUnits']), value: ArrayToJson(value, JsonToString)};
  }
  setDependentUnitsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['dependentUnits', key]), value};
  }
  deleteDependentUnits(path) {
    return {type: 'DELETE', path: path.concat(['dependentUnits'])};
  }
  deleteDependentUnitsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['dependentUnits', key])};
  }
  /**
   * @returns {string[]}
   */
  get dependentEffects() {
    return this._dependentEffects;
  }
  addDependentEffects(path, value) {
    return {type: 'ADD', path: path.concat(['dependentEffects']), value};
  }
  setDependentEffects(path, value) {
    return {type: 'SET', path: path.concat(['dependentEffects']), value: ArrayToJson(value, JsonToString)};
  }
  setDependentEffectsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['dependentEffects', key]), value};
  }
  deleteDependentEffects(path) {
    return {type: 'DELETE', path: path.concat(['dependentEffects'])};
  }
  deleteDependentEffectsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['dependentEffects', key])};
  }
  /**
   * @returns {string[]}
   */
  get dependentBehaviors() {
    return this._dependentBehaviors;
  }
  addDependentBehaviors(path, value) {
    return {type: 'ADD', path: path.concat(['dependentBehaviors']), value};
  }
  setDependentBehaviors(path, value) {
    return {type: 'SET', path: path.concat(['dependentBehaviors']), value: ArrayToJson(value, JsonToString)};
  }
  setDependentBehaviorsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['dependentBehaviors', key]), value};
  }
  deleteDependentBehaviors(path) {
    return {type: 'DELETE', path: path.concat(['dependentBehaviors'])};
  }
  deleteDependentBehaviorsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['dependentBehaviors', key])};
  }
  /**
   * @returns {string[]}
   */
  get dependentSpriteAssets() {
    return this._dependentSpriteAssets;
  }
  addDependentSpriteAssets(path, value) {
    return {type: 'ADD', path: path.concat(['dependentSpriteAssets']), value};
  }
  setDependentSpriteAssets(path, value) {
    return {type: 'SET', path: path.concat(['dependentSpriteAssets']), value: ArrayToJson(value, JsonToString)};
  }
  setDependentSpriteAssetsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['dependentSpriteAssets', key]), value};
  }
  deleteDependentSpriteAssets(path) {
    return {type: 'DELETE', path: path.concat(['dependentSpriteAssets'])};
  }
  deleteDependentSpriteAssetsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['dependentSpriteAssets', key])};
  }
  /**
   * @returns {Unit_MiniMapConfig}
   */
  get miniMapConfig() {
    return this._hasMiniMapConfig ? this._miniMapConfig : Unit_MiniMapConfig.default;
  }
  get hasMiniMapConfig() {
    return this._hasMiniMapConfig;
  }
  setMiniMapConfig(path, value) {
    return {type: 'SET', path: path.concat(['miniMapConfig']), value: value.toJson()};
  }
  deleteMiniMapConfig(path) {
    return {type: 'DELETE', path: path.concat(['miniMapConfig'])};
  }
  /**
   * @returns {number}
   */
  get cardId() {
    return this._hasCardId ? this._cardId : JsonToInt32.default;
  }
  get hasCardId() {
    return this._hasCardId;
  }
  setCardId(path, value) {
    return {type: 'SET', path: path.concat(['cardId']), value};
  }
  deleteCardId(path) {
    return {type: 'DELETE', path: path.concat(['cardId'])};
  }
  /**
   * @returns {number}
   */
  get affinityIndex() {
    return this._hasAffinityIndex ? this._affinityIndex : JsonToInt32.default;
  }
  get hasAffinityIndex() {
    return this._hasAffinityIndex;
  }
  setAffinityIndex(path, value) {
    return {type: 'SET', path: path.concat(['affinityIndex']), value};
  }
  deleteAffinityIndex(path) {
    return {type: 'DELETE', path: path.concat(['affinityIndex'])};
  }
  /**
   * @returns {string}
   */
  get cardName() {
    return this._hasCardName ? this._cardName : JsonToString.default;
  }
  get hasCardName() {
    return this._hasCardName;
  }
  setCardName(path, value) {
    return {type: 'SET', path: path.concat(['cardName']), value};
  }
  deleteCardName(path) {
    return {type: 'DELETE', path: path.concat(['cardName'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "prefix": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._hasPrefix = true;
              copy._prefix = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrefix) {
                return this;
              }
              const copy = new Unit(this);
              copy._hasPrefix = false;
              copy._prefix = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "template": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._hasTemplate = true;
              copy._template = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTemplate) {
                return this;
              }
              const copy = new Unit(this);
              copy._hasTemplate = false;
              copy._template = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "comment": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._hasComment = true;
              copy._comment = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasComment) {
                return this;
              }
              const copy = new Unit(this);
              copy._hasComment = false;
              copy._comment = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "baseUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._hasParent = true;
              copy._baseUnit = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasParent) {
                return this;
              }
              const copy = new Unit(this);
              copy._hasParent = false;
              copy._baseUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "components": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._hasComponents = true;
              copy._components = UnitComponents.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasComponents) {
                return this;
              }
              const copy = new Unit(this);
              copy._hasComponents = false;
              copy._components = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasComponents) {
            const copy = new Unit(this);
            copy._hasComponents = true;
            copy._components = UnitComponents.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._components.apply(type, path.slice(1), value);
          if (newValue === this._components) {
            return this;
          }
          const copy = new Unit(this);
          copy._components = copy._components.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "references": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._hasReferences = true;
              copy._references = UnitReferences.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasReferences) {
                return this;
              }
              const copy = new Unit(this);
              copy._hasReferences = false;
              copy._references = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasReferences) {
            const copy = new Unit(this);
            copy._hasReferences = true;
            copy._references = UnitReferences.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._references.apply(type, path.slice(1), value);
          if (newValue === this._references) {
            return this;
          }
          const copy = new Unit(this);
          copy._references = copy._references.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "level": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._hasLevel = true;
              copy._level = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevel) {
                return this;
              }
              const copy = new Unit(this);
              copy._hasLevel = false;
              copy._level = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new Unit(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hideUnitStatusBar": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._hasHideUnitStatusBar = true;
              copy._hideUnitStatusBar = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHideUnitStatusBar) {
                return this;
              }
              const copy = new Unit(this);
              copy._hasHideUnitStatusBar = false;
              copy._hideUnitStatusBar = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ingameIcon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._hasIngameIcon = true;
              copy._ingameIcon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIngameIcon) {
                return this;
              }
              const copy = new Unit(this);
              copy._hasIngameIcon = false;
              copy._ingameIcon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "bindAbilityUi": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._hasBindAbilityUi = true;
              copy._bindAbilityUi = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBindAbilityUi) {
                return this;
              }
              const copy = new Unit(this);
              copy._hasBindAbilityUi = false;
              copy._bindAbilityUi = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "healthBar": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._hasHealthBar = true;
              copy._healthBar = Unit_HealthBarOption.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHealthBar) {
                return this;
              }
              const copy = new Unit(this);
              copy._hasHealthBar = false;
              copy._healthBar = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasHealthBar) {
            const copy = new Unit(this);
            copy._hasHealthBar = true;
            copy._healthBar = Unit_HealthBarOption.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._healthBar.apply(type, path.slice(1), value);
          if (newValue === this._healthBar) {
            return this;
          }
          const copy = new Unit(this);
          copy._healthBar = copy._healthBar.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "dependentUnits": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._dependentUnits = [];        for (let i of value) {
                copy._dependentUnits.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Unit(this);
              copy._dependentUnits = copy._dependentUnits.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._dependentUnits.length === 0) {
                return this;
              }
              const copy = new Unit(this);
              copy._dependentUnits = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._dependentUnits.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._dependentUnits = copy._dependentUnits.slice();
              copy._dependentUnits[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Unit(this);
              copy._dependentUnits = copy._dependentUnits.slice(0, path[1]).concat(copy._dependentUnits.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._dependentUnits.length) {
            return this;
          }
          const oldValue = this._dependentUnits[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Unit(this);
          copy._dependentUnits = copy._dependentUnits.slice();
          copy._dependentUnits[key] = newValue;
          return copy;
        }
      }
      case "dependentEffects": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._dependentEffects = [];        for (let i of value) {
                copy._dependentEffects.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Unit(this);
              copy._dependentEffects = copy._dependentEffects.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._dependentEffects.length === 0) {
                return this;
              }
              const copy = new Unit(this);
              copy._dependentEffects = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._dependentEffects.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._dependentEffects = copy._dependentEffects.slice();
              copy._dependentEffects[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Unit(this);
              copy._dependentEffects = copy._dependentEffects.slice(0, path[1]).concat(copy._dependentEffects.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._dependentEffects.length) {
            return this;
          }
          const oldValue = this._dependentEffects[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Unit(this);
          copy._dependentEffects = copy._dependentEffects.slice();
          copy._dependentEffects[key] = newValue;
          return copy;
        }
      }
      case "dependentBehaviors": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._dependentBehaviors = [];        for (let i of value) {
                copy._dependentBehaviors.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Unit(this);
              copy._dependentBehaviors = copy._dependentBehaviors.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._dependentBehaviors.length === 0) {
                return this;
              }
              const copy = new Unit(this);
              copy._dependentBehaviors = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._dependentBehaviors.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._dependentBehaviors = copy._dependentBehaviors.slice();
              copy._dependentBehaviors[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Unit(this);
              copy._dependentBehaviors = copy._dependentBehaviors.slice(0, path[1]).concat(copy._dependentBehaviors.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._dependentBehaviors.length) {
            return this;
          }
          const oldValue = this._dependentBehaviors[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Unit(this);
          copy._dependentBehaviors = copy._dependentBehaviors.slice();
          copy._dependentBehaviors[key] = newValue;
          return copy;
        }
      }
      case "dependentSpriteAssets": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._dependentSpriteAssets = [];        for (let i of value) {
                copy._dependentSpriteAssets.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Unit(this);
              copy._dependentSpriteAssets = copy._dependentSpriteAssets.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._dependentSpriteAssets.length === 0) {
                return this;
              }
              const copy = new Unit(this);
              copy._dependentSpriteAssets = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._dependentSpriteAssets.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._dependentSpriteAssets = copy._dependentSpriteAssets.slice();
              copy._dependentSpriteAssets[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Unit(this);
              copy._dependentSpriteAssets = copy._dependentSpriteAssets.slice(0, path[1]).concat(copy._dependentSpriteAssets.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._dependentSpriteAssets.length) {
            return this;
          }
          const oldValue = this._dependentSpriteAssets[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Unit(this);
          copy._dependentSpriteAssets = copy._dependentSpriteAssets.slice();
          copy._dependentSpriteAssets[key] = newValue;
          return copy;
        }
      }
      case "miniMapConfig": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._hasMiniMapConfig = true;
              copy._miniMapConfig = Unit_MiniMapConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMiniMapConfig) {
                return this;
              }
              const copy = new Unit(this);
              copy._hasMiniMapConfig = false;
              copy._miniMapConfig = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasMiniMapConfig) {
            const copy = new Unit(this);
            copy._hasMiniMapConfig = true;
            copy._miniMapConfig = Unit_MiniMapConfig.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._miniMapConfig.apply(type, path.slice(1), value);
          if (newValue === this._miniMapConfig) {
            return this;
          }
          const copy = new Unit(this);
          copy._miniMapConfig = copy._miniMapConfig.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "cardId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._hasCardId = true;
              copy._cardId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardId) {
                return this;
              }
              const copy = new Unit(this);
              copy._hasCardId = false;
              copy._cardId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "affinityIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._hasAffinityIndex = true;
              copy._affinityIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAffinityIndex) {
                return this;
              }
              const copy = new Unit(this);
              copy._hasAffinityIndex = false;
              copy._affinityIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cardName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Unit(this);
              copy._hasCardName = true;
              copy._cardName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardName) {
                return this;
              }
              const copy = new Unit(this);
              copy._hasCardName = false;
              copy._cardName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Unit} other
   * @returns {Unit}
   */
  merge(other) {
    const copy = new Unit(this);
    if (other._hasPrefix) {
      copy._hasPrefix = true;
      copy._prefix = other._prefix;
    }
    if (other._hasTemplate) {
      copy._hasTemplate = true;
      copy._template = other._template;
    }
    if (other._hasComment) {
      copy._hasComment = true;
      copy._comment = other._comment;
    }
    if (other._hasParent) {
      copy._hasParent = true;
      copy._baseUnit = other._baseUnit;
    }
    if (other._hasComponents) {
      if (copy._hasComponents) {
        copy._components = copy.components.merge(other.components);
      } else {
        copy._components = other._components;
      }
      copy._hasComponents = true;
    }
    if (other._hasReferences) {
      if (copy._hasReferences) {
        copy._references = copy.references.merge(other.references);
      } else {
        copy._references = other._references;
      }
      copy._hasReferences = true;
    }
    if (other._hasLevel) {
      copy._hasLevel = true;
      copy._level = other._level;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasHideUnitStatusBar) {
      copy._hasHideUnitStatusBar = true;
      copy._hideUnitStatusBar = other._hideUnitStatusBar;
    }
    if (other._hasIngameIcon) {
      copy._hasIngameIcon = true;
      copy._ingameIcon = other._ingameIcon;
    }
    if (other._hasBindAbilityUi) {
      copy._hasBindAbilityUi = true;
      copy._bindAbilityUi = other._bindAbilityUi;
    }
    if (other._hasHealthBar) {
      if (copy._hasHealthBar) {
        copy._healthBar = copy.healthBar.merge(other.healthBar);
      } else {
        copy._healthBar = other._healthBar;
      }
      copy._hasHealthBar = true;
    }
    copy._dependentUnits = this._dependentUnits.concat(other._dependentUnits);
    copy._dependentEffects = this._dependentEffects.concat(other._dependentEffects);
    copy._dependentBehaviors = this._dependentBehaviors.concat(other._dependentBehaviors);
    copy._dependentSpriteAssets = this._dependentSpriteAssets.concat(other._dependentSpriteAssets);
    if (other._hasMiniMapConfig) {
      if (copy._hasMiniMapConfig) {
        copy._miniMapConfig = copy.miniMapConfig.merge(other.miniMapConfig);
      } else {
        copy._miniMapConfig = other._miniMapConfig;
      }
      copy._hasMiniMapConfig = true;
    }
    if (other._hasCardId) {
      copy._hasCardId = true;
      copy._cardId = other._cardId;
    }
    if (other._hasAffinityIndex) {
      copy._hasAffinityIndex = true;
      copy._affinityIndex = other._affinityIndex;
    }
    if (other._hasCardName) {
      copy._hasCardName = true;
      copy._cardName = other._cardName;
    }
    return copy;
  }
}
Unit.default = new Unit();
Unit.HealthBarOption = Unit_HealthBarOption;
Unit.MiniMapConfig = Unit_MiniMapConfig;
class Unit_Builder {
  constructor(value) {
    this._value = new Unit(value);
  }
  build() {
    return new Unit(this._value);
  }
  setPrefix(value) {
    this._value._hasPrefix = true;
    this._value._prefix = value;
    return this;
  }
  deletePrefix() {
    this._value._hasPrefix = false;
    this._value._prefix = null;
    return this;
  }
  setTemplate(value) {
    this._value._hasTemplate = true;
    this._value._template = value;
    return this;
  }
  deleteTemplate() {
    this._value._hasTemplate = false;
    this._value._template = null;
    return this;
  }
  setComment(value) {
    this._value._hasComment = true;
    this._value._comment = value;
    return this;
  }
  deleteComment() {
    this._value._hasComment = false;
    this._value._comment = null;
    return this;
  }
  setParent(value) {
    this._value._hasParent = true;
    this._value._baseUnit = value;
    return this;
  }
  deleteParent() {
    this._value._hasParent = false;
    this._value._baseUnit = null;
    return this;
  }
  setComponents(value) {
    this._value._hasComponents = true;
    this._value._components = value;
    return this;
  }
  deleteComponents() {
    this._value._hasComponents = false;
    this._value._components = null;
    return this;
  }
  setReferences(value) {
    this._value._hasReferences = true;
    this._value._references = value;
    return this;
  }
  deleteReferences() {
    this._value._hasReferences = false;
    this._value._references = null;
    return this;
  }
  setLevel(value) {
    this._value._hasLevel = true;
    this._value._level = value;
    return this;
  }
  deleteLevel() {
    this._value._hasLevel = false;
    this._value._level = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setHideUnitStatusBar(value) {
    this._value._hasHideUnitStatusBar = true;
    this._value._hideUnitStatusBar = value;
    return this;
  }
  deleteHideUnitStatusBar() {
    this._value._hasHideUnitStatusBar = false;
    this._value._hideUnitStatusBar = null;
    return this;
  }
  setIngameIcon(value) {
    this._value._hasIngameIcon = true;
    this._value._ingameIcon = value;
    return this;
  }
  deleteIngameIcon() {
    this._value._hasIngameIcon = false;
    this._value._ingameIcon = null;
    return this;
  }
  setBindAbilityUi(value) {
    this._value._hasBindAbilityUi = true;
    this._value._bindAbilityUi = value;
    return this;
  }
  deleteBindAbilityUi() {
    this._value._hasBindAbilityUi = false;
    this._value._bindAbilityUi = null;
    return this;
  }
  setHealthBar(value) {
    this._value._hasHealthBar = true;
    this._value._healthBar = value;
    return this;
  }
  deleteHealthBar() {
    this._value._hasHealthBar = false;
    this._value._healthBar = null;
    return this;
  }
  addAllDependentUnits(values) {
    this._value._dependentUnits = this._value._dependentUnits.concat(values);
    return this;
  }
  addDependentUnits(value) {
    this._value._dependentUnits = this._value._dependentUnits.concat([value]);
    return this;
  }
  setDependentUnits(index, value) {
    this._value._dependentUnits = this._value._dependentUnits.concat();
    this._value._dependentUnits[index] = value;
    return this;
  }
  clearDependentUnits() {
    this._value._dependentUnits = [];
    return this;
  }
  addAllDependentEffects(values) {
    this._value._dependentEffects = this._value._dependentEffects.concat(values);
    return this;
  }
  addDependentEffects(value) {
    this._value._dependentEffects = this._value._dependentEffects.concat([value]);
    return this;
  }
  setDependentEffects(index, value) {
    this._value._dependentEffects = this._value._dependentEffects.concat();
    this._value._dependentEffects[index] = value;
    return this;
  }
  clearDependentEffects() {
    this._value._dependentEffects = [];
    return this;
  }
  addAllDependentBehaviors(values) {
    this._value._dependentBehaviors = this._value._dependentBehaviors.concat(values);
    return this;
  }
  addDependentBehaviors(value) {
    this._value._dependentBehaviors = this._value._dependentBehaviors.concat([value]);
    return this;
  }
  setDependentBehaviors(index, value) {
    this._value._dependentBehaviors = this._value._dependentBehaviors.concat();
    this._value._dependentBehaviors[index] = value;
    return this;
  }
  clearDependentBehaviors() {
    this._value._dependentBehaviors = [];
    return this;
  }
  addAllDependentSpriteAssets(values) {
    this._value._dependentSpriteAssets = this._value._dependentSpriteAssets.concat(values);
    return this;
  }
  addDependentSpriteAssets(value) {
    this._value._dependentSpriteAssets = this._value._dependentSpriteAssets.concat([value]);
    return this;
  }
  setDependentSpriteAssets(index, value) {
    this._value._dependentSpriteAssets = this._value._dependentSpriteAssets.concat();
    this._value._dependentSpriteAssets[index] = value;
    return this;
  }
  clearDependentSpriteAssets() {
    this._value._dependentSpriteAssets = [];
    return this;
  }
  setMiniMapConfig(value) {
    this._value._hasMiniMapConfig = true;
    this._value._miniMapConfig = value;
    return this;
  }
  deleteMiniMapConfig() {
    this._value._hasMiniMapConfig = false;
    this._value._miniMapConfig = null;
    return this;
  }
  setCardId(value) {
    this._value._hasCardId = true;
    this._value._cardId = value;
    return this;
  }
  deleteCardId() {
    this._value._hasCardId = false;
    this._value._cardId = null;
    return this;
  }
  setAffinityIndex(value) {
    this._value._hasAffinityIndex = true;
    this._value._affinityIndex = value;
    return this;
  }
  deleteAffinityIndex() {
    this._value._hasAffinityIndex = false;
    this._value._affinityIndex = null;
    return this;
  }
  setCardName(value) {
    this._value._hasCardName = true;
    this._value._cardName = value;
    return this;
  }
  deleteCardName() {
    this._value._hasCardName = false;
    this._value._cardName = null;
    return this;
  }
}
Unit.Builder = Unit_Builder;
class Unit_WithParent {
  /**
   * @param {Unit} value
   * @param {Unit_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Unit.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPrefix() {
    if (this._cachedHasPrefix === undefined) {
      if (this._value.hasPrefix) {
        this._cachedHasPrefix = true;
      } else {
        this._cachedHasPrefix = this._parent ? this._parent.hasPrefix : false;
      }
    }
    return this._cachedHasPrefix;
  }
  get prefix() {
    if (this._cachedPrefix === undefined) {
      if (this._value.hasPrefix) {
        this._cachedPrefix = this._value.prefix;
      } else {
        this._cachedPrefix = this._parent ? this._parent.prefix : this._value.prefix;
      }
    }
    return this._cachedPrefix;
  }
  get hasTemplate() {
    if (this._cachedHasTemplate === undefined) {
      if (this._value.hasTemplate) {
        this._cachedHasTemplate = true;
      } else {
        this._cachedHasTemplate = this._parent ? this._parent.hasTemplate : false;
      }
    }
    return this._cachedHasTemplate;
  }
  get template() {
    if (this._cachedTemplate === undefined) {
      if (this._value.hasTemplate) {
        this._cachedTemplate = this._value.template;
      } else {
        this._cachedTemplate = this._parent ? this._parent.template : this._value.template;
      }
    }
    return this._cachedTemplate;
  }
  get hasComment() {
    if (this._cachedHasComment === undefined) {
      if (this._value.hasComment) {
        this._cachedHasComment = true;
      } else {
        this._cachedHasComment = this._parent ? this._parent.hasComment : false;
      }
    }
    return this._cachedHasComment;
  }
  get comment() {
    if (this._cachedComment === undefined) {
      if (this._value.hasComment) {
        this._cachedComment = this._value.comment;
      } else {
        this._cachedComment = this._parent ? this._parent.comment : this._value.comment;
      }
    }
    return this._cachedComment;
  }
  get hasParent() {
    if (this._cachedHasParent === undefined) {
      if (this._value.hasParent) {
        this._cachedHasParent = true;
      } else {
        this._cachedHasParent = this._parent ? this._parent.hasParent : false;
      }
    }
    return this._cachedHasParent;
  }
  get baseUnit() {
    if (this._cachedParent === undefined) {
      if (this._value.hasParent) {
        this._cachedParent = this._value.baseUnit;
      } else {
        this._cachedParent = this._parent ? this._parent.baseUnit : this._value.baseUnit;
      }
    }
    return this._cachedParent;
  }
  get hasComponents() {
    if (this._cachedHasComponents === undefined) {
      if (this._value.hasComponents) {
        this._cachedHasComponents = true;
      } else {
        this._cachedHasComponents = this._parent ? this._parent.hasComponents : false;
      }
    }
    return this._cachedHasComponents;
  }
  get components() {
    if (!this._cachedComponents) {
      if (this._value.hasComponents) {
        this._cachedComponents = new UnitComponents.WithParent(this._value.components, this._parent && this._parent.hasComponents ? this._parent.components : null);
      } else {
        this._cachedComponents = this._parent ? new UnitComponents.WithParent(UnitComponents.default, this._parent.components) : UnitComponents.WithParent.default;
      }
    }
    return this._cachedComponents;
  }
  get hasReferences() {
    if (this._cachedHasReferences === undefined) {
      if (this._value.hasReferences) {
        this._cachedHasReferences = true;
      } else {
        this._cachedHasReferences = this._parent ? this._parent.hasReferences : false;
      }
    }
    return this._cachedHasReferences;
  }
  get references() {
    if (!this._cachedReferences) {
      if (this._value.hasReferences) {
        this._cachedReferences = new UnitReferences.WithParent(this._value.references, this._parent && this._parent.hasReferences ? this._parent.references : null);
      } else {
        this._cachedReferences = this._parent ? new UnitReferences.WithParent(UnitReferences.default, this._parent.references) : UnitReferences.WithParent.default;
      }
    }
    return this._cachedReferences;
  }
  get hasLevel() {
    if (this._cachedHasLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedHasLevel = true;
      } else {
        this._cachedHasLevel = this._parent ? this._parent.hasLevel : false;
      }
    }
    return this._cachedHasLevel;
  }
  get level() {
    if (this._cachedLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedLevel = this._value.level;
      } else {
        this._cachedLevel = this._parent ? this._parent.level : this._value.level;
      }
    }
    return this._cachedLevel;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasHideUnitStatusBar() {
    if (this._cachedHasHideUnitStatusBar === undefined) {
      if (this._value.hasHideUnitStatusBar) {
        this._cachedHasHideUnitStatusBar = true;
      } else {
        this._cachedHasHideUnitStatusBar = this._parent ? this._parent.hasHideUnitStatusBar : false;
      }
    }
    return this._cachedHasHideUnitStatusBar;
  }
  get hideUnitStatusBar() {
    if (this._cachedHideUnitStatusBar === undefined) {
      if (this._value.hasHideUnitStatusBar) {
        this._cachedHideUnitStatusBar = this._value.hideUnitStatusBar;
      } else {
        this._cachedHideUnitStatusBar = this._parent ? this._parent.hideUnitStatusBar : this._value.hideUnitStatusBar;
      }
    }
    return this._cachedHideUnitStatusBar;
  }
  get hasIngameIcon() {
    if (this._cachedHasIngameIcon === undefined) {
      if (this._value.hasIngameIcon) {
        this._cachedHasIngameIcon = true;
      } else {
        this._cachedHasIngameIcon = this._parent ? this._parent.hasIngameIcon : false;
      }
    }
    return this._cachedHasIngameIcon;
  }
  get ingameIcon() {
    if (this._cachedIngameIcon === undefined) {
      if (this._value.hasIngameIcon) {
        this._cachedIngameIcon = this._value.ingameIcon;
      } else {
        this._cachedIngameIcon = this._parent ? this._parent.ingameIcon : this._value.ingameIcon;
      }
    }
    return this._cachedIngameIcon;
  }
  get hasBindAbilityUi() {
    if (this._cachedHasBindAbilityUi === undefined) {
      if (this._value.hasBindAbilityUi) {
        this._cachedHasBindAbilityUi = true;
      } else {
        this._cachedHasBindAbilityUi = this._parent ? this._parent.hasBindAbilityUi : false;
      }
    }
    return this._cachedHasBindAbilityUi;
  }
  get bindAbilityUi() {
    if (this._cachedBindAbilityUi === undefined) {
      if (this._value.hasBindAbilityUi) {
        this._cachedBindAbilityUi = this._value.bindAbilityUi;
      } else {
        this._cachedBindAbilityUi = this._parent ? this._parent.bindAbilityUi : this._value.bindAbilityUi;
      }
    }
    return this._cachedBindAbilityUi;
  }
  get hasHealthBar() {
    if (this._cachedHasHealthBar === undefined) {
      if (this._value.hasHealthBar) {
        this._cachedHasHealthBar = true;
      } else {
        this._cachedHasHealthBar = this._parent ? this._parent.hasHealthBar : false;
      }
    }
    return this._cachedHasHealthBar;
  }
  get healthBar() {
    if (!this._cachedHealthBar) {
      if (this._value.hasHealthBar) {
        this._cachedHealthBar = new Unit_HealthBarOption.WithParent(this._value.healthBar, this._parent && this._parent.hasHealthBar ? this._parent.healthBar : null);
      } else {
        this._cachedHealthBar = this._parent ? new Unit_HealthBarOption.WithParent(Unit_HealthBarOption.default, this._parent.healthBar) : Unit_HealthBarOption.WithParent.default;
      }
    }
    return this._cachedHealthBar;
  }
  get selfDependentUnits() {
    return this._value.dependentUnits;
  }
  get inherentDependentUnits() {
    if (!this._inherentDependentUnits) {
      this._inherentDependentUnits = this._parent ? this._parent.dependentUnits : [];
    }
    return this._inherentDependentUnits;
  }
  get dependentUnits() {
    if (!this._allDependentUnits) {
      this._allDependentUnits = this._parent ? this._parent.dependentUnits.concat(this.selfDependentUnits) : this.selfDependentUnits;
    }
    return this._allDependentUnits;
  }
  get selfDependentEffects() {
    return this._value.dependentEffects;
  }
  get inherentDependentEffects() {
    if (!this._inherentDependentEffects) {
      this._inherentDependentEffects = this._parent ? this._parent.dependentEffects : [];
    }
    return this._inherentDependentEffects;
  }
  get dependentEffects() {
    if (!this._allDependentEffects) {
      this._allDependentEffects = this._parent ? this._parent.dependentEffects.concat(this.selfDependentEffects) : this.selfDependentEffects;
    }
    return this._allDependentEffects;
  }
  get selfDependentBehaviors() {
    return this._value.dependentBehaviors;
  }
  get inherentDependentBehaviors() {
    if (!this._inherentDependentBehaviors) {
      this._inherentDependentBehaviors = this._parent ? this._parent.dependentBehaviors : [];
    }
    return this._inherentDependentBehaviors;
  }
  get dependentBehaviors() {
    if (!this._allDependentBehaviors) {
      this._allDependentBehaviors = this._parent ? this._parent.dependentBehaviors.concat(this.selfDependentBehaviors) : this.selfDependentBehaviors;
    }
    return this._allDependentBehaviors;
  }
  get selfDependentSpriteAssets() {
    return this._value.dependentSpriteAssets;
  }
  get inherentDependentSpriteAssets() {
    if (!this._inherentDependentSpriteAssets) {
      this._inherentDependentSpriteAssets = this._parent ? this._parent.dependentSpriteAssets : [];
    }
    return this._inherentDependentSpriteAssets;
  }
  get dependentSpriteAssets() {
    if (!this._allDependentSpriteAssets) {
      this._allDependentSpriteAssets = this._parent ? this._parent.dependentSpriteAssets.concat(this.selfDependentSpriteAssets) : this.selfDependentSpriteAssets;
    }
    return this._allDependentSpriteAssets;
  }
  get hasMiniMapConfig() {
    if (this._cachedHasMiniMapConfig === undefined) {
      if (this._value.hasMiniMapConfig) {
        this._cachedHasMiniMapConfig = true;
      } else {
        this._cachedHasMiniMapConfig = this._parent ? this._parent.hasMiniMapConfig : false;
      }
    }
    return this._cachedHasMiniMapConfig;
  }
  get miniMapConfig() {
    if (!this._cachedMiniMapConfig) {
      if (this._value.hasMiniMapConfig) {
        this._cachedMiniMapConfig = new Unit_MiniMapConfig.WithParent(this._value.miniMapConfig, this._parent && this._parent.hasMiniMapConfig ? this._parent.miniMapConfig : null);
      } else {
        this._cachedMiniMapConfig = this._parent ? new Unit_MiniMapConfig.WithParent(Unit_MiniMapConfig.default, this._parent.miniMapConfig) : Unit_MiniMapConfig.WithParent.default;
      }
    }
    return this._cachedMiniMapConfig;
  }
  get hasCardId() {
    if (this._cachedHasCardId === undefined) {
      if (this._value.hasCardId) {
        this._cachedHasCardId = true;
      } else {
        this._cachedHasCardId = this._parent ? this._parent.hasCardId : false;
      }
    }
    return this._cachedHasCardId;
  }
  get cardId() {
    if (this._cachedCardId === undefined) {
      if (this._value.hasCardId) {
        this._cachedCardId = this._value.cardId;
      } else {
        this._cachedCardId = this._parent ? this._parent.cardId : this._value.cardId;
      }
    }
    return this._cachedCardId;
  }
  get hasAffinityIndex() {
    if (this._cachedHasAffinityIndex === undefined) {
      if (this._value.hasAffinityIndex) {
        this._cachedHasAffinityIndex = true;
      } else {
        this._cachedHasAffinityIndex = this._parent ? this._parent.hasAffinityIndex : false;
      }
    }
    return this._cachedHasAffinityIndex;
  }
  get affinityIndex() {
    if (this._cachedAffinityIndex === undefined) {
      if (this._value.hasAffinityIndex) {
        this._cachedAffinityIndex = this._value.affinityIndex;
      } else {
        this._cachedAffinityIndex = this._parent ? this._parent.affinityIndex : this._value.affinityIndex;
      }
    }
    return this._cachedAffinityIndex;
  }
  get hasCardName() {
    if (this._cachedHasCardName === undefined) {
      if (this._value.hasCardName) {
        this._cachedHasCardName = true;
      } else {
        this._cachedHasCardName = this._parent ? this._parent.hasCardName : false;
      }
    }
    return this._cachedHasCardName;
  }
  get cardName() {
    if (this._cachedCardName === undefined) {
      if (this._value.hasCardName) {
        this._cachedCardName = this._value.cardName;
      } else {
        this._cachedCardName = this._parent ? this._parent.cardName : this._value.cardName;
      }
    }
    return this._cachedCardName;
  }
  update(current, parent) {
    const result = new Unit_WithParent(current, parent);
    if (this._cachedComponents && this._value.hasComponents && current.hasComponents) {
      if (this._value.components === current.components && this._parent === parent) {
        result._cachedComponents = this._cachedComponents;
      } else {
        result._cachedComponents = this._cachedComponents.update(current.components, parent && parent.hasComponents ? parent.components : null);
      }
    }
    if (this._cachedReferences && this._value.hasReferences && current.hasReferences) {
      if (this._value.references === current.references && this._parent === parent) {
        result._cachedReferences = this._cachedReferences;
      } else {
        result._cachedReferences = this._cachedReferences.update(current.references, parent && parent.hasReferences ? parent.references : null);
      }
    }
    if (this._cachedHealthBar && this._value.hasHealthBar && current.hasHealthBar) {
      if (this._value.healthBar === current.healthBar && this._parent === parent) {
        result._cachedHealthBar = this._cachedHealthBar;
      } else {
        result._cachedHealthBar = this._cachedHealthBar.update(current.healthBar, parent && parent.hasHealthBar ? parent.healthBar : null);
      }
    }
    if (this._cachedMiniMapConfig && this._value.hasMiniMapConfig && current.hasMiniMapConfig) {
      if (this._value.miniMapConfig === current.miniMapConfig && this._parent === parent) {
        result._cachedMiniMapConfig = this._cachedMiniMapConfig;
      } else {
        result._cachedMiniMapConfig = this._cachedMiniMapConfig.update(current.miniMapConfig, parent && parent.hasMiniMapConfig ? parent.miniMapConfig : null);
      }
    }
    return result;
  }
}
Unit_WithParent.default = new Unit_WithParent(Unit.default, null);
Unit.WithParent = Unit_WithParent;
class Unit_Descriptor {
  get prefix() {
    if (!this._prefix) {
      this._prefix = {
        name: "prefix",
        Name: "Prefix",
        number: 1000,
        protoType: 9,
        protoName: "prefix",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._prefix;
  }
  get template() {
    if (!this._template) {
      this._template = {
        name: "template",
        Name: "Template",
        number: 2000,
        protoType: 8,
        protoName: "template",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._template;
  }
  get comment() {
    if (!this._comment) {
      this._comment = {
        name: "comment",
        Name: "Comment",
        number: 3000,
        protoType: 9,
        protoName: "comment",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._comment;
  }
  get baseUnit() {
    if (!this._baseUnit) {
      this._baseUnit = {
        name: "baseUnit",
        Name: "Parent",
        number: 1,
        protoType: 9,
        protoName: "parent",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedBaseUnitNamesWithNullWithTemplate",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._baseUnit;
  }
  get components() {
    if (!this._components) {
      this._components = {
        name: "components",
        Name: "Components",
        number: 2,
        protoType: 11,
        protoName: "components",
        type: UnitComponents,
        options: {
          flattenWiki: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._components;
  }
  get references() {
    if (!this._references) {
      this._references = {
        name: "references",
        Name: "References",
        number: 3,
        protoType: 11,
        protoName: "references",
        type: UnitReferences,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._references;
  }
  get level() {
    if (!this._level) {
      this._level = {
        name: "level",
        Name: "Level",
        number: 4,
        protoType: 5,
        protoName: "level",
        type: JsonToInt32,
        options: {
          comments: "A unit level reference that can be referenced in validator expressions. Current usage is limited.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._level;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 5,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get hideUnitStatusBar() {
    if (!this._hideUnitStatusBar) {
      this._hideUnitStatusBar = {
        name: "hideUnitStatusBar",
        Name: "HideUnitStatusBar",
        number: 6,
        protoType: 8,
        protoName: "hide_unit_status_bar",
        type: JsonToBoolean,
        options: {
          deprecated: {date: '2020-10-10', reason: 'Set health bar type to NONE instead.'},
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hideUnitStatusBar;
  }
  get ingameIcon() {
    if (!this._ingameIcon) {
      this._ingameIcon = {
        name: "ingameIcon",
        Name: "IngameIcon",
        number: 11,
        protoType: 9,
        protoName: "ingame_icon",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedInGameIcons",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ingameIcon;
  }
  get bindAbilityUi() {
    if (!this._bindAbilityUi) {
      this._bindAbilityUi = {
        name: "bindAbilityUi",
        Name: "BindAbilityUi",
        number: 12,
        protoType: 8,
        protoName: "bind_ability_ui",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bindAbilityUi;
  }
  get healthBar() {
    if (!this._healthBar) {
      this._healthBar = {
        name: "healthBar",
        Name: "HealthBar",
        number: 21,
        protoType: 11,
        protoName: "health_bar",
        type: Unit_HealthBarOption,
        options: {
          comments: "The type of health bar to display.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._healthBar;
  }
  get dependentUnits() {
    if (!this._dependentUnits) {
      this._dependentUnits = {
        name: "dependentUnits",
        Name: "DependentUnits",
        number: 31,
        protoType: 9,
        protoName: "dependent_units",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Dependent units will be loaded when the unit is loaded",
          valueDropdown: "SupportedBaseUnitNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dependentUnits;
  }
  get dependentEffects() {
    if (!this._dependentEffects) {
      this._dependentEffects = {
        name: "dependentEffects",
        Name: "DependentEffects",
        number: 32,
        protoType: 9,
        protoName: "dependent_effects",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Dependent effects will be loaded when the unit is loaded",
          valueDropdown: "SupportedEffectListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dependentEffects;
  }
  get dependentBehaviors() {
    if (!this._dependentBehaviors) {
      this._dependentBehaviors = {
        name: "dependentBehaviors",
        Name: "DependentBehaviors",
        number: 33,
        protoType: 9,
        protoName: "dependent_behaviors",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Dependent behaviors will be loaded when the unit is loaded",
          valueDropdown: "SupportedBehaviorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dependentBehaviors;
  }
  get dependentSpriteAssets() {
    if (!this._dependentSpriteAssets) {
      this._dependentSpriteAssets = {
        name: "dependentSpriteAssets",
        Name: "DependentSpriteAssets",
        number: 34,
        protoType: 9,
        protoName: "dependent_sprite_assets",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Dependent sprites will be loaded when this unit is loaded.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dependentSpriteAssets;
  }
  get miniMapConfig() {
    if (!this._miniMapConfig) {
      this._miniMapConfig = {
        name: "miniMapConfig",
        Name: "MiniMapConfig",
        number: 22,
        protoType: 11,
        protoName: "mini_map_config",
        type: Unit_MiniMapConfig,
        options: {
          comments: "These settings determine how the unit will be rendered on a minimap frame.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._miniMapConfig;
  }
  get cardId() {
    if (!this._cardId) {
      this._cardId = {
        name: "cardId",
        Name: "CardId",
        number: 101,
        protoType: 5,
        protoName: "card_id",
        type: JsonToInt32,
        options: {
          comments: "Which card this unit is associated with. Used by the engine only.",
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardId;
  }
  get affinityIndex() {
    if (!this._affinityIndex) {
      this._affinityIndex = {
        name: "affinityIndex",
        Name: "AffinityIndex",
        number: 102,
        protoType: 5,
        protoName: "affinity_index",
        type: JsonToInt32,
        options: {
          comments: "The affinity of this unit. Only set this field if: 1. this is a hero unit. 2. and this hero is used as a built-in hero (i.e., not added through a loadout hero card but available in the level automatically). The mapping: 1 => normal 2 => fire 3 => ice 4 => nature 5 => light 6 => dark",
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._affinityIndex;
  }
  get cardName() {
    if (!this._cardName) {
      this._cardName = {
        name: "cardName",
        Name: "CardName",
        number: 103,
        protoType: 9,
        protoName: "card_name",
        type: JsonToString,
        options: {
          comments: "Name of the card this unit is associated with. Used for reporting in-game stats. It\'s automatically set by the engine when loading card information. Only set it explicitly if the unit belongs to a card that hasn\'t been implemented yet and you want to gather stats for it.",
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardName;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.prefix,
        this.template,
        this.comment,
        this.baseUnit,
        this.components,
        this.references,
        this.level,
        this.displayName,
        this.hideUnitStatusBar,
        this.ingameIcon,
        this.bindAbilityUi,
        this.healthBar,
        this.dependentUnits,
        this.dependentEffects,
        this.dependentBehaviors,
        this.dependentSpriteAssets,
        this.miniMapConfig,
        this.cardId,
        this.affinityIndex,
        this.cardName,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPrefix",
        Name: "DummyOneofForPrefix",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTemplate",
        Name: "DummyOneofForTemplate",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForComment",
        Name: "DummyOneofForComment",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForParent",
        Name: "DummyOneofForParent",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForComponents",
        Name: "DummyOneofForComponents",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForReferences",
        Name: "DummyOneofForReferences",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevel",
        Name: "DummyOneofForLevel",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHideUnitStatusBar",
        Name: "DummyOneofForHideUnitStatusBar",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIngameIcon",
        Name: "DummyOneofForIngameIcon",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBindAbilityUi",
        Name: "DummyOneofForBindAbilityUi",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHealthBar",
        Name: "DummyOneofForHealthBar",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMiniMapConfig",
        Name: "DummyOneofForMiniMapConfig",
        fields: [
          this.fields[16],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardId",
        Name: "DummyOneofForCardId",
        fields: [
          this.fields[17],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAffinityIndex",
        Name: "DummyOneofForAffinityIndex",
        fields: [
          this.fields[18],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardName",
        Name: "DummyOneofForCardName",
        fields: [
          this.fields[19],
        ],
      });
    }
    return this._oneofs;
  }
}
Unit.descriptor = new Unit_Descriptor();
export class UnitComponents {
  get descriptor() {
    return UnitComponents.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
    this._hasUnitStats = false;
    this._unitStats = null;
    this._hasHealth = false;
    this._health = null;
    this._hasMana = false;
    this._mana = null;
    this._hasShield = false;
    this._shield = null;
    this._hasMovement = false;
    this._movement = null;
    this._hasTurning = false;
    this._turning = null;
    this._hasBehavior = false;
    this._behavior = null;
    this._hasUnitBattleData = false;
    this._unitBattleData = null;
    this._hasRallyPoint = false;
    this._rallyPoint = null;
    this._hasUnitValue = false;
    this._unitValue = null;
  }
  isEmpty() {
    if (this._hasUnit && !this._unit.isEmpty()) return false;
    if (this._hasUnitStats && !this._unitStats.isEmpty()) return false;
    if (this._hasHealth && !this._health.isEmpty()) return false;
    if (this._hasMana && !this._mana.isEmpty()) return false;
    if (this._hasShield && !this._shield.isEmpty()) return false;
    if (this._hasMovement && !this._movement.isEmpty()) return false;
    if (this._hasTurning && !this._turning.isEmpty()) return false;
    if (this._hasBehavior && !this._behavior.isEmpty()) return false;
    if (this._hasUnitBattleData && !this._unitBattleData.isEmpty()) return false;
    if (this._hasRallyPoint && !this._rallyPoint.isEmpty()) return false;
    if (this._hasUnitValue && !this._unitValue.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UnitComponents) {
      return value;
    }
    return UnitComponents.fromJson(value);
  }
  static fromJson(json) {
    const result = new UnitComponents();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = UnitComponent.fromJson(json.unit);
    }
    if (json.unitStats != null) {
      result._hasUnitStats = true;
      result._unitStats = UnitStatsComponent.fromJson(json.unitStats);
    }
    if (json.health != null) {
      result._hasHealth = true;
      result._health = HealthComponent.fromJson(json.health);
    }
    if (json.mana != null) {
      result._hasMana = true;
      result._mana = ManaComponent.fromJson(json.mana);
    }
    if (json.shield != null) {
      result._hasShield = true;
      result._shield = ShieldComponent.fromJson(json.shield);
    }
    if (json.movement != null) {
      result._hasMovement = true;
      result._movement = MovementComponent.fromJson(json.movement);
    }
    if (json.turning != null) {
      result._hasTurning = true;
      result._turning = UnitTurningComponent.fromJson(json.turning);
    }
    if (json.behavior != null) {
      result._hasBehavior = true;
      result._behavior = BehaviorComponent.fromJson(json.behavior);
    }
    if (json.unitBattleData != null) {
      result._hasUnitBattleData = true;
      result._unitBattleData = UnitBattleData.fromJson(json.unitBattleData);
    }
    if (json.rallyPoint != null) {
      result._hasRallyPoint = true;
      result._rallyPoint = RallyPointComponent.fromJson(json.rallyPoint);
    }
    if (json.unitValue != null) {
      result._hasUnitValue = true;
      result._unitValue = UnitValueComponent.fromJson(json.unitValue);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit && !this._unit.isEmpty()) {
      result.unit = UnitComponent.toJson(this._unit);
    }
    if (this._hasUnitStats && !this._unitStats.isEmpty()) {
      result.unitStats = UnitStatsComponent.toJson(this._unitStats);
    }
    if (this._hasHealth && !this._health.isEmpty()) {
      result.health = HealthComponent.toJson(this._health);
    }
    if (this._hasMana && !this._mana.isEmpty()) {
      result.mana = ManaComponent.toJson(this._mana);
    }
    if (this._hasShield && !this._shield.isEmpty()) {
      result.shield = ShieldComponent.toJson(this._shield);
    }
    if (this._hasMovement && !this._movement.isEmpty()) {
      result.movement = MovementComponent.toJson(this._movement);
    }
    if (this._hasTurning && !this._turning.isEmpty()) {
      result.turning = UnitTurningComponent.toJson(this._turning);
    }
    if (this._hasBehavior && !this._behavior.isEmpty()) {
      result.behavior = BehaviorComponent.toJson(this._behavior);
    }
    if (this._hasUnitBattleData && !this._unitBattleData.isEmpty()) {
      result.unitBattleData = UnitBattleData.toJson(this._unitBattleData);
    }
    if (this._hasRallyPoint && !this._rallyPoint.isEmpty()) {
      result.rallyPoint = RallyPointComponent.toJson(this._rallyPoint);
    }
    if (this._hasUnitValue && !this._unitValue.isEmpty()) {
      result.unitValue = UnitValueComponent.toJson(this._unitValue);
    }
    return result;
  }
  /**
   * @returns {UnitComponent}
   */
  get unit() {
    return this._hasUnit ? this._unit : UnitComponent.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value: value.toJson()};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  /**
   * @returns {UnitStatsComponent}
   */
  get unitStats() {
    return this._hasUnitStats ? this._unitStats : UnitStatsComponent.default;
  }
  get hasUnitStats() {
    return this._hasUnitStats;
  }
  setUnitStats(path, value) {
    return {type: 'SET', path: path.concat(['unitStats']), value: value.toJson()};
  }
  deleteUnitStats(path) {
    return {type: 'DELETE', path: path.concat(['unitStats'])};
  }
  /**
   * @returns {HealthComponent}
   */
  get health() {
    return this._hasHealth ? this._health : HealthComponent.default;
  }
  get hasHealth() {
    return this._hasHealth;
  }
  setHealth(path, value) {
    return {type: 'SET', path: path.concat(['health']), value: value.toJson()};
  }
  deleteHealth(path) {
    return {type: 'DELETE', path: path.concat(['health'])};
  }
  /**
   * @returns {ManaComponent}
   */
  get mana() {
    return this._hasMana ? this._mana : ManaComponent.default;
  }
  get hasMana() {
    return this._hasMana;
  }
  setMana(path, value) {
    return {type: 'SET', path: path.concat(['mana']), value: value.toJson()};
  }
  deleteMana(path) {
    return {type: 'DELETE', path: path.concat(['mana'])};
  }
  /**
   * @returns {ShieldComponent}
   */
  get shield() {
    return this._hasShield ? this._shield : ShieldComponent.default;
  }
  get hasShield() {
    return this._hasShield;
  }
  setShield(path, value) {
    return {type: 'SET', path: path.concat(['shield']), value: value.toJson()};
  }
  deleteShield(path) {
    return {type: 'DELETE', path: path.concat(['shield'])};
  }
  /**
   * @returns {MovementComponent}
   */
  get movement() {
    return this._hasMovement ? this._movement : MovementComponent.default;
  }
  get hasMovement() {
    return this._hasMovement;
  }
  setMovement(path, value) {
    return {type: 'SET', path: path.concat(['movement']), value: value.toJson()};
  }
  deleteMovement(path) {
    return {type: 'DELETE', path: path.concat(['movement'])};
  }
  /**
   * @returns {UnitTurningComponent}
   */
  get turning() {
    return this._hasTurning ? this._turning : UnitTurningComponent.default;
  }
  get hasTurning() {
    return this._hasTurning;
  }
  setTurning(path, value) {
    return {type: 'SET', path: path.concat(['turning']), value: value.toJson()};
  }
  deleteTurning(path) {
    return {type: 'DELETE', path: path.concat(['turning'])};
  }
  /**
   * @returns {BehaviorComponent}
   */
  get behavior() {
    return this._hasBehavior ? this._behavior : BehaviorComponent.default;
  }
  get hasBehavior() {
    return this._hasBehavior;
  }
  setBehavior(path, value) {
    return {type: 'SET', path: path.concat(['behavior']), value: value.toJson()};
  }
  deleteBehavior(path) {
    return {type: 'DELETE', path: path.concat(['behavior'])};
  }
  /**
   * @returns {UnitBattleData}
   */
  get unitBattleData() {
    return this._hasUnitBattleData ? this._unitBattleData : UnitBattleData.default;
  }
  get hasUnitBattleData() {
    return this._hasUnitBattleData;
  }
  setUnitBattleData(path, value) {
    return {type: 'SET', path: path.concat(['unitBattleData']), value: value.toJson()};
  }
  deleteUnitBattleData(path) {
    return {type: 'DELETE', path: path.concat(['unitBattleData'])};
  }
  /**
   * @returns {RallyPointComponent}
   */
  get rallyPoint() {
    return this._hasRallyPoint ? this._rallyPoint : RallyPointComponent.default;
  }
  get hasRallyPoint() {
    return this._hasRallyPoint;
  }
  setRallyPoint(path, value) {
    return {type: 'SET', path: path.concat(['rallyPoint']), value: value.toJson()};
  }
  deleteRallyPoint(path) {
    return {type: 'DELETE', path: path.concat(['rallyPoint'])};
  }
  /**
   * @returns {UnitValueComponent}
   */
  get unitValue() {
    return this._hasUnitValue ? this._unitValue : UnitValueComponent.default;
  }
  get hasUnitValue() {
    return this._hasUnitValue;
  }
  setUnitValue(path, value) {
    return {type: 'SET', path: path.concat(['unitValue']), value: value.toJson()};
  }
  deleteUnitValue(path) {
    return {type: 'DELETE', path: path.concat(['unitValue'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitComponents(this);
              copy._hasUnit = true;
              copy._unit = UnitComponent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new UnitComponents(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnit) {
            const copy = new UnitComponents(this);
            copy._hasUnit = true;
            copy._unit = UnitComponent.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unit.apply(type, path.slice(1), value);
          if (newValue === this._unit) {
            return this;
          }
          const copy = new UnitComponents(this);
          copy._unit = copy._unit.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "unitStats": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitComponents(this);
              copy._hasUnitStats = true;
              copy._unitStats = UnitStatsComponent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitStats) {
                return this;
              }
              const copy = new UnitComponents(this);
              copy._hasUnitStats = false;
              copy._unitStats = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitStats) {
            const copy = new UnitComponents(this);
            copy._hasUnitStats = true;
            copy._unitStats = UnitStatsComponent.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unitStats.apply(type, path.slice(1), value);
          if (newValue === this._unitStats) {
            return this;
          }
          const copy = new UnitComponents(this);
          copy._unitStats = copy._unitStats.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "health": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitComponents(this);
              copy._hasHealth = true;
              copy._health = HealthComponent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHealth) {
                return this;
              }
              const copy = new UnitComponents(this);
              copy._hasHealth = false;
              copy._health = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasHealth) {
            const copy = new UnitComponents(this);
            copy._hasHealth = true;
            copy._health = HealthComponent.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._health.apply(type, path.slice(1), value);
          if (newValue === this._health) {
            return this;
          }
          const copy = new UnitComponents(this);
          copy._health = copy._health.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "mana": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitComponents(this);
              copy._hasMana = true;
              copy._mana = ManaComponent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMana) {
                return this;
              }
              const copy = new UnitComponents(this);
              copy._hasMana = false;
              copy._mana = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasMana) {
            const copy = new UnitComponents(this);
            copy._hasMana = true;
            copy._mana = ManaComponent.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._mana.apply(type, path.slice(1), value);
          if (newValue === this._mana) {
            return this;
          }
          const copy = new UnitComponents(this);
          copy._mana = copy._mana.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "shield": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitComponents(this);
              copy._hasShield = true;
              copy._shield = ShieldComponent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShield) {
                return this;
              }
              const copy = new UnitComponents(this);
              copy._hasShield = false;
              copy._shield = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasShield) {
            const copy = new UnitComponents(this);
            copy._hasShield = true;
            copy._shield = ShieldComponent.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._shield.apply(type, path.slice(1), value);
          if (newValue === this._shield) {
            return this;
          }
          const copy = new UnitComponents(this);
          copy._shield = copy._shield.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "movement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitComponents(this);
              copy._hasMovement = true;
              copy._movement = MovementComponent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMovement) {
                return this;
              }
              const copy = new UnitComponents(this);
              copy._hasMovement = false;
              copy._movement = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasMovement) {
            const copy = new UnitComponents(this);
            copy._hasMovement = true;
            copy._movement = MovementComponent.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._movement.apply(type, path.slice(1), value);
          if (newValue === this._movement) {
            return this;
          }
          const copy = new UnitComponents(this);
          copy._movement = copy._movement.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "turning": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitComponents(this);
              copy._hasTurning = true;
              copy._turning = UnitTurningComponent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTurning) {
                return this;
              }
              const copy = new UnitComponents(this);
              copy._hasTurning = false;
              copy._turning = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTurning) {
            const copy = new UnitComponents(this);
            copy._hasTurning = true;
            copy._turning = UnitTurningComponent.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._turning.apply(type, path.slice(1), value);
          if (newValue === this._turning) {
            return this;
          }
          const copy = new UnitComponents(this);
          copy._turning = copy._turning.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "behavior": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitComponents(this);
              copy._hasBehavior = true;
              copy._behavior = BehaviorComponent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBehavior) {
                return this;
              }
              const copy = new UnitComponents(this);
              copy._hasBehavior = false;
              copy._behavior = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasBehavior) {
            const copy = new UnitComponents(this);
            copy._hasBehavior = true;
            copy._behavior = BehaviorComponent.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._behavior.apply(type, path.slice(1), value);
          if (newValue === this._behavior) {
            return this;
          }
          const copy = new UnitComponents(this);
          copy._behavior = copy._behavior.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "unitBattleData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitComponents(this);
              copy._hasUnitBattleData = true;
              copy._unitBattleData = UnitBattleData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitBattleData) {
                return this;
              }
              const copy = new UnitComponents(this);
              copy._hasUnitBattleData = false;
              copy._unitBattleData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitBattleData) {
            const copy = new UnitComponents(this);
            copy._hasUnitBattleData = true;
            copy._unitBattleData = UnitBattleData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unitBattleData.apply(type, path.slice(1), value);
          if (newValue === this._unitBattleData) {
            return this;
          }
          const copy = new UnitComponents(this);
          copy._unitBattleData = copy._unitBattleData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "rallyPoint": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitComponents(this);
              copy._hasRallyPoint = true;
              copy._rallyPoint = RallyPointComponent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRallyPoint) {
                return this;
              }
              const copy = new UnitComponents(this);
              copy._hasRallyPoint = false;
              copy._rallyPoint = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRallyPoint) {
            const copy = new UnitComponents(this);
            copy._hasRallyPoint = true;
            copy._rallyPoint = RallyPointComponent.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._rallyPoint.apply(type, path.slice(1), value);
          if (newValue === this._rallyPoint) {
            return this;
          }
          const copy = new UnitComponents(this);
          copy._rallyPoint = copy._rallyPoint.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "unitValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitComponents(this);
              copy._hasUnitValue = true;
              copy._unitValue = UnitValueComponent.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitValue) {
                return this;
              }
              const copy = new UnitComponents(this);
              copy._hasUnitValue = false;
              copy._unitValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitValue) {
            const copy = new UnitComponents(this);
            copy._hasUnitValue = true;
            copy._unitValue = UnitValueComponent.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unitValue.apply(type, path.slice(1), value);
          if (newValue === this._unitValue) {
            return this;
          }
          const copy = new UnitComponents(this);
          copy._unitValue = copy._unitValue.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UnitComponents} other
   * @returns {UnitComponents}
   */
  merge(other) {
    const copy = new UnitComponents(this);
    if (other._hasUnit) {
      if (copy._hasUnit) {
        copy._unit = copy.unit.merge(other.unit);
      } else {
        copy._unit = other._unit;
      }
      copy._hasUnit = true;
    }
    if (other._hasUnitStats) {
      if (copy._hasUnitStats) {
        copy._unitStats = copy.unitStats.merge(other.unitStats);
      } else {
        copy._unitStats = other._unitStats;
      }
      copy._hasUnitStats = true;
    }
    if (other._hasHealth) {
      if (copy._hasHealth) {
        copy._health = copy.health.merge(other.health);
      } else {
        copy._health = other._health;
      }
      copy._hasHealth = true;
    }
    if (other._hasMana) {
      if (copy._hasMana) {
        copy._mana = copy.mana.merge(other.mana);
      } else {
        copy._mana = other._mana;
      }
      copy._hasMana = true;
    }
    if (other._hasShield) {
      if (copy._hasShield) {
        copy._shield = copy.shield.merge(other.shield);
      } else {
        copy._shield = other._shield;
      }
      copy._hasShield = true;
    }
    if (other._hasMovement) {
      if (copy._hasMovement) {
        copy._movement = copy.movement.merge(other.movement);
      } else {
        copy._movement = other._movement;
      }
      copy._hasMovement = true;
    }
    if (other._hasTurning) {
      if (copy._hasTurning) {
        copy._turning = copy.turning.merge(other.turning);
      } else {
        copy._turning = other._turning;
      }
      copy._hasTurning = true;
    }
    if (other._hasBehavior) {
      if (copy._hasBehavior) {
        copy._behavior = copy.behavior.merge(other.behavior);
      } else {
        copy._behavior = other._behavior;
      }
      copy._hasBehavior = true;
    }
    if (other._hasUnitBattleData) {
      if (copy._hasUnitBattleData) {
        copy._unitBattleData = copy.unitBattleData.merge(other.unitBattleData);
      } else {
        copy._unitBattleData = other._unitBattleData;
      }
      copy._hasUnitBattleData = true;
    }
    if (other._hasRallyPoint) {
      if (copy._hasRallyPoint) {
        copy._rallyPoint = copy.rallyPoint.merge(other.rallyPoint);
      } else {
        copy._rallyPoint = other._rallyPoint;
      }
      copy._hasRallyPoint = true;
    }
    if (other._hasUnitValue) {
      if (copy._hasUnitValue) {
        copy._unitValue = copy.unitValue.merge(other.unitValue);
      } else {
        copy._unitValue = other._unitValue;
      }
      copy._hasUnitValue = true;
    }
    return copy;
  }
}
UnitComponents.default = new UnitComponents();
class UnitComponents_Builder {
  constructor(value) {
    this._value = new UnitComponents(value);
  }
  build() {
    return new UnitComponents(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
  setUnitStats(value) {
    this._value._hasUnitStats = true;
    this._value._unitStats = value;
    return this;
  }
  deleteUnitStats() {
    this._value._hasUnitStats = false;
    this._value._unitStats = null;
    return this;
  }
  setHealth(value) {
    this._value._hasHealth = true;
    this._value._health = value;
    return this;
  }
  deleteHealth() {
    this._value._hasHealth = false;
    this._value._health = null;
    return this;
  }
  setMana(value) {
    this._value._hasMana = true;
    this._value._mana = value;
    return this;
  }
  deleteMana() {
    this._value._hasMana = false;
    this._value._mana = null;
    return this;
  }
  setShield(value) {
    this._value._hasShield = true;
    this._value._shield = value;
    return this;
  }
  deleteShield() {
    this._value._hasShield = false;
    this._value._shield = null;
    return this;
  }
  setMovement(value) {
    this._value._hasMovement = true;
    this._value._movement = value;
    return this;
  }
  deleteMovement() {
    this._value._hasMovement = false;
    this._value._movement = null;
    return this;
  }
  setTurning(value) {
    this._value._hasTurning = true;
    this._value._turning = value;
    return this;
  }
  deleteTurning() {
    this._value._hasTurning = false;
    this._value._turning = null;
    return this;
  }
  setBehavior(value) {
    this._value._hasBehavior = true;
    this._value._behavior = value;
    return this;
  }
  deleteBehavior() {
    this._value._hasBehavior = false;
    this._value._behavior = null;
    return this;
  }
  setUnitBattleData(value) {
    this._value._hasUnitBattleData = true;
    this._value._unitBattleData = value;
    return this;
  }
  deleteUnitBattleData() {
    this._value._hasUnitBattleData = false;
    this._value._unitBattleData = null;
    return this;
  }
  setRallyPoint(value) {
    this._value._hasRallyPoint = true;
    this._value._rallyPoint = value;
    return this;
  }
  deleteRallyPoint() {
    this._value._hasRallyPoint = false;
    this._value._rallyPoint = null;
    return this;
  }
  setUnitValue(value) {
    this._value._hasUnitValue = true;
    this._value._unitValue = value;
    return this;
  }
  deleteUnitValue() {
    this._value._hasUnitValue = false;
    this._value._unitValue = null;
    return this;
  }
}
UnitComponents.Builder = UnitComponents_Builder;
class UnitComponents_WithParent {
  /**
   * @param {UnitComponents} value
   * @param {UnitComponents_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UnitComponents.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (!this._cachedUnit) {
      if (this._value.hasUnit) {
        this._cachedUnit = new UnitComponent.WithParent(this._value.unit, this._parent && this._parent.hasUnit ? this._parent.unit : null);
      } else {
        this._cachedUnit = this._parent ? new UnitComponent.WithParent(UnitComponent.default, this._parent.unit) : UnitComponent.WithParent.default;
      }
    }
    return this._cachedUnit;
  }
  get hasUnitStats() {
    if (this._cachedHasUnitStats === undefined) {
      if (this._value.hasUnitStats) {
        this._cachedHasUnitStats = true;
      } else {
        this._cachedHasUnitStats = this._parent ? this._parent.hasUnitStats : false;
      }
    }
    return this._cachedHasUnitStats;
  }
  get unitStats() {
    if (!this._cachedUnitStats) {
      if (this._value.hasUnitStats) {
        this._cachedUnitStats = new UnitStatsComponent.WithParent(this._value.unitStats, this._parent && this._parent.hasUnitStats ? this._parent.unitStats : null);
      } else {
        this._cachedUnitStats = this._parent ? new UnitStatsComponent.WithParent(UnitStatsComponent.default, this._parent.unitStats) : UnitStatsComponent.WithParent.default;
      }
    }
    return this._cachedUnitStats;
  }
  get hasHealth() {
    if (this._cachedHasHealth === undefined) {
      if (this._value.hasHealth) {
        this._cachedHasHealth = true;
      } else {
        this._cachedHasHealth = this._parent ? this._parent.hasHealth : false;
      }
    }
    return this._cachedHasHealth;
  }
  get health() {
    if (!this._cachedHealth) {
      if (this._value.hasHealth) {
        this._cachedHealth = new HealthComponent.WithParent(this._value.health, this._parent && this._parent.hasHealth ? this._parent.health : null);
      } else {
        this._cachedHealth = this._parent ? new HealthComponent.WithParent(HealthComponent.default, this._parent.health) : HealthComponent.WithParent.default;
      }
    }
    return this._cachedHealth;
  }
  get hasMana() {
    if (this._cachedHasMana === undefined) {
      if (this._value.hasMana) {
        this._cachedHasMana = true;
      } else {
        this._cachedHasMana = this._parent ? this._parent.hasMana : false;
      }
    }
    return this._cachedHasMana;
  }
  get mana() {
    if (!this._cachedMana) {
      if (this._value.hasMana) {
        this._cachedMana = new ManaComponent.WithParent(this._value.mana, this._parent && this._parent.hasMana ? this._parent.mana : null);
      } else {
        this._cachedMana = this._parent ? new ManaComponent.WithParent(ManaComponent.default, this._parent.mana) : ManaComponent.WithParent.default;
      }
    }
    return this._cachedMana;
  }
  get hasShield() {
    if (this._cachedHasShield === undefined) {
      if (this._value.hasShield) {
        this._cachedHasShield = true;
      } else {
        this._cachedHasShield = this._parent ? this._parent.hasShield : false;
      }
    }
    return this._cachedHasShield;
  }
  get shield() {
    if (!this._cachedShield) {
      if (this._value.hasShield) {
        this._cachedShield = new ShieldComponent.WithParent(this._value.shield, this._parent && this._parent.hasShield ? this._parent.shield : null);
      } else {
        this._cachedShield = this._parent ? new ShieldComponent.WithParent(ShieldComponent.default, this._parent.shield) : ShieldComponent.WithParent.default;
      }
    }
    return this._cachedShield;
  }
  get hasMovement() {
    if (this._cachedHasMovement === undefined) {
      if (this._value.hasMovement) {
        this._cachedHasMovement = true;
      } else {
        this._cachedHasMovement = this._parent ? this._parent.hasMovement : false;
      }
    }
    return this._cachedHasMovement;
  }
  get movement() {
    if (!this._cachedMovement) {
      if (this._value.hasMovement) {
        this._cachedMovement = new MovementComponent.WithParent(this._value.movement, this._parent && this._parent.hasMovement ? this._parent.movement : null);
      } else {
        this._cachedMovement = this._parent ? new MovementComponent.WithParent(MovementComponent.default, this._parent.movement) : MovementComponent.WithParent.default;
      }
    }
    return this._cachedMovement;
  }
  get hasTurning() {
    if (this._cachedHasTurning === undefined) {
      if (this._value.hasTurning) {
        this._cachedHasTurning = true;
      } else {
        this._cachedHasTurning = this._parent ? this._parent.hasTurning : false;
      }
    }
    return this._cachedHasTurning;
  }
  get turning() {
    if (!this._cachedTurning) {
      if (this._value.hasTurning) {
        this._cachedTurning = new UnitTurningComponent.WithParent(this._value.turning, this._parent && this._parent.hasTurning ? this._parent.turning : null);
      } else {
        this._cachedTurning = this._parent ? new UnitTurningComponent.WithParent(UnitTurningComponent.default, this._parent.turning) : UnitTurningComponent.WithParent.default;
      }
    }
    return this._cachedTurning;
  }
  get hasBehavior() {
    if (this._cachedHasBehavior === undefined) {
      if (this._value.hasBehavior) {
        this._cachedHasBehavior = true;
      } else {
        this._cachedHasBehavior = this._parent ? this._parent.hasBehavior : false;
      }
    }
    return this._cachedHasBehavior;
  }
  get behavior() {
    if (!this._cachedBehavior) {
      if (this._value.hasBehavior) {
        this._cachedBehavior = new BehaviorComponent.WithParent(this._value.behavior, this._parent && this._parent.hasBehavior ? this._parent.behavior : null);
      } else {
        this._cachedBehavior = this._parent ? new BehaviorComponent.WithParent(BehaviorComponent.default, this._parent.behavior) : BehaviorComponent.WithParent.default;
      }
    }
    return this._cachedBehavior;
  }
  get hasUnitBattleData() {
    if (this._cachedHasUnitBattleData === undefined) {
      if (this._value.hasUnitBattleData) {
        this._cachedHasUnitBattleData = true;
      } else {
        this._cachedHasUnitBattleData = this._parent ? this._parent.hasUnitBattleData : false;
      }
    }
    return this._cachedHasUnitBattleData;
  }
  get unitBattleData() {
    if (!this._cachedUnitBattleData) {
      if (this._value.hasUnitBattleData) {
        this._cachedUnitBattleData = new UnitBattleData.WithParent(this._value.unitBattleData, this._parent && this._parent.hasUnitBattleData ? this._parent.unitBattleData : null);
      } else {
        this._cachedUnitBattleData = this._parent ? new UnitBattleData.WithParent(UnitBattleData.default, this._parent.unitBattleData) : UnitBattleData.WithParent.default;
      }
    }
    return this._cachedUnitBattleData;
  }
  get hasRallyPoint() {
    if (this._cachedHasRallyPoint === undefined) {
      if (this._value.hasRallyPoint) {
        this._cachedHasRallyPoint = true;
      } else {
        this._cachedHasRallyPoint = this._parent ? this._parent.hasRallyPoint : false;
      }
    }
    return this._cachedHasRallyPoint;
  }
  get rallyPoint() {
    if (!this._cachedRallyPoint) {
      if (this._value.hasRallyPoint) {
        this._cachedRallyPoint = new RallyPointComponent.WithParent(this._value.rallyPoint, this._parent && this._parent.hasRallyPoint ? this._parent.rallyPoint : null);
      } else {
        this._cachedRallyPoint = this._parent ? new RallyPointComponent.WithParent(RallyPointComponent.default, this._parent.rallyPoint) : RallyPointComponent.WithParent.default;
      }
    }
    return this._cachedRallyPoint;
  }
  get hasUnitValue() {
    if (this._cachedHasUnitValue === undefined) {
      if (this._value.hasUnitValue) {
        this._cachedHasUnitValue = true;
      } else {
        this._cachedHasUnitValue = this._parent ? this._parent.hasUnitValue : false;
      }
    }
    return this._cachedHasUnitValue;
  }
  get unitValue() {
    if (!this._cachedUnitValue) {
      if (this._value.hasUnitValue) {
        this._cachedUnitValue = new UnitValueComponent.WithParent(this._value.unitValue, this._parent && this._parent.hasUnitValue ? this._parent.unitValue : null);
      } else {
        this._cachedUnitValue = this._parent ? new UnitValueComponent.WithParent(UnitValueComponent.default, this._parent.unitValue) : UnitValueComponent.WithParent.default;
      }
    }
    return this._cachedUnitValue;
  }
  update(current, parent) {
    const result = new UnitComponents_WithParent(current, parent);
    if (this._cachedUnit && this._value.hasUnit && current.hasUnit) {
      if (this._value.unit === current.unit && this._parent === parent) {
        result._cachedUnit = this._cachedUnit;
      } else {
        result._cachedUnit = this._cachedUnit.update(current.unit, parent && parent.hasUnit ? parent.unit : null);
      }
    }
    if (this._cachedUnitStats && this._value.hasUnitStats && current.hasUnitStats) {
      if (this._value.unitStats === current.unitStats && this._parent === parent) {
        result._cachedUnitStats = this._cachedUnitStats;
      } else {
        result._cachedUnitStats = this._cachedUnitStats.update(current.unitStats, parent && parent.hasUnitStats ? parent.unitStats : null);
      }
    }
    if (this._cachedHealth && this._value.hasHealth && current.hasHealth) {
      if (this._value.health === current.health && this._parent === parent) {
        result._cachedHealth = this._cachedHealth;
      } else {
        result._cachedHealth = this._cachedHealth.update(current.health, parent && parent.hasHealth ? parent.health : null);
      }
    }
    if (this._cachedMana && this._value.hasMana && current.hasMana) {
      if (this._value.mana === current.mana && this._parent === parent) {
        result._cachedMana = this._cachedMana;
      } else {
        result._cachedMana = this._cachedMana.update(current.mana, parent && parent.hasMana ? parent.mana : null);
      }
    }
    if (this._cachedShield && this._value.hasShield && current.hasShield) {
      if (this._value.shield === current.shield && this._parent === parent) {
        result._cachedShield = this._cachedShield;
      } else {
        result._cachedShield = this._cachedShield.update(current.shield, parent && parent.hasShield ? parent.shield : null);
      }
    }
    if (this._cachedMovement && this._value.hasMovement && current.hasMovement) {
      if (this._value.movement === current.movement && this._parent === parent) {
        result._cachedMovement = this._cachedMovement;
      } else {
        result._cachedMovement = this._cachedMovement.update(current.movement, parent && parent.hasMovement ? parent.movement : null);
      }
    }
    if (this._cachedTurning && this._value.hasTurning && current.hasTurning) {
      if (this._value.turning === current.turning && this._parent === parent) {
        result._cachedTurning = this._cachedTurning;
      } else {
        result._cachedTurning = this._cachedTurning.update(current.turning, parent && parent.hasTurning ? parent.turning : null);
      }
    }
    if (this._cachedBehavior && this._value.hasBehavior && current.hasBehavior) {
      if (this._value.behavior === current.behavior && this._parent === parent) {
        result._cachedBehavior = this._cachedBehavior;
      } else {
        result._cachedBehavior = this._cachedBehavior.update(current.behavior, parent && parent.hasBehavior ? parent.behavior : null);
      }
    }
    if (this._cachedUnitBattleData && this._value.hasUnitBattleData && current.hasUnitBattleData) {
      if (this._value.unitBattleData === current.unitBattleData && this._parent === parent) {
        result._cachedUnitBattleData = this._cachedUnitBattleData;
      } else {
        result._cachedUnitBattleData = this._cachedUnitBattleData.update(current.unitBattleData, parent && parent.hasUnitBattleData ? parent.unitBattleData : null);
      }
    }
    if (this._cachedRallyPoint && this._value.hasRallyPoint && current.hasRallyPoint) {
      if (this._value.rallyPoint === current.rallyPoint && this._parent === parent) {
        result._cachedRallyPoint = this._cachedRallyPoint;
      } else {
        result._cachedRallyPoint = this._cachedRallyPoint.update(current.rallyPoint, parent && parent.hasRallyPoint ? parent.rallyPoint : null);
      }
    }
    if (this._cachedUnitValue && this._value.hasUnitValue && current.hasUnitValue) {
      if (this._value.unitValue === current.unitValue && this._parent === parent) {
        result._cachedUnitValue = this._cachedUnitValue;
      } else {
        result._cachedUnitValue = this._cachedUnitValue.update(current.unitValue, parent && parent.hasUnitValue ? parent.unitValue : null);
      }
    }
    return result;
  }
}
UnitComponents_WithParent.default = new UnitComponents_WithParent(UnitComponents.default, null);
UnitComponents.WithParent = UnitComponents_WithParent;
class UnitComponents_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 11,
        protoName: "unit",
        type: UnitComponent,
        options: {
          flattenWiki: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get unitStats() {
    if (!this._unitStats) {
      this._unitStats = {
        name: "unitStats",
        Name: "UnitStats",
        number: 2,
        protoType: 11,
        protoName: "unit_stats",
        type: UnitStatsComponent,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitStats;
  }
  get health() {
    if (!this._health) {
      this._health = {
        name: "health",
        Name: "Health",
        number: 3,
        protoType: 11,
        protoName: "health",
        type: HealthComponent,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._health;
  }
  get mana() {
    if (!this._mana) {
      this._mana = {
        name: "mana",
        Name: "Mana",
        number: 4,
        protoType: 11,
        protoName: "mana",
        type: ManaComponent,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mana;
  }
  get shield() {
    if (!this._shield) {
      this._shield = {
        name: "shield",
        Name: "Shield",
        number: 5,
        protoType: 11,
        protoName: "shield",
        type: ShieldComponent,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shield;
  }
  get movement() {
    if (!this._movement) {
      this._movement = {
        name: "movement",
        Name: "Movement",
        number: 6,
        protoType: 11,
        protoName: "movement",
        type: MovementComponent,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._movement;
  }
  get turning() {
    if (!this._turning) {
      this._turning = {
        name: "turning",
        Name: "Turning",
        number: 7,
        protoType: 11,
        protoName: "turning",
        type: UnitTurningComponent,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._turning;
  }
  get behavior() {
    if (!this._behavior) {
      this._behavior = {
        name: "behavior",
        Name: "Behavior",
        number: 8,
        protoType: 11,
        protoName: "behavior",
        type: BehaviorComponent,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behavior;
  }
  get unitBattleData() {
    if (!this._unitBattleData) {
      this._unitBattleData = {
        name: "unitBattleData",
        Name: "UnitBattleData",
        number: 9,
        protoType: 11,
        protoName: "unit_battle_data",
        type: UnitBattleData,
        options: {
          deprecated: {date: '2020-11-5', reason: 'Use new behavior component instead.'},
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitBattleData;
  }
  get rallyPoint() {
    if (!this._rallyPoint) {
      this._rallyPoint = {
        name: "rallyPoint",
        Name: "RallyPoint",
        number: 10,
        protoType: 11,
        protoName: "rally_point",
        type: RallyPointComponent,
        options: {
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rallyPoint;
  }
  get unitValue() {
    if (!this._unitValue) {
      this._unitValue = {
        name: "unitValue",
        Name: "UnitValue",
        number: 11,
        protoType: 11,
        protoName: "unit_value",
        type: UnitValueComponent,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitValue;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
        this.unitStats,
        this.health,
        this.mana,
        this.shield,
        this.movement,
        this.turning,
        this.behavior,
        this.unitBattleData,
        this.rallyPoint,
        this.unitValue,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitStats",
        Name: "DummyOneofForUnitStats",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHealth",
        Name: "DummyOneofForHealth",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMana",
        Name: "DummyOneofForMana",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShield",
        Name: "DummyOneofForShield",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMovement",
        Name: "DummyOneofForMovement",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTurning",
        Name: "DummyOneofForTurning",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBehavior",
        Name: "DummyOneofForBehavior",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitBattleData",
        Name: "DummyOneofForUnitBattleData",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRallyPoint",
        Name: "DummyOneofForRallyPoint",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitValue",
        Name: "DummyOneofForUnitValue",
        fields: [
          this.fields[10],
        ],
      });
    }
    return this._oneofs;
  }
}
UnitComponents.descriptor = new UnitComponents_Descriptor();
export class UnitStatsComponent {
  get descriptor() {
    return UnitStatsComponent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasRadius = false;
    this._radius = null;
    this._hasInvulnerable = false;
    this._immortal = null;
    this._hasGround = false;
    this._ground = null;
    this._hasAir = false;
    this._air = null;
    this._hasSelectable = false;
    this._selectable = null;
    this._hasTargetPriority = false;
    this._targetPriority = null;
    this._hasSelectionPriority = false;
    this._selectionPriority = null;
    this._hasIgnoreUnitCollision = false;
    this._ignoreCollision = null;
    this._hasIgnorePathing = false;
    this._ignorePathing = null;
  }
  isEmpty() {
    if (this._hasRadius) return false;
    if (this._hasInvulnerable) return false;
    if (this._hasGround) return false;
    if (this._hasAir) return false;
    if (this._hasSelectable) return false;
    if (this._hasTargetPriority) return false;
    if (this._hasSelectionPriority) return false;
    if (this._hasIgnoreUnitCollision) return false;
    if (this._hasIgnorePathing) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UnitStatsComponent) {
      return value;
    }
    return UnitStatsComponent.fromJson(value);
  }
  static fromJson(json) {
    const result = new UnitStatsComponent();
    if (json.radius != null) {
      result._hasRadius = true;
      result._radius = JsonToDouble.fromJson(json.radius);
    }
    if (json.immortal != null) {
      result._hasInvulnerable = true;
      result._immortal = JsonToBoolean.fromJson(json.immortal);
    }
    if (json.ground != null) {
      result._hasGround = true;
      result._ground = JsonToBoolean.fromJson(json.ground);
    }
    if (json.air != null) {
      result._hasAir = true;
      result._air = JsonToBoolean.fromJson(json.air);
    }
    if (json.selectable != null) {
      result._hasSelectable = true;
      result._selectable = JsonToBoolean.fromJson(json.selectable);
    }
    if (json.targetPriority != null) {
      result._hasTargetPriority = true;
      result._targetPriority = JsonToInt32.fromJson(json.targetPriority);
    }
    if (json.selectionPriority != null) {
      result._hasSelectionPriority = true;
      result._selectionPriority = JsonToInt32.fromJson(json.selectionPriority);
    }
    if (json.ignoreCollision != null) {
      result._hasIgnoreUnitCollision = true;
      result._ignoreCollision = JsonToBoolean.fromJson(json.ignoreCollision);
    }
    if (json.ignorePathing != null) {
      result._hasIgnorePathing = true;
      result._ignorePathing = JsonToBoolean.fromJson(json.ignorePathing);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasRadius) {
      result.radius = JsonToDouble.toJson(this._radius);
    }
    if (this._hasInvulnerable) {
      result.immortal = JsonToBoolean.toJson(this._immortal);
    }
    if (this._hasGround) {
      result.ground = JsonToBoolean.toJson(this._ground);
    }
    if (this._hasAir) {
      result.air = JsonToBoolean.toJson(this._air);
    }
    if (this._hasSelectable) {
      result.selectable = JsonToBoolean.toJson(this._selectable);
    }
    if (this._hasTargetPriority) {
      result.targetPriority = JsonToInt32.toJson(this._targetPriority);
    }
    if (this._hasSelectionPriority) {
      result.selectionPriority = JsonToInt32.toJson(this._selectionPriority);
    }
    if (this._hasIgnoreUnitCollision) {
      result.ignoreCollision = JsonToBoolean.toJson(this._ignoreCollision);
    }
    if (this._hasIgnorePathing) {
      result.ignorePathing = JsonToBoolean.toJson(this._ignorePathing);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get radius() {
    return this._hasRadius ? this._radius : JsonToDouble.default;
  }
  get hasRadius() {
    return this._hasRadius;
  }
  setRadius(path, value) {
    return {type: 'SET', path: path.concat(['radius']), value};
  }
  deleteRadius(path) {
    return {type: 'DELETE', path: path.concat(['radius'])};
  }
  /**
   * @returns {boolean}
   */
  get immortal() {
    return this._hasInvulnerable ? this._immortal : JsonToBoolean.default;
  }
  get hasInvulnerable() {
    return this._hasInvulnerable;
  }
  setInvulnerable(path, value) {
    return {type: 'SET', path: path.concat(['immortal']), value};
  }
  deleteInvulnerable(path) {
    return {type: 'DELETE', path: path.concat(['immortal'])};
  }
  /**
   * @returns {boolean}
   */
  get ground() {
    return this._hasGround ? this._ground : JsonToBoolean.default;
  }
  get hasGround() {
    return this._hasGround;
  }
  setGround(path, value) {
    return {type: 'SET', path: path.concat(['ground']), value};
  }
  deleteGround(path) {
    return {type: 'DELETE', path: path.concat(['ground'])};
  }
  /**
   * @returns {boolean}
   */
  get air() {
    return this._hasAir ? this._air : JsonToBoolean.default;
  }
  get hasAir() {
    return this._hasAir;
  }
  setAir(path, value) {
    return {type: 'SET', path: path.concat(['air']), value};
  }
  deleteAir(path) {
    return {type: 'DELETE', path: path.concat(['air'])};
  }
  /**
   * @returns {boolean}
   */
  get selectable() {
    return this._hasSelectable ? this._selectable : JsonToBoolean.default;
  }
  get hasSelectable() {
    return this._hasSelectable;
  }
  setSelectable(path, value) {
    return {type: 'SET', path: path.concat(['selectable']), value};
  }
  deleteSelectable(path) {
    return {type: 'DELETE', path: path.concat(['selectable'])};
  }
  /**
   * @returns {number}
   */
  get targetPriority() {
    return this._hasTargetPriority ? this._targetPriority : JsonToInt32.default;
  }
  get hasTargetPriority() {
    return this._hasTargetPriority;
  }
  setTargetPriority(path, value) {
    return {type: 'SET', path: path.concat(['targetPriority']), value};
  }
  deleteTargetPriority(path) {
    return {type: 'DELETE', path: path.concat(['targetPriority'])};
  }
  /**
   * @returns {number}
   */
  get selectionPriority() {
    return this._hasSelectionPriority ? this._selectionPriority : JsonToInt32.default;
  }
  get hasSelectionPriority() {
    return this._hasSelectionPriority;
  }
  setSelectionPriority(path, value) {
    return {type: 'SET', path: path.concat(['selectionPriority']), value};
  }
  deleteSelectionPriority(path) {
    return {type: 'DELETE', path: path.concat(['selectionPriority'])};
  }
  /**
   * @returns {boolean}
   */
  get ignoreCollision() {
    return this._hasIgnoreUnitCollision ? this._ignoreCollision : JsonToBoolean.default;
  }
  get hasIgnoreUnitCollision() {
    return this._hasIgnoreUnitCollision;
  }
  setIgnoreUnitCollision(path, value) {
    return {type: 'SET', path: path.concat(['ignoreCollision']), value};
  }
  deleteIgnoreUnitCollision(path) {
    return {type: 'DELETE', path: path.concat(['ignoreCollision'])};
  }
  /**
   * @returns {boolean}
   */
  get ignorePathing() {
    return this._hasIgnorePathing ? this._ignorePathing : JsonToBoolean.default;
  }
  get hasIgnorePathing() {
    return this._hasIgnorePathing;
  }
  setIgnorePathing(path, value) {
    return {type: 'SET', path: path.concat(['ignorePathing']), value};
  }
  deleteIgnorePathing(path) {
    return {type: 'DELETE', path: path.concat(['ignorePathing'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "radius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitStatsComponent(this);
              copy._hasRadius = true;
              copy._radius = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRadius) {
                return this;
              }
              const copy = new UnitStatsComponent(this);
              copy._hasRadius = false;
              copy._radius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "immortal": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitStatsComponent(this);
              copy._hasInvulnerable = true;
              copy._immortal = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInvulnerable) {
                return this;
              }
              const copy = new UnitStatsComponent(this);
              copy._hasInvulnerable = false;
              copy._immortal = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ground": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitStatsComponent(this);
              copy._hasGround = true;
              copy._ground = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGround) {
                return this;
              }
              const copy = new UnitStatsComponent(this);
              copy._hasGround = false;
              copy._ground = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "air": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitStatsComponent(this);
              copy._hasAir = true;
              copy._air = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAir) {
                return this;
              }
              const copy = new UnitStatsComponent(this);
              copy._hasAir = false;
              copy._air = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "selectable": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitStatsComponent(this);
              copy._hasSelectable = true;
              copy._selectable = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSelectable) {
                return this;
              }
              const copy = new UnitStatsComponent(this);
              copy._hasSelectable = false;
              copy._selectable = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "targetPriority": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitStatsComponent(this);
              copy._hasTargetPriority = true;
              copy._targetPriority = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetPriority) {
                return this;
              }
              const copy = new UnitStatsComponent(this);
              copy._hasTargetPriority = false;
              copy._targetPriority = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "selectionPriority": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitStatsComponent(this);
              copy._hasSelectionPriority = true;
              copy._selectionPriority = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSelectionPriority) {
                return this;
              }
              const copy = new UnitStatsComponent(this);
              copy._hasSelectionPriority = false;
              copy._selectionPriority = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ignoreCollision": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitStatsComponent(this);
              copy._hasIgnoreUnitCollision = true;
              copy._ignoreCollision = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIgnoreUnitCollision) {
                return this;
              }
              const copy = new UnitStatsComponent(this);
              copy._hasIgnoreUnitCollision = false;
              copy._ignoreCollision = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ignorePathing": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitStatsComponent(this);
              copy._hasIgnorePathing = true;
              copy._ignorePathing = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIgnorePathing) {
                return this;
              }
              const copy = new UnitStatsComponent(this);
              copy._hasIgnorePathing = false;
              copy._ignorePathing = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UnitStatsComponent} other
   * @returns {UnitStatsComponent}
   */
  merge(other) {
    const copy = new UnitStatsComponent(this);
    if (other._hasRadius) {
      copy._hasRadius = true;
      copy._radius = other._radius;
    }
    if (other._hasInvulnerable) {
      copy._hasInvulnerable = true;
      copy._immortal = other._immortal;
    }
    if (other._hasGround) {
      copy._hasGround = true;
      copy._ground = other._ground;
    }
    if (other._hasAir) {
      copy._hasAir = true;
      copy._air = other._air;
    }
    if (other._hasSelectable) {
      copy._hasSelectable = true;
      copy._selectable = other._selectable;
    }
    if (other._hasTargetPriority) {
      copy._hasTargetPriority = true;
      copy._targetPriority = other._targetPriority;
    }
    if (other._hasSelectionPriority) {
      copy._hasSelectionPriority = true;
      copy._selectionPriority = other._selectionPriority;
    }
    if (other._hasIgnoreUnitCollision) {
      copy._hasIgnoreUnitCollision = true;
      copy._ignoreCollision = other._ignoreCollision;
    }
    if (other._hasIgnorePathing) {
      copy._hasIgnorePathing = true;
      copy._ignorePathing = other._ignorePathing;
    }
    return copy;
  }
}
UnitStatsComponent.default = new UnitStatsComponent();
class UnitStatsComponent_Builder {
  constructor(value) {
    this._value = new UnitStatsComponent(value);
  }
  build() {
    return new UnitStatsComponent(this._value);
  }
  setRadius(value) {
    this._value._hasRadius = true;
    this._value._radius = value;
    return this;
  }
  deleteRadius() {
    this._value._hasRadius = false;
    this._value._radius = null;
    return this;
  }
  setInvulnerable(value) {
    this._value._hasInvulnerable = true;
    this._value._immortal = value;
    return this;
  }
  deleteInvulnerable() {
    this._value._hasInvulnerable = false;
    this._value._immortal = null;
    return this;
  }
  setGround(value) {
    this._value._hasGround = true;
    this._value._ground = value;
    return this;
  }
  deleteGround() {
    this._value._hasGround = false;
    this._value._ground = null;
    return this;
  }
  setAir(value) {
    this._value._hasAir = true;
    this._value._air = value;
    return this;
  }
  deleteAir() {
    this._value._hasAir = false;
    this._value._air = null;
    return this;
  }
  setSelectable(value) {
    this._value._hasSelectable = true;
    this._value._selectable = value;
    return this;
  }
  deleteSelectable() {
    this._value._hasSelectable = false;
    this._value._selectable = null;
    return this;
  }
  setTargetPriority(value) {
    this._value._hasTargetPriority = true;
    this._value._targetPriority = value;
    return this;
  }
  deleteTargetPriority() {
    this._value._hasTargetPriority = false;
    this._value._targetPriority = null;
    return this;
  }
  setSelectionPriority(value) {
    this._value._hasSelectionPriority = true;
    this._value._selectionPriority = value;
    return this;
  }
  deleteSelectionPriority() {
    this._value._hasSelectionPriority = false;
    this._value._selectionPriority = null;
    return this;
  }
  setIgnoreUnitCollision(value) {
    this._value._hasIgnoreUnitCollision = true;
    this._value._ignoreCollision = value;
    return this;
  }
  deleteIgnoreUnitCollision() {
    this._value._hasIgnoreUnitCollision = false;
    this._value._ignoreCollision = null;
    return this;
  }
  setIgnorePathing(value) {
    this._value._hasIgnorePathing = true;
    this._value._ignorePathing = value;
    return this;
  }
  deleteIgnorePathing() {
    this._value._hasIgnorePathing = false;
    this._value._ignorePathing = null;
    return this;
  }
}
UnitStatsComponent.Builder = UnitStatsComponent_Builder;
class UnitStatsComponent_WithParent {
  /**
   * @param {UnitStatsComponent} value
   * @param {UnitStatsComponent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UnitStatsComponent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasRadius() {
    if (this._cachedHasRadius === undefined) {
      if (this._value.hasRadius) {
        this._cachedHasRadius = true;
      } else {
        this._cachedHasRadius = this._parent ? this._parent.hasRadius : false;
      }
    }
    return this._cachedHasRadius;
  }
  get radius() {
    if (this._cachedRadius === undefined) {
      if (this._value.hasRadius) {
        this._cachedRadius = this._value.radius;
      } else {
        this._cachedRadius = this._parent ? this._parent.radius : this._value.radius;
      }
    }
    return this._cachedRadius;
  }
  get hasInvulnerable() {
    if (this._cachedHasInvulnerable === undefined) {
      if (this._value.hasInvulnerable) {
        this._cachedHasInvulnerable = true;
      } else {
        this._cachedHasInvulnerable = this._parent ? this._parent.hasInvulnerable : false;
      }
    }
    return this._cachedHasInvulnerable;
  }
  get immortal() {
    if (this._cachedInvulnerable === undefined) {
      if (this._value.hasInvulnerable) {
        this._cachedInvulnerable = this._value.immortal;
      } else {
        this._cachedInvulnerable = this._parent ? this._parent.immortal : this._value.immortal;
      }
    }
    return this._cachedInvulnerable;
  }
  get hasGround() {
    if (this._cachedHasGround === undefined) {
      if (this._value.hasGround) {
        this._cachedHasGround = true;
      } else {
        this._cachedHasGround = this._parent ? this._parent.hasGround : false;
      }
    }
    return this._cachedHasGround;
  }
  get ground() {
    if (this._cachedGround === undefined) {
      if (this._value.hasGround) {
        this._cachedGround = this._value.ground;
      } else {
        this._cachedGround = this._parent ? this._parent.ground : this._value.ground;
      }
    }
    return this._cachedGround;
  }
  get hasAir() {
    if (this._cachedHasAir === undefined) {
      if (this._value.hasAir) {
        this._cachedHasAir = true;
      } else {
        this._cachedHasAir = this._parent ? this._parent.hasAir : false;
      }
    }
    return this._cachedHasAir;
  }
  get air() {
    if (this._cachedAir === undefined) {
      if (this._value.hasAir) {
        this._cachedAir = this._value.air;
      } else {
        this._cachedAir = this._parent ? this._parent.air : this._value.air;
      }
    }
    return this._cachedAir;
  }
  get hasSelectable() {
    if (this._cachedHasSelectable === undefined) {
      if (this._value.hasSelectable) {
        this._cachedHasSelectable = true;
      } else {
        this._cachedHasSelectable = this._parent ? this._parent.hasSelectable : false;
      }
    }
    return this._cachedHasSelectable;
  }
  get selectable() {
    if (this._cachedSelectable === undefined) {
      if (this._value.hasSelectable) {
        this._cachedSelectable = this._value.selectable;
      } else {
        this._cachedSelectable = this._parent ? this._parent.selectable : this._value.selectable;
      }
    }
    return this._cachedSelectable;
  }
  get hasTargetPriority() {
    if (this._cachedHasTargetPriority === undefined) {
      if (this._value.hasTargetPriority) {
        this._cachedHasTargetPriority = true;
      } else {
        this._cachedHasTargetPriority = this._parent ? this._parent.hasTargetPriority : false;
      }
    }
    return this._cachedHasTargetPriority;
  }
  get targetPriority() {
    if (this._cachedTargetPriority === undefined) {
      if (this._value.hasTargetPriority) {
        this._cachedTargetPriority = this._value.targetPriority;
      } else {
        this._cachedTargetPriority = this._parent ? this._parent.targetPriority : this._value.targetPriority;
      }
    }
    return this._cachedTargetPriority;
  }
  get hasSelectionPriority() {
    if (this._cachedHasSelectionPriority === undefined) {
      if (this._value.hasSelectionPriority) {
        this._cachedHasSelectionPriority = true;
      } else {
        this._cachedHasSelectionPriority = this._parent ? this._parent.hasSelectionPriority : false;
      }
    }
    return this._cachedHasSelectionPriority;
  }
  get selectionPriority() {
    if (this._cachedSelectionPriority === undefined) {
      if (this._value.hasSelectionPriority) {
        this._cachedSelectionPriority = this._value.selectionPriority;
      } else {
        this._cachedSelectionPriority = this._parent ? this._parent.selectionPriority : this._value.selectionPriority;
      }
    }
    return this._cachedSelectionPriority;
  }
  get hasIgnoreUnitCollision() {
    if (this._cachedHasIgnoreUnitCollision === undefined) {
      if (this._value.hasIgnoreUnitCollision) {
        this._cachedHasIgnoreUnitCollision = true;
      } else {
        this._cachedHasIgnoreUnitCollision = this._parent ? this._parent.hasIgnoreUnitCollision : false;
      }
    }
    return this._cachedHasIgnoreUnitCollision;
  }
  get ignoreCollision() {
    if (this._cachedIgnoreUnitCollision === undefined) {
      if (this._value.hasIgnoreUnitCollision) {
        this._cachedIgnoreUnitCollision = this._value.ignoreCollision;
      } else {
        this._cachedIgnoreUnitCollision = this._parent ? this._parent.ignoreCollision : this._value.ignoreCollision;
      }
    }
    return this._cachedIgnoreUnitCollision;
  }
  get hasIgnorePathing() {
    if (this._cachedHasIgnorePathing === undefined) {
      if (this._value.hasIgnorePathing) {
        this._cachedHasIgnorePathing = true;
      } else {
        this._cachedHasIgnorePathing = this._parent ? this._parent.hasIgnorePathing : false;
      }
    }
    return this._cachedHasIgnorePathing;
  }
  get ignorePathing() {
    if (this._cachedIgnorePathing === undefined) {
      if (this._value.hasIgnorePathing) {
        this._cachedIgnorePathing = this._value.ignorePathing;
      } else {
        this._cachedIgnorePathing = this._parent ? this._parent.ignorePathing : this._value.ignorePathing;
      }
    }
    return this._cachedIgnorePathing;
  }
  update(current, parent) {
    const result = new UnitStatsComponent_WithParent(current, parent);
    return result;
  }
}
UnitStatsComponent_WithParent.default = new UnitStatsComponent_WithParent(UnitStatsComponent.default, null);
UnitStatsComponent.WithParent = UnitStatsComponent_WithParent;
class UnitStatsComponent_Descriptor {
  get radius() {
    if (!this._radius) {
      this._radius = {
        name: "radius",
        Name: "Radius",
        number: 1,
        protoType: 1,
        protoName: "radius",
        type: JsonToDouble,
        options: {
          comments: "Determines the collision size of the unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._radius;
  }
  get immortal() {
    if (!this._immortal) {
      this._immortal = {
        name: "immortal",
        Name: "Invulnerable",
        number: 2,
        protoType: 8,
        protoName: "invulnerable",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._immortal;
  }
  get ground() {
    if (!this._ground) {
      this._ground = {
        name: "ground",
        Name: "Ground",
        number: 3,
        protoType: 8,
        protoName: "ground",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ground;
  }
  get air() {
    if (!this._air) {
      this._air = {
        name: "air",
        Name: "Air",
        number: 4,
        protoType: 8,
        protoName: "air",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._air;
  }
  get selectable() {
    if (!this._selectable) {
      this._selectable = {
        name: "selectable",
        Name: "Selectable",
        number: 5,
        protoType: 8,
        protoName: "selectable",
        type: JsonToBoolean,
        options: {
          comments: "Determines whether or not the unit can be selected.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._selectable;
  }
  get targetPriority() {
    if (!this._targetPriority) {
      this._targetPriority = {
        name: "targetPriority",
        Name: "TargetPriority",
        number: 6,
        protoType: 5,
        protoName: "target_priority",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetPriority;
  }
  get selectionPriority() {
    if (!this._selectionPriority) {
      this._selectionPriority = {
        name: "selectionPriority",
        Name: "SelectionPriority",
        number: 7,
        protoType: 5,
        protoName: "selection_priority",
        type: JsonToInt32,
        options: {
          comments: "Determines the unit selection priority when multiple units are overlapping. Higher priority units will be selected over lower priority units.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._selectionPriority;
  }
  get ignoreCollision() {
    if (!this._ignoreCollision) {
      this._ignoreCollision = {
        name: "ignoreCollision",
        Name: "IgnoreUnitCollision",
        number: 8,
        protoType: 8,
        protoName: "ignore_unit_collision",
        type: JsonToBoolean,
        options: {
          comments: "When checked, the unit will ignore collision with other units. Note that this does not affect navigation mesh pathfinding (ie collision with props).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ignoreCollision;
  }
  get ignorePathing() {
    if (!this._ignorePathing) {
      this._ignorePathing = {
        name: "ignorePathing",
        Name: "IgnorePathing",
        number: 9,
        protoType: 8,
        protoName: "ignore_pathing",
        type: JsonToBoolean,
        options: {
          comments: "When checked, the unit will ignore navigation mesh and move in a direct line to its target position.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ignorePathing;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.radius,
        this.immortal,
        this.ground,
        this.air,
        this.selectable,
        this.targetPriority,
        this.selectionPriority,
        this.ignoreCollision,
        this.ignorePathing,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForRadius",
        Name: "DummyOneofForRadius",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForInvulnerable",
        Name: "DummyOneofForInvulnerable",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGround",
        Name: "DummyOneofForGround",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAir",
        Name: "DummyOneofForAir",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSelectable",
        Name: "DummyOneofForSelectable",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTargetPriority",
        Name: "DummyOneofForTargetPriority",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSelectionPriority",
        Name: "DummyOneofForSelectionPriority",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIgnoreUnitCollision",
        Name: "DummyOneofForIgnoreUnitCollision",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIgnorePathing",
        Name: "DummyOneofForIgnorePathing",
        fields: [
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
UnitStatsComponent.descriptor = new UnitStatsComponent_Descriptor();
export class UnitValueComponent {
  get descriptor() {
    return UnitValueComponent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasGoldCost = false;
    this._goldCost = null;
  }
  isEmpty() {
    if (this._hasGoldCost) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UnitValueComponent) {
      return value;
    }
    return UnitValueComponent.fromJson(value);
  }
  static fromJson(json) {
    const result = new UnitValueComponent();
    if (json.goldCost != null) {
      result._hasGoldCost = true;
      result._goldCost = JsonToInt32.fromJson(json.goldCost);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasGoldCost) {
      result.goldCost = JsonToInt32.toJson(this._goldCost);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get goldCost() {
    return this._hasGoldCost ? this._goldCost : JsonToInt32.default;
  }
  get hasGoldCost() {
    return this._hasGoldCost;
  }
  setGoldCost(path, value) {
    return {type: 'SET', path: path.concat(['goldCost']), value};
  }
  deleteGoldCost(path) {
    return {type: 'DELETE', path: path.concat(['goldCost'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "goldCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitValueComponent(this);
              copy._hasGoldCost = true;
              copy._goldCost = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGoldCost) {
                return this;
              }
              const copy = new UnitValueComponent(this);
              copy._hasGoldCost = false;
              copy._goldCost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UnitValueComponent} other
   * @returns {UnitValueComponent}
   */
  merge(other) {
    const copy = new UnitValueComponent(this);
    if (other._hasGoldCost) {
      copy._hasGoldCost = true;
      copy._goldCost = other._goldCost;
    }
    return copy;
  }
}
UnitValueComponent.default = new UnitValueComponent();
class UnitValueComponent_Builder {
  constructor(value) {
    this._value = new UnitValueComponent(value);
  }
  build() {
    return new UnitValueComponent(this._value);
  }
  setGoldCost(value) {
    this._value._hasGoldCost = true;
    this._value._goldCost = value;
    return this;
  }
  deleteGoldCost() {
    this._value._hasGoldCost = false;
    this._value._goldCost = null;
    return this;
  }
}
UnitValueComponent.Builder = UnitValueComponent_Builder;
class UnitValueComponent_WithParent {
  /**
   * @param {UnitValueComponent} value
   * @param {UnitValueComponent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UnitValueComponent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasGoldCost() {
    if (this._cachedHasGoldCost === undefined) {
      if (this._value.hasGoldCost) {
        this._cachedHasGoldCost = true;
      } else {
        this._cachedHasGoldCost = this._parent ? this._parent.hasGoldCost : false;
      }
    }
    return this._cachedHasGoldCost;
  }
  get goldCost() {
    if (this._cachedGoldCost === undefined) {
      if (this._value.hasGoldCost) {
        this._cachedGoldCost = this._value.goldCost;
      } else {
        this._cachedGoldCost = this._parent ? this._parent.goldCost : this._value.goldCost;
      }
    }
    return this._cachedGoldCost;
  }
  update(current, parent) {
    const result = new UnitValueComponent_WithParent(current, parent);
    return result;
  }
}
UnitValueComponent_WithParent.default = new UnitValueComponent_WithParent(UnitValueComponent.default, null);
UnitValueComponent.WithParent = UnitValueComponent_WithParent;
class UnitValueComponent_Descriptor {
  get goldCost() {
    if (!this._goldCost) {
      this._goldCost = {
        name: "goldCost",
        Name: "GoldCost",
        number: 1,
        protoType: 5,
        protoName: "gold_cost",
        type: JsonToInt32,
        options: {
          comments: "The base gold cost of the unit.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._goldCost;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.goldCost,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForGoldCost",
        Name: "DummyOneofForGoldCost",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
UnitValueComponent.descriptor = new UnitValueComponent_Descriptor();
export class UnitTurningComponent {
  get descriptor() {
    return UnitTurningComponent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTurningSpeed = false;
    this._turningSpeed = null;
  }
  isEmpty() {
    if (this._hasTurningSpeed) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UnitTurningComponent) {
      return value;
    }
    return UnitTurningComponent.fromJson(value);
  }
  static fromJson(json) {
    const result = new UnitTurningComponent();
    if (json.turningSpeed != null) {
      result._hasTurningSpeed = true;
      result._turningSpeed = JsonToDouble.fromJson(json.turningSpeed);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTurningSpeed) {
      result.turningSpeed = JsonToDouble.toJson(this._turningSpeed);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get turningSpeed() {
    return this._hasTurningSpeed ? this._turningSpeed : JsonToDouble.default;
  }
  get hasTurningSpeed() {
    return this._hasTurningSpeed;
  }
  setTurningSpeed(path, value) {
    return {type: 'SET', path: path.concat(['turningSpeed']), value};
  }
  deleteTurningSpeed(path) {
    return {type: 'DELETE', path: path.concat(['turningSpeed'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "turningSpeed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitTurningComponent(this);
              copy._hasTurningSpeed = true;
              copy._turningSpeed = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTurningSpeed) {
                return this;
              }
              const copy = new UnitTurningComponent(this);
              copy._hasTurningSpeed = false;
              copy._turningSpeed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UnitTurningComponent} other
   * @returns {UnitTurningComponent}
   */
  merge(other) {
    const copy = new UnitTurningComponent(this);
    if (other._hasTurningSpeed) {
      copy._hasTurningSpeed = true;
      copy._turningSpeed = other._turningSpeed;
    }
    return copy;
  }
}
UnitTurningComponent.default = new UnitTurningComponent();
class UnitTurningComponent_Builder {
  constructor(value) {
    this._value = new UnitTurningComponent(value);
  }
  build() {
    return new UnitTurningComponent(this._value);
  }
  setTurningSpeed(value) {
    this._value._hasTurningSpeed = true;
    this._value._turningSpeed = value;
    return this;
  }
  deleteTurningSpeed() {
    this._value._hasTurningSpeed = false;
    this._value._turningSpeed = null;
    return this;
  }
}
UnitTurningComponent.Builder = UnitTurningComponent_Builder;
class UnitTurningComponent_WithParent {
  /**
   * @param {UnitTurningComponent} value
   * @param {UnitTurningComponent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UnitTurningComponent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTurningSpeed() {
    if (this._cachedHasTurningSpeed === undefined) {
      if (this._value.hasTurningSpeed) {
        this._cachedHasTurningSpeed = true;
      } else {
        this._cachedHasTurningSpeed = this._parent ? this._parent.hasTurningSpeed : false;
      }
    }
    return this._cachedHasTurningSpeed;
  }
  get turningSpeed() {
    if (this._cachedTurningSpeed === undefined) {
      if (this._value.hasTurningSpeed) {
        this._cachedTurningSpeed = this._value.turningSpeed;
      } else {
        this._cachedTurningSpeed = this._parent ? this._parent.turningSpeed : this._value.turningSpeed;
      }
    }
    return this._cachedTurningSpeed;
  }
  update(current, parent) {
    const result = new UnitTurningComponent_WithParent(current, parent);
    return result;
  }
}
UnitTurningComponent_WithParent.default = new UnitTurningComponent_WithParent(UnitTurningComponent.default, null);
UnitTurningComponent.WithParent = UnitTurningComponent_WithParent;
class UnitTurningComponent_Descriptor {
  get turningSpeed() {
    if (!this._turningSpeed) {
      this._turningSpeed = {
        name: "turningSpeed",
        Name: "TurningSpeed",
        number: 1,
        protoType: 1,
        protoName: "turning_speed",
        type: JsonToDouble,
        options: {
          comments: "The turning speed of the unit. Note that the unit must turn before moving if the target position is greater than 90 degrees from the unit\'s facing.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._turningSpeed;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.turningSpeed,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTurningSpeed",
        Name: "DummyOneofForTurningSpeed",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
UnitTurningComponent.descriptor = new UnitTurningComponent_Descriptor();
export class MovementComponent {
  get descriptor() {
    return MovementComponent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMoveSpeed = false;
    this._moveSpeed = null;
    this._hasUnitHeight = false;
    this._unitHeight = null;
  }
  isEmpty() {
    if (this._hasMoveSpeed) return false;
    if (this._hasUnitHeight) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MovementComponent) {
      return value;
    }
    return MovementComponent.fromJson(value);
  }
  static fromJson(json) {
    const result = new MovementComponent();
    if (json.moveSpeed != null) {
      result._hasMoveSpeed = true;
      result._moveSpeed = JsonToDouble.fromJson(json.moveSpeed);
    }
    if (json.unitHeight != null) {
      result._hasUnitHeight = true;
      result._unitHeight = JsonToDouble.fromJson(json.unitHeight);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMoveSpeed) {
      result.moveSpeed = JsonToDouble.toJson(this._moveSpeed);
    }
    if (this._hasUnitHeight) {
      result.unitHeight = JsonToDouble.toJson(this._unitHeight);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get moveSpeed() {
    return this._hasMoveSpeed ? this._moveSpeed : JsonToDouble.default;
  }
  get hasMoveSpeed() {
    return this._hasMoveSpeed;
  }
  setMoveSpeed(path, value) {
    return {type: 'SET', path: path.concat(['moveSpeed']), value};
  }
  deleteMoveSpeed(path) {
    return {type: 'DELETE', path: path.concat(['moveSpeed'])};
  }
  /**
   * @returns {number}
   */
  get unitHeight() {
    return this._hasUnitHeight ? this._unitHeight : JsonToDouble.default;
  }
  get hasUnitHeight() {
    return this._hasUnitHeight;
  }
  setUnitHeight(path, value) {
    return {type: 'SET', path: path.concat(['unitHeight']), value};
  }
  deleteUnitHeight(path) {
    return {type: 'DELETE', path: path.concat(['unitHeight'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "moveSpeed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MovementComponent(this);
              copy._hasMoveSpeed = true;
              copy._moveSpeed = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMoveSpeed) {
                return this;
              }
              const copy = new MovementComponent(this);
              copy._hasMoveSpeed = false;
              copy._moveSpeed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unitHeight": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MovementComponent(this);
              copy._hasUnitHeight = true;
              copy._unitHeight = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitHeight) {
                return this;
              }
              const copy = new MovementComponent(this);
              copy._hasUnitHeight = false;
              copy._unitHeight = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MovementComponent} other
   * @returns {MovementComponent}
   */
  merge(other) {
    const copy = new MovementComponent(this);
    if (other._hasMoveSpeed) {
      copy._hasMoveSpeed = true;
      copy._moveSpeed = other._moveSpeed;
    }
    if (other._hasUnitHeight) {
      copy._hasUnitHeight = true;
      copy._unitHeight = other._unitHeight;
    }
    return copy;
  }
}
MovementComponent.default = new MovementComponent();
class MovementComponent_Builder {
  constructor(value) {
    this._value = new MovementComponent(value);
  }
  build() {
    return new MovementComponent(this._value);
  }
  setMoveSpeed(value) {
    this._value._hasMoveSpeed = true;
    this._value._moveSpeed = value;
    return this;
  }
  deleteMoveSpeed() {
    this._value._hasMoveSpeed = false;
    this._value._moveSpeed = null;
    return this;
  }
  setUnitHeight(value) {
    this._value._hasUnitHeight = true;
    this._value._unitHeight = value;
    return this;
  }
  deleteUnitHeight() {
    this._value._hasUnitHeight = false;
    this._value._unitHeight = null;
    return this;
  }
}
MovementComponent.Builder = MovementComponent_Builder;
class MovementComponent_WithParent {
  /**
   * @param {MovementComponent} value
   * @param {MovementComponent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MovementComponent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMoveSpeed() {
    if (this._cachedHasMoveSpeed === undefined) {
      if (this._value.hasMoveSpeed) {
        this._cachedHasMoveSpeed = true;
      } else {
        this._cachedHasMoveSpeed = this._parent ? this._parent.hasMoveSpeed : false;
      }
    }
    return this._cachedHasMoveSpeed;
  }
  get moveSpeed() {
    if (this._cachedMoveSpeed === undefined) {
      if (this._value.hasMoveSpeed) {
        this._cachedMoveSpeed = this._value.moveSpeed;
      } else {
        this._cachedMoveSpeed = this._parent ? this._parent.moveSpeed : this._value.moveSpeed;
      }
    }
    return this._cachedMoveSpeed;
  }
  get hasUnitHeight() {
    if (this._cachedHasUnitHeight === undefined) {
      if (this._value.hasUnitHeight) {
        this._cachedHasUnitHeight = true;
      } else {
        this._cachedHasUnitHeight = this._parent ? this._parent.hasUnitHeight : false;
      }
    }
    return this._cachedHasUnitHeight;
  }
  get unitHeight() {
    if (this._cachedUnitHeight === undefined) {
      if (this._value.hasUnitHeight) {
        this._cachedUnitHeight = this._value.unitHeight;
      } else {
        this._cachedUnitHeight = this._parent ? this._parent.unitHeight : this._value.unitHeight;
      }
    }
    return this._cachedUnitHeight;
  }
  update(current, parent) {
    const result = new MovementComponent_WithParent(current, parent);
    return result;
  }
}
MovementComponent_WithParent.default = new MovementComponent_WithParent(MovementComponent.default, null);
MovementComponent.WithParent = MovementComponent_WithParent;
class MovementComponent_Descriptor {
  get moveSpeed() {
    if (!this._moveSpeed) {
      this._moveSpeed = {
        name: "moveSpeed",
        Name: "MoveSpeed",
        number: 1,
        protoType: 1,
        protoName: "move_speed",
        type: JsonToDouble,
        options: {
          comments: "The movement speed of the unit, in terrain grid-units-per-second.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._moveSpeed;
  }
  get unitHeight() {
    if (!this._unitHeight) {
      this._unitHeight = {
        name: "unitHeight",
        Name: "UnitHeight",
        number: 2,
        protoType: 1,
        protoName: "unit_height",
        type: JsonToDouble,
        options: {
          comments: "The visual height of the unit. Useful for making flying units appear to be flying in the air.",
          propertyRange: "0, 5",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitHeight;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.moveSpeed,
        this.unitHeight,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMoveSpeed",
        Name: "DummyOneofForMoveSpeed",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitHeight",
        Name: "DummyOneofForUnitHeight",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MovementComponent.descriptor = new MovementComponent_Descriptor();
export class HealthComponent {
  get descriptor() {
    return HealthComponent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMaxHealth = false;
    this._maxHealth = null;
    this._hasStartHealth = false;
    this._startHealth = null;
    this._hasRegeneration = false;
    this._regeneration = null;
    this._hasRegenerationDelay = false;
    this._regenerationDelay = null;
  }
  isEmpty() {
    if (this._hasMaxHealth) return false;
    if (this._hasStartHealth) return false;
    if (this._hasRegeneration) return false;
    if (this._hasRegenerationDelay) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof HealthComponent) {
      return value;
    }
    return HealthComponent.fromJson(value);
  }
  static fromJson(json) {
    const result = new HealthComponent();
    if (json.maxHealth != null) {
      result._hasMaxHealth = true;
      result._maxHealth = JsonToInt32.fromJson(json.maxHealth);
    }
    if (json.startHealth != null) {
      result._hasStartHealth = true;
      result._startHealth = JsonToInt32.fromJson(json.startHealth);
    }
    if (json.regeneration != null) {
      result._hasRegeneration = true;
      result._regeneration = JsonToDouble.fromJson(json.regeneration);
    }
    if (json.regenerationDelay != null) {
      result._hasRegenerationDelay = true;
      result._regenerationDelay = JsonToDouble.fromJson(json.regenerationDelay);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMaxHealth) {
      result.maxHealth = JsonToInt32.toJson(this._maxHealth);
    }
    if (this._hasStartHealth) {
      result.startHealth = JsonToInt32.toJson(this._startHealth);
    }
    if (this._hasRegeneration) {
      result.regeneration = JsonToDouble.toJson(this._regeneration);
    }
    if (this._hasRegenerationDelay) {
      result.regenerationDelay = JsonToDouble.toJson(this._regenerationDelay);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get maxHealth() {
    return this._hasMaxHealth ? this._maxHealth : JsonToInt32.default;
  }
  get hasMaxHealth() {
    return this._hasMaxHealth;
  }
  setMaxHealth(path, value) {
    return {type: 'SET', path: path.concat(['maxHealth']), value};
  }
  deleteMaxHealth(path) {
    return {type: 'DELETE', path: path.concat(['maxHealth'])};
  }
  /**
   * @returns {number}
   */
  get startHealth() {
    return this._hasStartHealth ? this._startHealth : JsonToInt32.default;
  }
  get hasStartHealth() {
    return this._hasStartHealth;
  }
  setStartHealth(path, value) {
    return {type: 'SET', path: path.concat(['startHealth']), value};
  }
  deleteStartHealth(path) {
    return {type: 'DELETE', path: path.concat(['startHealth'])};
  }
  /**
   * @returns {number}
   */
  get regeneration() {
    return this._hasRegeneration ? this._regeneration : JsonToDouble.default;
  }
  get hasRegeneration() {
    return this._hasRegeneration;
  }
  setRegeneration(path, value) {
    return {type: 'SET', path: path.concat(['regeneration']), value};
  }
  deleteRegeneration(path) {
    return {type: 'DELETE', path: path.concat(['regeneration'])};
  }
  /**
   * @returns {number}
   */
  get regenerationDelay() {
    return this._hasRegenerationDelay ? this._regenerationDelay : JsonToDouble.default;
  }
  get hasRegenerationDelay() {
    return this._hasRegenerationDelay;
  }
  setRegenerationDelay(path, value) {
    return {type: 'SET', path: path.concat(['regenerationDelay']), value};
  }
  deleteRegenerationDelay(path) {
    return {type: 'DELETE', path: path.concat(['regenerationDelay'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "maxHealth": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HealthComponent(this);
              copy._hasMaxHealth = true;
              copy._maxHealth = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxHealth) {
                return this;
              }
              const copy = new HealthComponent(this);
              copy._hasMaxHealth = false;
              copy._maxHealth = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "startHealth": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HealthComponent(this);
              copy._hasStartHealth = true;
              copy._startHealth = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartHealth) {
                return this;
              }
              const copy = new HealthComponent(this);
              copy._hasStartHealth = false;
              copy._startHealth = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "regeneration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HealthComponent(this);
              copy._hasRegeneration = true;
              copy._regeneration = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRegeneration) {
                return this;
              }
              const copy = new HealthComponent(this);
              copy._hasRegeneration = false;
              copy._regeneration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "regenerationDelay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new HealthComponent(this);
              copy._hasRegenerationDelay = true;
              copy._regenerationDelay = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRegenerationDelay) {
                return this;
              }
              const copy = new HealthComponent(this);
              copy._hasRegenerationDelay = false;
              copy._regenerationDelay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {HealthComponent} other
   * @returns {HealthComponent}
   */
  merge(other) {
    const copy = new HealthComponent(this);
    if (other._hasMaxHealth) {
      copy._hasMaxHealth = true;
      copy._maxHealth = other._maxHealth;
    }
    if (other._hasStartHealth) {
      copy._hasStartHealth = true;
      copy._startHealth = other._startHealth;
    }
    if (other._hasRegeneration) {
      copy._hasRegeneration = true;
      copy._regeneration = other._regeneration;
    }
    if (other._hasRegenerationDelay) {
      copy._hasRegenerationDelay = true;
      copy._regenerationDelay = other._regenerationDelay;
    }
    return copy;
  }
}
HealthComponent.default = new HealthComponent();
class HealthComponent_Builder {
  constructor(value) {
    this._value = new HealthComponent(value);
  }
  build() {
    return new HealthComponent(this._value);
  }
  setMaxHealth(value) {
    this._value._hasMaxHealth = true;
    this._value._maxHealth = value;
    return this;
  }
  deleteMaxHealth() {
    this._value._hasMaxHealth = false;
    this._value._maxHealth = null;
    return this;
  }
  setStartHealth(value) {
    this._value._hasStartHealth = true;
    this._value._startHealth = value;
    return this;
  }
  deleteStartHealth() {
    this._value._hasStartHealth = false;
    this._value._startHealth = null;
    return this;
  }
  setRegeneration(value) {
    this._value._hasRegeneration = true;
    this._value._regeneration = value;
    return this;
  }
  deleteRegeneration() {
    this._value._hasRegeneration = false;
    this._value._regeneration = null;
    return this;
  }
  setRegenerationDelay(value) {
    this._value._hasRegenerationDelay = true;
    this._value._regenerationDelay = value;
    return this;
  }
  deleteRegenerationDelay() {
    this._value._hasRegenerationDelay = false;
    this._value._regenerationDelay = null;
    return this;
  }
}
HealthComponent.Builder = HealthComponent_Builder;
class HealthComponent_WithParent {
  /**
   * @param {HealthComponent} value
   * @param {HealthComponent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return HealthComponent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMaxHealth() {
    if (this._cachedHasMaxHealth === undefined) {
      if (this._value.hasMaxHealth) {
        this._cachedHasMaxHealth = true;
      } else {
        this._cachedHasMaxHealth = this._parent ? this._parent.hasMaxHealth : false;
      }
    }
    return this._cachedHasMaxHealth;
  }
  get maxHealth() {
    if (this._cachedMaxHealth === undefined) {
      if (this._value.hasMaxHealth) {
        this._cachedMaxHealth = this._value.maxHealth;
      } else {
        this._cachedMaxHealth = this._parent ? this._parent.maxHealth : this._value.maxHealth;
      }
    }
    return this._cachedMaxHealth;
  }
  get hasStartHealth() {
    if (this._cachedHasStartHealth === undefined) {
      if (this._value.hasStartHealth) {
        this._cachedHasStartHealth = true;
      } else {
        this._cachedHasStartHealth = this._parent ? this._parent.hasStartHealth : false;
      }
    }
    return this._cachedHasStartHealth;
  }
  get startHealth() {
    if (this._cachedStartHealth === undefined) {
      if (this._value.hasStartHealth) {
        this._cachedStartHealth = this._value.startHealth;
      } else {
        this._cachedStartHealth = this._parent ? this._parent.startHealth : this._value.startHealth;
      }
    }
    return this._cachedStartHealth;
  }
  get hasRegeneration() {
    if (this._cachedHasRegeneration === undefined) {
      if (this._value.hasRegeneration) {
        this._cachedHasRegeneration = true;
      } else {
        this._cachedHasRegeneration = this._parent ? this._parent.hasRegeneration : false;
      }
    }
    return this._cachedHasRegeneration;
  }
  get regeneration() {
    if (this._cachedRegeneration === undefined) {
      if (this._value.hasRegeneration) {
        this._cachedRegeneration = this._value.regeneration;
      } else {
        this._cachedRegeneration = this._parent ? this._parent.regeneration : this._value.regeneration;
      }
    }
    return this._cachedRegeneration;
  }
  get hasRegenerationDelay() {
    if (this._cachedHasRegenerationDelay === undefined) {
      if (this._value.hasRegenerationDelay) {
        this._cachedHasRegenerationDelay = true;
      } else {
        this._cachedHasRegenerationDelay = this._parent ? this._parent.hasRegenerationDelay : false;
      }
    }
    return this._cachedHasRegenerationDelay;
  }
  get regenerationDelay() {
    if (this._cachedRegenerationDelay === undefined) {
      if (this._value.hasRegenerationDelay) {
        this._cachedRegenerationDelay = this._value.regenerationDelay;
      } else {
        this._cachedRegenerationDelay = this._parent ? this._parent.regenerationDelay : this._value.regenerationDelay;
      }
    }
    return this._cachedRegenerationDelay;
  }
  update(current, parent) {
    const result = new HealthComponent_WithParent(current, parent);
    return result;
  }
}
HealthComponent_WithParent.default = new HealthComponent_WithParent(HealthComponent.default, null);
HealthComponent.WithParent = HealthComponent_WithParent;
class HealthComponent_Descriptor {
  get maxHealth() {
    if (!this._maxHealth) {
      this._maxHealth = {
        name: "maxHealth",
        Name: "MaxHealth",
        number: 1,
        protoType: 5,
        protoName: "max_health",
        type: JsonToInt32,
        options: {
          comments: "The maximum health of the unit.",
          min: 1,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxHealth;
  }
  get startHealth() {
    if (!this._startHealth) {
      this._startHealth = {
        name: "startHealth",
        Name: "StartHealth",
        number: 2,
        protoType: 5,
        protoName: "start_health",
        type: JsonToInt32,
        options: {
          comments: "The starting health of the unit. By default this will use the **Max Health** value.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startHealth;
  }
  get regeneration() {
    if (!this._regeneration) {
      this._regeneration = {
        name: "regeneration",
        Name: "Regeneration",
        number: 3,
        protoType: 1,
        protoName: "regeneration",
        type: JsonToDouble,
        options: {
          comments: "The amount of health the unit regenerates per second.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._regeneration;
  }
  get regenerationDelay() {
    if (!this._regenerationDelay) {
      this._regenerationDelay = {
        name: "regenerationDelay",
        Name: "RegenerationDelay",
        number: 4,
        protoType: 1,
        protoName: "regeneration_delay",
        type: JsonToDouble,
        options: {
          comments: "The delay after the unit takes damage before it begins regenerating health. Useful for making health only regenerate outside of combat.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._regenerationDelay;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.maxHealth,
        this.startHealth,
        this.regeneration,
        this.regenerationDelay,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMaxHealth",
        Name: "DummyOneofForMaxHealth",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStartHealth",
        Name: "DummyOneofForStartHealth",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRegeneration",
        Name: "DummyOneofForRegeneration",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRegenerationDelay",
        Name: "DummyOneofForRegenerationDelay",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
HealthComponent.descriptor = new HealthComponent_Descriptor();
class UnitComponent_UnitType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "UNIT": return 0;
        case "MISSILE": return 1;
        case "STRUCTURE": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return UnitComponent_UnitType.fromJson(value);
  }
  static fromReact(e) {
    return UnitComponent_UnitType.fromJson(e);
  }
}
UnitComponent_UnitType.UNIT = 0;
UnitComponent_UnitType.MISSILE = 1;
UnitComponent_UnitType.STRUCTURE = 2;
UnitComponent_UnitType.default = 0;
UnitComponent_UnitType.values = {
  UNIT: 0,
  MISSILE: 1,
  STRUCTURE: 2,
};
UnitComponent_UnitType.names = {
  0: "UNIT",
  1: "MISSILE",
  2: "STRUCTURE",
};
export class UnitComponent {
  get descriptor() {
    return UnitComponent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnitType = false;
    this._unitType = null;
  }
  isEmpty() {
    if (this._hasUnitType) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UnitComponent) {
      return value;
    }
    return UnitComponent.fromJson(value);
  }
  static fromJson(json) {
    const result = new UnitComponent();
    if (json.unitType != null) {
      result._hasUnitType = true;
      result._unitType = UnitComponent_UnitType.fromJson(json.unitType);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnitType) {
      result.unitType = UnitComponent_UnitType.toJson(this._unitType);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get unitType() {
    return this._hasUnitType ? this._unitType : UnitComponent_UnitType.default;
  }
  get hasUnitType() {
    return this._hasUnitType;
  }
  setUnitType(path, value) {
    return {type: 'SET', path: path.concat(['unitType']), value};
  }
  deleteUnitType(path) {
    return {type: 'DELETE', path: path.concat(['unitType'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unitType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitComponent(this);
              copy._hasUnitType = true;
              copy._unitType = UnitComponent_UnitType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitType) {
                return this;
              }
              const copy = new UnitComponent(this);
              copy._hasUnitType = false;
              copy._unitType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UnitComponent} other
   * @returns {UnitComponent}
   */
  merge(other) {
    const copy = new UnitComponent(this);
    if (other._hasUnitType) {
      copy._hasUnitType = true;
      copy._unitType = other._unitType;
    }
    return copy;
  }
}
UnitComponent.default = new UnitComponent();
UnitComponent.UnitType = UnitComponent_UnitType;
class UnitComponent_Builder {
  constructor(value) {
    this._value = new UnitComponent(value);
  }
  build() {
    return new UnitComponent(this._value);
  }
  setUnitType(value) {
    this._value._hasUnitType = true;
    this._value._unitType = value;
    return this;
  }
  deleteUnitType() {
    this._value._hasUnitType = false;
    this._value._unitType = null;
    return this;
  }
}
UnitComponent.Builder = UnitComponent_Builder;
class UnitComponent_WithParent {
  /**
   * @param {UnitComponent} value
   * @param {UnitComponent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UnitComponent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnitType() {
    if (this._cachedHasUnitType === undefined) {
      if (this._value.hasUnitType) {
        this._cachedHasUnitType = true;
      } else {
        this._cachedHasUnitType = this._parent ? this._parent.hasUnitType : false;
      }
    }
    return this._cachedHasUnitType;
  }
  get unitType() {
    if (this._cachedUnitType === undefined) {
      if (this._value.hasUnitType) {
        this._cachedUnitType = this._value.unitType;
      } else {
        this._cachedUnitType = this._parent ? this._parent.unitType : this._value.unitType;
      }
    }
    return this._cachedUnitType;
  }
  update(current, parent) {
    const result = new UnitComponent_WithParent(current, parent);
    return result;
  }
}
UnitComponent_WithParent.default = new UnitComponent_WithParent(UnitComponent.default, null);
UnitComponent.WithParent = UnitComponent_WithParent;
class UnitComponent_Descriptor {
  get unitType() {
    if (!this._unitType) {
      this._unitType = {
        name: "unitType",
        Name: "UnitType",
        number: 1,
        protoType: 14,
        protoName: "unit_type",
        type: UnitComponent_UnitType,
        options: {
          comments: "Sets the type of unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitType;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unitType,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnitType",
        Name: "DummyOneofForUnitType",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
UnitComponent.descriptor = new UnitComponent_Descriptor();
class BehaviorComponent_BehaviorDoNothing {
  get descriptor() {
    return BehaviorComponent_BehaviorDoNothing.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof BehaviorComponent_BehaviorDoNothing) {
      return value;
    }
    return BehaviorComponent_BehaviorDoNothing.fromJson(value);
  }
  static fromJson(json) {
    const result = new BehaviorComponent_BehaviorDoNothing();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {BehaviorComponent_BehaviorDoNothing} other
   * @returns {BehaviorComponent_BehaviorDoNothing}
   */
  merge(other) {
    const copy = new BehaviorComponent_BehaviorDoNothing(this);
    return copy;
  }
}
BehaviorComponent_BehaviorDoNothing.default = new BehaviorComponent_BehaviorDoNothing();
class BehaviorComponent_BehaviorDoNothing_Builder {
  constructor(value) {
    this._value = new BehaviorComponent_BehaviorDoNothing(value);
  }
  build() {
    return new BehaviorComponent_BehaviorDoNothing(this._value);
  }
}
BehaviorComponent_BehaviorDoNothing.Builder = BehaviorComponent_BehaviorDoNothing_Builder;
class BehaviorComponent_BehaviorDoNothing_WithParent {
  /**
   * @param {BehaviorComponent_BehaviorDoNothing} value
   * @param {BehaviorComponent_BehaviorDoNothing_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return BehaviorComponent_BehaviorDoNothing.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new BehaviorComponent_BehaviorDoNothing_WithParent(current, parent);
    return result;
  }
}
BehaviorComponent_BehaviorDoNothing_WithParent.default = new BehaviorComponent_BehaviorDoNothing_WithParent(BehaviorComponent_BehaviorDoNothing.default, null);
BehaviorComponent_BehaviorDoNothing.WithParent = BehaviorComponent_BehaviorDoNothing_WithParent;
class BehaviorComponent_BehaviorDoNothing_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
BehaviorComponent_BehaviorDoNothing.descriptor = new BehaviorComponent_BehaviorDoNothing_Descriptor();
class BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan {
  get descriptor() {
    return BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPeriod = false;
    this._period = null;
  }
  isEmpty() {
    if (this._hasPeriod) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan) {
      return value;
    }
    return BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan.fromJson(value);
  }
  static fromJson(json) {
    const result = new BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan();
    if (json.period != null) {
      result._hasPeriod = true;
      result._period = JsonToDouble.fromJson(json.period);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPeriod) {
      result.period = JsonToDouble.toJson(this._period);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get period() {
    return this._hasPeriod ? this._period : JsonToDouble.default;
  }
  get hasPeriod() {
    return this._hasPeriod;
  }
  setPeriod(path, value) {
    return {type: 'SET', path: path.concat(['period']), value};
  }
  deletePeriod(path) {
    return {type: 'DELETE', path: path.concat(['period'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "period": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan(this);
              copy._hasPeriod = true;
              copy._period = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPeriod) {
                return this;
              }
              const copy = new BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan(this);
              copy._hasPeriod = false;
              copy._period = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan} other
   * @returns {BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan}
   */
  merge(other) {
    const copy = new BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan(this);
    if (other._hasPeriod) {
      copy._hasPeriod = true;
      copy._period = other._period;
    }
    return copy;
  }
}
BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan.default = new BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan();
class BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan_Builder {
  constructor(value) {
    this._value = new BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan(value);
  }
  build() {
    return new BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan(this._value);
  }
  setPeriod(value) {
    this._value._hasPeriod = true;
    this._value._period = value;
    return this;
  }
  deletePeriod() {
    this._value._hasPeriod = false;
    this._value._period = null;
    return this;
  }
}
BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan.Builder = BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan_Builder;
class BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan_WithParent {
  /**
   * @param {BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan} value
   * @param {BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPeriod() {
    if (this._cachedHasPeriod === undefined) {
      if (this._value.hasPeriod) {
        this._cachedHasPeriod = true;
      } else {
        this._cachedHasPeriod = this._parent ? this._parent.hasPeriod : false;
      }
    }
    return this._cachedHasPeriod;
  }
  get period() {
    if (this._cachedPeriod === undefined) {
      if (this._value.hasPeriod) {
        this._cachedPeriod = this._value.period;
      } else {
        this._cachedPeriod = this._parent ? this._parent.period : this._value.period;
      }
    }
    return this._cachedPeriod;
  }
  update(current, parent) {
    const result = new BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan_WithParent(current, parent);
    return result;
  }
}
BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan_WithParent.default = new BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan_WithParent(BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan.default, null);
BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan.WithParent = BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan_WithParent;
class BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan_Descriptor {
  get period() {
    if (!this._period) {
      this._period = {
        name: "period",
        Name: "Period",
        number: 3,
        protoType: 1,
        protoName: "period",
        type: JsonToDouble,
        options: {
          comments: "If set, the unit will be forced to reconsider its current weapon target each period. Otherwise weapons tend to stick to the current target until it becomes invalid or dies.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._period;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.period,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPeriod",
        Name: "DummyOneofForPeriod",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan.descriptor = new BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan_Descriptor();
class BehaviorComponent_BehaviorGenericControllableUnit {
  get descriptor() {
    return BehaviorComponent_BehaviorGenericControllableUnit.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLeashRadius = false;
    this._leashRadius = null;
    this._hasLeashResetRadius = false;
    this._leashResetRadius = null;
    this._hasForceRescan = false;
    this._forceRescan = null;
  }
  isEmpty() {
    if (this._hasLeashRadius) return false;
    if (this._hasLeashResetRadius) return false;
    if (this._hasForceRescan && !this._forceRescan.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof BehaviorComponent_BehaviorGenericControllableUnit) {
      return value;
    }
    return BehaviorComponent_BehaviorGenericControllableUnit.fromJson(value);
  }
  static fromJson(json) {
    const result = new BehaviorComponent_BehaviorGenericControllableUnit();
    if (json.leashRadius != null) {
      result._hasLeashRadius = true;
      result._leashRadius = JsonToDouble.fromJson(json.leashRadius);
    }
    if (json.leashResetRadius != null) {
      result._hasLeashResetRadius = true;
      result._leashResetRadius = JsonToDouble.fromJson(json.leashResetRadius);
    }
    if (json.forceRescan != null) {
      result._hasForceRescan = true;
      result._forceRescan = BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan.fromJson(json.forceRescan);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLeashRadius) {
      result.leashRadius = JsonToDouble.toJson(this._leashRadius);
    }
    if (this._hasLeashResetRadius) {
      result.leashResetRadius = JsonToDouble.toJson(this._leashResetRadius);
    }
    if (this._hasForceRescan && !this._forceRescan.isEmpty()) {
      result.forceRescan = BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan.toJson(this._forceRescan);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get leashRadius() {
    return this._hasLeashRadius ? this._leashRadius : JsonToDouble.default;
  }
  get hasLeashRadius() {
    return this._hasLeashRadius;
  }
  setLeashRadius(path, value) {
    return {type: 'SET', path: path.concat(['leashRadius']), value};
  }
  deleteLeashRadius(path) {
    return {type: 'DELETE', path: path.concat(['leashRadius'])};
  }
  /**
   * @returns {number}
   */
  get leashResetRadius() {
    return this._hasLeashResetRadius ? this._leashResetRadius : JsonToDouble.default;
  }
  get hasLeashResetRadius() {
    return this._hasLeashResetRadius;
  }
  setLeashResetRadius(path, value) {
    return {type: 'SET', path: path.concat(['leashResetRadius']), value};
  }
  deleteLeashResetRadius(path) {
    return {type: 'DELETE', path: path.concat(['leashResetRadius'])};
  }
  /**
   * @returns {BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan}
   */
  get forceRescan() {
    return this._hasForceRescan ? this._forceRescan : BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan.default;
  }
  get hasForceRescan() {
    return this._hasForceRescan;
  }
  setForceRescan(path, value) {
    return {type: 'SET', path: path.concat(['forceRescan']), value: value.toJson()};
  }
  deleteForceRescan(path) {
    return {type: 'DELETE', path: path.concat(['forceRescan'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "leashRadius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorComponent_BehaviorGenericControllableUnit(this);
              copy._hasLeashRadius = true;
              copy._leashRadius = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeashRadius) {
                return this;
              }
              const copy = new BehaviorComponent_BehaviorGenericControllableUnit(this);
              copy._hasLeashRadius = false;
              copy._leashRadius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "leashResetRadius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorComponent_BehaviorGenericControllableUnit(this);
              copy._hasLeashResetRadius = true;
              copy._leashResetRadius = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeashResetRadius) {
                return this;
              }
              const copy = new BehaviorComponent_BehaviorGenericControllableUnit(this);
              copy._hasLeashResetRadius = false;
              copy._leashResetRadius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "forceRescan": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorComponent_BehaviorGenericControllableUnit(this);
              copy._hasForceRescan = true;
              copy._forceRescan = BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasForceRescan) {
                return this;
              }
              const copy = new BehaviorComponent_BehaviorGenericControllableUnit(this);
              copy._hasForceRescan = false;
              copy._forceRescan = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasForceRescan) {
            const copy = new BehaviorComponent_BehaviorGenericControllableUnit(this);
            copy._hasForceRescan = true;
            copy._forceRescan = BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._forceRescan.apply(type, path.slice(1), value);
          if (newValue === this._forceRescan) {
            return this;
          }
          const copy = new BehaviorComponent_BehaviorGenericControllableUnit(this);
          copy._forceRescan = copy._forceRescan.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {BehaviorComponent_BehaviorGenericControllableUnit} other
   * @returns {BehaviorComponent_BehaviorGenericControllableUnit}
   */
  merge(other) {
    const copy = new BehaviorComponent_BehaviorGenericControllableUnit(this);
    if (other._hasLeashRadius) {
      copy._hasLeashRadius = true;
      copy._leashRadius = other._leashRadius;
    }
    if (other._hasLeashResetRadius) {
      copy._hasLeashResetRadius = true;
      copy._leashResetRadius = other._leashResetRadius;
    }
    if (other._hasForceRescan) {
      if (copy._hasForceRescan) {
        copy._forceRescan = copy.forceRescan.merge(other.forceRescan);
      } else {
        copy._forceRescan = other._forceRescan;
      }
      copy._hasForceRescan = true;
    }
    return copy;
  }
}
BehaviorComponent_BehaviorGenericControllableUnit.default = new BehaviorComponent_BehaviorGenericControllableUnit();
BehaviorComponent_BehaviorGenericControllableUnit.ForceRescan = BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan;
class BehaviorComponent_BehaviorGenericControllableUnit_Builder {
  constructor(value) {
    this._value = new BehaviorComponent_BehaviorGenericControllableUnit(value);
  }
  build() {
    return new BehaviorComponent_BehaviorGenericControllableUnit(this._value);
  }
  setLeashRadius(value) {
    this._value._hasLeashRadius = true;
    this._value._leashRadius = value;
    return this;
  }
  deleteLeashRadius() {
    this._value._hasLeashRadius = false;
    this._value._leashRadius = null;
    return this;
  }
  setLeashResetRadius(value) {
    this._value._hasLeashResetRadius = true;
    this._value._leashResetRadius = value;
    return this;
  }
  deleteLeashResetRadius() {
    this._value._hasLeashResetRadius = false;
    this._value._leashResetRadius = null;
    return this;
  }
  setForceRescan(value) {
    this._value._hasForceRescan = true;
    this._value._forceRescan = value;
    return this;
  }
  deleteForceRescan() {
    this._value._hasForceRescan = false;
    this._value._forceRescan = null;
    return this;
  }
}
BehaviorComponent_BehaviorGenericControllableUnit.Builder = BehaviorComponent_BehaviorGenericControllableUnit_Builder;
class BehaviorComponent_BehaviorGenericControllableUnit_WithParent {
  /**
   * @param {BehaviorComponent_BehaviorGenericControllableUnit} value
   * @param {BehaviorComponent_BehaviorGenericControllableUnit_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return BehaviorComponent_BehaviorGenericControllableUnit.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLeashRadius() {
    if (this._cachedHasLeashRadius === undefined) {
      if (this._value.hasLeashRadius) {
        this._cachedHasLeashRadius = true;
      } else {
        this._cachedHasLeashRadius = this._parent ? this._parent.hasLeashRadius : false;
      }
    }
    return this._cachedHasLeashRadius;
  }
  get leashRadius() {
    if (this._cachedLeashRadius === undefined) {
      if (this._value.hasLeashRadius) {
        this._cachedLeashRadius = this._value.leashRadius;
      } else {
        this._cachedLeashRadius = this._parent ? this._parent.leashRadius : this._value.leashRadius;
      }
    }
    return this._cachedLeashRadius;
  }
  get hasLeashResetRadius() {
    if (this._cachedHasLeashResetRadius === undefined) {
      if (this._value.hasLeashResetRadius) {
        this._cachedHasLeashResetRadius = true;
      } else {
        this._cachedHasLeashResetRadius = this._parent ? this._parent.hasLeashResetRadius : false;
      }
    }
    return this._cachedHasLeashResetRadius;
  }
  get leashResetRadius() {
    if (this._cachedLeashResetRadius === undefined) {
      if (this._value.hasLeashResetRadius) {
        this._cachedLeashResetRadius = this._value.leashResetRadius;
      } else {
        this._cachedLeashResetRadius = this._parent ? this._parent.leashResetRadius : this._value.leashResetRadius;
      }
    }
    return this._cachedLeashResetRadius;
  }
  get hasForceRescan() {
    if (this._cachedHasForceRescan === undefined) {
      if (this._value.hasForceRescan) {
        this._cachedHasForceRescan = true;
      } else {
        this._cachedHasForceRescan = this._parent ? this._parent.hasForceRescan : false;
      }
    }
    return this._cachedHasForceRescan;
  }
  get forceRescan() {
    if (!this._cachedForceRescan) {
      if (this._value.hasForceRescan) {
        this._cachedForceRescan = new BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan.WithParent(this._value.forceRescan, this._parent && this._parent.hasForceRescan ? this._parent.forceRescan : null);
      } else {
        this._cachedForceRescan = this._parent ? new BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan.WithParent(BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan.default, this._parent.forceRescan) : BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan.WithParent.default;
      }
    }
    return this._cachedForceRescan;
  }
  update(current, parent) {
    const result = new BehaviorComponent_BehaviorGenericControllableUnit_WithParent(current, parent);
    if (this._cachedForceRescan && this._value.hasForceRescan && current.hasForceRescan) {
      if (this._value.forceRescan === current.forceRescan && this._parent === parent) {
        result._cachedForceRescan = this._cachedForceRescan;
      } else {
        result._cachedForceRescan = this._cachedForceRescan.update(current.forceRescan, parent && parent.hasForceRescan ? parent.forceRescan : null);
      }
    }
    return result;
  }
}
BehaviorComponent_BehaviorGenericControllableUnit_WithParent.default = new BehaviorComponent_BehaviorGenericControllableUnit_WithParent(BehaviorComponent_BehaviorGenericControllableUnit.default, null);
BehaviorComponent_BehaviorGenericControllableUnit.WithParent = BehaviorComponent_BehaviorGenericControllableUnit_WithParent;
class BehaviorComponent_BehaviorGenericControllableUnit_Descriptor {
  get leashRadius() {
    if (!this._leashRadius) {
      this._leashRadius = {
        name: "leashRadius",
        Name: "LeashRadius",
        number: 1,
        protoType: 1,
        protoName: "leash_radius",
        type: JsonToDouble,
        options: {
          comments: "Units will only chase auto-acquired targets within this radius. If the unit leaves this radius, it will be ordered to return to its original position (ie the origin of the leash radius). The unit will not be able to auto-acquire a new target until it reaches the leash reset radius. The position of the leash region only updates when a unit becomes idle.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._leashRadius;
  }
  get leashResetRadius() {
    if (!this._leashResetRadius) {
      this._leashResetRadius = {
        name: "leashResetRadius",
        Name: "LeashResetRadius",
        number: 2,
        protoType: 1,
        protoName: "leash_reset_radius",
        type: JsonToDouble,
        options: {
          comments: "Leashed units (ones that have abandoned their auto-acquired targets and are moving towards their original position) are allowed to acquire new targets within this radius. The leash reset region uses the same origin as the leash region (and updates with it). The purpose of using two regions is to prevent attackers from being able to kite defenders by jumping in and out of the leash radius; The leash reset radius should be significantly smaller than the leash radius to provide the defender a decent area to retreat to.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._leashResetRadius;
  }
  get forceRescan() {
    if (!this._forceRescan) {
      this._forceRescan = {
        name: "forceRescan",
        Name: "ForceRescan",
        number: 3,
        protoType: 11,
        protoName: "force_rescan",
        type: BehaviorComponent_BehaviorGenericControllableUnit_ForceRescan,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._forceRescan;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.leashRadius,
        this.leashResetRadius,
        this.forceRescan,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLeashRadius",
        Name: "DummyOneofForLeashRadius",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLeashResetRadius",
        Name: "DummyOneofForLeashResetRadius",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForForceRescan",
        Name: "DummyOneofForForceRescan",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
BehaviorComponent_BehaviorGenericControllableUnit.descriptor = new BehaviorComponent_BehaviorGenericControllableUnit_Descriptor();
class BehaviorComponent_BehaviorWander {
  get descriptor() {
    return BehaviorComponent_BehaviorWander.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasChangeLocationPeriod = false;
    this._changeLocationPeriod = null;
    this._hasWanderRadius = false;
    this._wanderRadius = null;
  }
  isEmpty() {
    if (this._hasChangeLocationPeriod) return false;
    if (this._hasWanderRadius) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof BehaviorComponent_BehaviorWander) {
      return value;
    }
    return BehaviorComponent_BehaviorWander.fromJson(value);
  }
  static fromJson(json) {
    const result = new BehaviorComponent_BehaviorWander();
    if (json.changeLocationPeriod != null) {
      result._hasChangeLocationPeriod = true;
      result._changeLocationPeriod = JsonToDouble.fromJson(json.changeLocationPeriod);
    }
    if (json.wanderRadius != null) {
      result._hasWanderRadius = true;
      result._wanderRadius = JsonToDouble.fromJson(json.wanderRadius);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasChangeLocationPeriod) {
      result.changeLocationPeriod = JsonToDouble.toJson(this._changeLocationPeriod);
    }
    if (this._hasWanderRadius) {
      result.wanderRadius = JsonToDouble.toJson(this._wanderRadius);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get changeLocationPeriod() {
    return this._hasChangeLocationPeriod ? this._changeLocationPeriod : JsonToDouble.default;
  }
  get hasChangeLocationPeriod() {
    return this._hasChangeLocationPeriod;
  }
  setChangeLocationPeriod(path, value) {
    return {type: 'SET', path: path.concat(['changeLocationPeriod']), value};
  }
  deleteChangeLocationPeriod(path) {
    return {type: 'DELETE', path: path.concat(['changeLocationPeriod'])};
  }
  /**
   * @returns {number}
   */
  get wanderRadius() {
    return this._hasWanderRadius ? this._wanderRadius : JsonToDouble.default;
  }
  get hasWanderRadius() {
    return this._hasWanderRadius;
  }
  setWanderRadius(path, value) {
    return {type: 'SET', path: path.concat(['wanderRadius']), value};
  }
  deleteWanderRadius(path) {
    return {type: 'DELETE', path: path.concat(['wanderRadius'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "changeLocationPeriod": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorComponent_BehaviorWander(this);
              copy._hasChangeLocationPeriod = true;
              copy._changeLocationPeriod = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChangeLocationPeriod) {
                return this;
              }
              const copy = new BehaviorComponent_BehaviorWander(this);
              copy._hasChangeLocationPeriod = false;
              copy._changeLocationPeriod = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "wanderRadius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorComponent_BehaviorWander(this);
              copy._hasWanderRadius = true;
              copy._wanderRadius = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWanderRadius) {
                return this;
              }
              const copy = new BehaviorComponent_BehaviorWander(this);
              copy._hasWanderRadius = false;
              copy._wanderRadius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {BehaviorComponent_BehaviorWander} other
   * @returns {BehaviorComponent_BehaviorWander}
   */
  merge(other) {
    const copy = new BehaviorComponent_BehaviorWander(this);
    if (other._hasChangeLocationPeriod) {
      copy._hasChangeLocationPeriod = true;
      copy._changeLocationPeriod = other._changeLocationPeriod;
    }
    if (other._hasWanderRadius) {
      copy._hasWanderRadius = true;
      copy._wanderRadius = other._wanderRadius;
    }
    return copy;
  }
}
BehaviorComponent_BehaviorWander.default = new BehaviorComponent_BehaviorWander();
class BehaviorComponent_BehaviorWander_Builder {
  constructor(value) {
    this._value = new BehaviorComponent_BehaviorWander(value);
  }
  build() {
    return new BehaviorComponent_BehaviorWander(this._value);
  }
  setChangeLocationPeriod(value) {
    this._value._hasChangeLocationPeriod = true;
    this._value._changeLocationPeriod = value;
    return this;
  }
  deleteChangeLocationPeriod() {
    this._value._hasChangeLocationPeriod = false;
    this._value._changeLocationPeriod = null;
    return this;
  }
  setWanderRadius(value) {
    this._value._hasWanderRadius = true;
    this._value._wanderRadius = value;
    return this;
  }
  deleteWanderRadius() {
    this._value._hasWanderRadius = false;
    this._value._wanderRadius = null;
    return this;
  }
}
BehaviorComponent_BehaviorWander.Builder = BehaviorComponent_BehaviorWander_Builder;
class BehaviorComponent_BehaviorWander_WithParent {
  /**
   * @param {BehaviorComponent_BehaviorWander} value
   * @param {BehaviorComponent_BehaviorWander_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return BehaviorComponent_BehaviorWander.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasChangeLocationPeriod() {
    if (this._cachedHasChangeLocationPeriod === undefined) {
      if (this._value.hasChangeLocationPeriod) {
        this._cachedHasChangeLocationPeriod = true;
      } else {
        this._cachedHasChangeLocationPeriod = this._parent ? this._parent.hasChangeLocationPeriod : false;
      }
    }
    return this._cachedHasChangeLocationPeriod;
  }
  get changeLocationPeriod() {
    if (this._cachedChangeLocationPeriod === undefined) {
      if (this._value.hasChangeLocationPeriod) {
        this._cachedChangeLocationPeriod = this._value.changeLocationPeriod;
      } else {
        this._cachedChangeLocationPeriod = this._parent ? this._parent.changeLocationPeriod : this._value.changeLocationPeriod;
      }
    }
    return this._cachedChangeLocationPeriod;
  }
  get hasWanderRadius() {
    if (this._cachedHasWanderRadius === undefined) {
      if (this._value.hasWanderRadius) {
        this._cachedHasWanderRadius = true;
      } else {
        this._cachedHasWanderRadius = this._parent ? this._parent.hasWanderRadius : false;
      }
    }
    return this._cachedHasWanderRadius;
  }
  get wanderRadius() {
    if (this._cachedWanderRadius === undefined) {
      if (this._value.hasWanderRadius) {
        this._cachedWanderRadius = this._value.wanderRadius;
      } else {
        this._cachedWanderRadius = this._parent ? this._parent.wanderRadius : this._value.wanderRadius;
      }
    }
    return this._cachedWanderRadius;
  }
  update(current, parent) {
    const result = new BehaviorComponent_BehaviorWander_WithParent(current, parent);
    return result;
  }
}
BehaviorComponent_BehaviorWander_WithParent.default = new BehaviorComponent_BehaviorWander_WithParent(BehaviorComponent_BehaviorWander.default, null);
BehaviorComponent_BehaviorWander.WithParent = BehaviorComponent_BehaviorWander_WithParent;
class BehaviorComponent_BehaviorWander_Descriptor {
  get changeLocationPeriod() {
    if (!this._changeLocationPeriod) {
      this._changeLocationPeriod = {
        name: "changeLocationPeriod",
        Name: "ChangeLocationPeriod",
        number: 1,
        protoType: 1,
        protoName: "change_location_period",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._changeLocationPeriod;
  }
  get wanderRadius() {
    if (!this._wanderRadius) {
      this._wanderRadius = {
        name: "wanderRadius",
        Name: "WanderRadius",
        number: 2,
        protoType: 1,
        protoName: "wander_radius",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._wanderRadius;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.changeLocationPeriod,
        this.wanderRadius,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForChangeLocationPeriod",
        Name: "DummyOneofForChangeLocationPeriod",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWanderRadius",
        Name: "DummyOneofForWanderRadius",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
BehaviorComponent_BehaviorWander.descriptor = new BehaviorComponent_BehaviorWander_Descriptor();
class BehaviorComponent_BehaviorTdTypes {
  get descriptor() {
    return BehaviorComponent_BehaviorTdTypes.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasBehaviorType = false;
    this._behaviorType = null;
    this._hasUnitBattleData = false;
    this._unitBattleData = null;
  }
  isEmpty() {
    if (this._hasBehaviorType) return false;
    if (this._hasUnitBattleData && !this._unitBattleData.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof BehaviorComponent_BehaviorTdTypes) {
      return value;
    }
    return BehaviorComponent_BehaviorTdTypes.fromJson(value);
  }
  static fromJson(json) {
    const result = new BehaviorComponent_BehaviorTdTypes();
    if (json.behaviorType != null) {
      result._hasBehaviorType = true;
      result._behaviorType = BehaviorComponent_BehaviorType.fromJson(json.behaviorType);
    }
    if (json.unitBattleData != null) {
      result._hasUnitBattleData = true;
      result._unitBattleData = UnitBattleData.fromJson(json.unitBattleData);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasBehaviorType) {
      result.behaviorType = BehaviorComponent_BehaviorType.toJson(this._behaviorType);
    }
    if (this._hasUnitBattleData && !this._unitBattleData.isEmpty()) {
      result.unitBattleData = UnitBattleData.toJson(this._unitBattleData);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get behaviorType() {
    return this._hasBehaviorType ? this._behaviorType : BehaviorComponent_BehaviorType.default;
  }
  get hasBehaviorType() {
    return this._hasBehaviorType;
  }
  setBehaviorType(path, value) {
    return {type: 'SET', path: path.concat(['behaviorType']), value};
  }
  deleteBehaviorType(path) {
    return {type: 'DELETE', path: path.concat(['behaviorType'])};
  }
  /**
   * @returns {UnitBattleData}
   */
  get unitBattleData() {
    return this._hasUnitBattleData ? this._unitBattleData : UnitBattleData.default;
  }
  get hasUnitBattleData() {
    return this._hasUnitBattleData;
  }
  setUnitBattleData(path, value) {
    return {type: 'SET', path: path.concat(['unitBattleData']), value: value.toJson()};
  }
  deleteUnitBattleData(path) {
    return {type: 'DELETE', path: path.concat(['unitBattleData'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "behaviorType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorComponent_BehaviorTdTypes(this);
              copy._hasBehaviorType = true;
              copy._behaviorType = BehaviorComponent_BehaviorType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBehaviorType) {
                return this;
              }
              const copy = new BehaviorComponent_BehaviorTdTypes(this);
              copy._hasBehaviorType = false;
              copy._behaviorType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unitBattleData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorComponent_BehaviorTdTypes(this);
              copy._hasUnitBattleData = true;
              copy._unitBattleData = UnitBattleData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitBattleData) {
                return this;
              }
              const copy = new BehaviorComponent_BehaviorTdTypes(this);
              copy._hasUnitBattleData = false;
              copy._unitBattleData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitBattleData) {
            const copy = new BehaviorComponent_BehaviorTdTypes(this);
            copy._hasUnitBattleData = true;
            copy._unitBattleData = UnitBattleData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unitBattleData.apply(type, path.slice(1), value);
          if (newValue === this._unitBattleData) {
            return this;
          }
          const copy = new BehaviorComponent_BehaviorTdTypes(this);
          copy._unitBattleData = copy._unitBattleData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {BehaviorComponent_BehaviorTdTypes} other
   * @returns {BehaviorComponent_BehaviorTdTypes}
   */
  merge(other) {
    const copy = new BehaviorComponent_BehaviorTdTypes(this);
    if (other._hasBehaviorType) {
      copy._hasBehaviorType = true;
      copy._behaviorType = other._behaviorType;
    }
    if (other._hasUnitBattleData) {
      if (copy._hasUnitBattleData) {
        copy._unitBattleData = copy.unitBattleData.merge(other.unitBattleData);
      } else {
        copy._unitBattleData = other._unitBattleData;
      }
      copy._hasUnitBattleData = true;
    }
    return copy;
  }
}
BehaviorComponent_BehaviorTdTypes.default = new BehaviorComponent_BehaviorTdTypes();
class BehaviorComponent_BehaviorTdTypes_Builder {
  constructor(value) {
    this._value = new BehaviorComponent_BehaviorTdTypes(value);
  }
  build() {
    return new BehaviorComponent_BehaviorTdTypes(this._value);
  }
  setBehaviorType(value) {
    this._value._hasBehaviorType = true;
    this._value._behaviorType = value;
    return this;
  }
  deleteBehaviorType() {
    this._value._hasBehaviorType = false;
    this._value._behaviorType = null;
    return this;
  }
  setUnitBattleData(value) {
    this._value._hasUnitBattleData = true;
    this._value._unitBattleData = value;
    return this;
  }
  deleteUnitBattleData() {
    this._value._hasUnitBattleData = false;
    this._value._unitBattleData = null;
    return this;
  }
}
BehaviorComponent_BehaviorTdTypes.Builder = BehaviorComponent_BehaviorTdTypes_Builder;
class BehaviorComponent_BehaviorTdTypes_WithParent {
  /**
   * @param {BehaviorComponent_BehaviorTdTypes} value
   * @param {BehaviorComponent_BehaviorTdTypes_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return BehaviorComponent_BehaviorTdTypes.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasBehaviorType() {
    if (this._cachedHasBehaviorType === undefined) {
      if (this._value.hasBehaviorType) {
        this._cachedHasBehaviorType = true;
      } else {
        this._cachedHasBehaviorType = this._parent ? this._parent.hasBehaviorType : false;
      }
    }
    return this._cachedHasBehaviorType;
  }
  get behaviorType() {
    if (this._cachedBehaviorType === undefined) {
      if (this._value.hasBehaviorType) {
        this._cachedBehaviorType = this._value.behaviorType;
      } else {
        this._cachedBehaviorType = this._parent ? this._parent.behaviorType : this._value.behaviorType;
      }
    }
    return this._cachedBehaviorType;
  }
  get hasUnitBattleData() {
    if (this._cachedHasUnitBattleData === undefined) {
      if (this._value.hasUnitBattleData) {
        this._cachedHasUnitBattleData = true;
      } else {
        this._cachedHasUnitBattleData = this._parent ? this._parent.hasUnitBattleData : false;
      }
    }
    return this._cachedHasUnitBattleData;
  }
  get unitBattleData() {
    if (!this._cachedUnitBattleData) {
      if (this._value.hasUnitBattleData) {
        this._cachedUnitBattleData = new UnitBattleData.WithParent(this._value.unitBattleData, this._parent && this._parent.hasUnitBattleData ? this._parent.unitBattleData : null);
      } else {
        this._cachedUnitBattleData = this._parent ? new UnitBattleData.WithParent(UnitBattleData.default, this._parent.unitBattleData) : UnitBattleData.WithParent.default;
      }
    }
    return this._cachedUnitBattleData;
  }
  update(current, parent) {
    const result = new BehaviorComponent_BehaviorTdTypes_WithParent(current, parent);
    if (this._cachedUnitBattleData && this._value.hasUnitBattleData && current.hasUnitBattleData) {
      if (this._value.unitBattleData === current.unitBattleData && this._parent === parent) {
        result._cachedUnitBattleData = this._cachedUnitBattleData;
      } else {
        result._cachedUnitBattleData = this._cachedUnitBattleData.update(current.unitBattleData, parent && parent.hasUnitBattleData ? parent.unitBattleData : null);
      }
    }
    return result;
  }
}
BehaviorComponent_BehaviorTdTypes_WithParent.default = new BehaviorComponent_BehaviorTdTypes_WithParent(BehaviorComponent_BehaviorTdTypes.default, null);
BehaviorComponent_BehaviorTdTypes.WithParent = BehaviorComponent_BehaviorTdTypes_WithParent;
class BehaviorComponent_BehaviorTdTypes_Descriptor {
  get behaviorType() {
    if (!this._behaviorType) {
      this._behaviorType = {
        name: "behaviorType",
        Name: "BehaviorType",
        number: 1,
        protoType: 14,
        protoName: "behavior_type",
        type: BehaviorComponent_BehaviorType,
        options: {
          comments: "The unit will wait for this duration before wandering to a new location.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behaviorType;
  }
  get unitBattleData() {
    if (!this._unitBattleData) {
      this._unitBattleData = {
        name: "unitBattleData",
        Name: "UnitBattleData",
        number: 2,
        protoType: 11,
        protoName: "unit_battle_data",
        type: UnitBattleData,
        options: {
          comments: "The unit will wander within this radius.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitBattleData;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.behaviorType,
        this.unitBattleData,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForBehaviorType",
        Name: "DummyOneofForBehaviorType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitBattleData",
        Name: "DummyOneofForUnitBattleData",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
BehaviorComponent_BehaviorTdTypes.descriptor = new BehaviorComponent_BehaviorTdTypes_Descriptor();
class BehaviorComponent_BehaviorType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "DO_NOTHING": return 0;
        case "GENERIC_CONTROLLABLE_UNIT": return 1;
        case "TD_HERO": return 2;
        case "TD_HERO_PET": return 3;
        case "TD_TOWER": return 4;
        case "TD_TOWER_TROOP": return 5;
        case "TD_CREEP": return 6;
        case "TD_CREEP_AGGRESSIVE": return 7;
        case "TD_CreepNoEngage": return 8;
        case "TD_JUNGLE_CREEP": return 9;
        case "TD_SHIP": return 10;
        case "TD_SUMMONED_TROOP": return 11;
        case "WANDER": return 12;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return BehaviorComponent_BehaviorType.fromJson(value);
  }
  static fromReact(e) {
    return BehaviorComponent_BehaviorType.fromJson(e);
  }
}
BehaviorComponent_BehaviorType.DO_NOTHING = 0;
BehaviorComponent_BehaviorType.GENERIC_CONTROLLABLE_UNIT = 1;
BehaviorComponent_BehaviorType.TD_HERO = 2;
BehaviorComponent_BehaviorType.TD_HERO_PET = 3;
BehaviorComponent_BehaviorType.TD_TOWER = 4;
BehaviorComponent_BehaviorType.TD_TOWER_TROOP = 5;
BehaviorComponent_BehaviorType.TD_CREEP = 6;
BehaviorComponent_BehaviorType.TD_CREEP_AGGRESSIVE = 7;
BehaviorComponent_BehaviorType.TD_CreepNoEngage = 8;
BehaviorComponent_BehaviorType.TD_JUNGLE_CREEP = 9;
BehaviorComponent_BehaviorType.TD_SHIP = 10;
BehaviorComponent_BehaviorType.TD_SUMMONED_TROOP = 11;
BehaviorComponent_BehaviorType.WANDER = 12;
BehaviorComponent_BehaviorType.default = 0;
BehaviorComponent_BehaviorType.values = {
  DO_NOTHING: 0,
  GENERIC_CONTROLLABLE_UNIT: 1,
  TD_HERO: 2,
  TD_HERO_PET: 3,
  TD_TOWER: 4,
  TD_TOWER_TROOP: 5,
  TD_CREEP: 6,
  TD_CREEP_AGGRESSIVE: 7,
  TD_CreepNoEngage: 8,
  TD_JUNGLE_CREEP: 9,
  TD_SHIP: 10,
  TD_SUMMONED_TROOP: 11,
  WANDER: 12,
};
BehaviorComponent_BehaviorType.names = {
  0: "DO_NOTHING",
  1: "GENERIC_CONTROLLABLE_UNIT",
  2: "TD_HERO",
  3: "TD_HERO_PET",
  4: "TD_TOWER",
  5: "TD_TOWER_TROOP",
  6: "TD_CREEP",
  7: "TD_CREEP_AGGRESSIVE",
  8: "TD_CreepNoEngage",
  9: "TD_JUNGLE_CREEP",
  10: "TD_SHIP",
  11: "TD_SUMMONED_TROOP",
  12: "WANDER",
};
export class BehaviorComponent {
  get descriptor() {
    return BehaviorComponent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasBehaviorType = false;
    this._behaviorType = null;
    this._oneofBehaviorTypeCase = 0;
    this._oneofBehaviorTypeValue = null;
  }
  isEmpty() {
    if (this._hasBehaviorType) return false;
    if (this._oneofBehaviorTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof BehaviorComponent) {
      return value;
    }
    return BehaviorComponent.fromJson(value);
  }
  static fromJson(json) {
    const result = new BehaviorComponent();
    if (json.behaviorType != null) {
      result._hasBehaviorType = true;
      result._behaviorType = BehaviorComponent_BehaviorType.fromJson(json.behaviorType);
    }
    if (json.doNothing != null) {
      result._oneofBehaviorTypeCase = 2;
      result._oneofBehaviorTypeValue = BehaviorComponent_BehaviorDoNothing.fromJson(json.doNothing);
    }
    if (json.genericControllableUnit != null) {
      result._oneofBehaviorTypeCase = 3;
      result._oneofBehaviorTypeValue = BehaviorComponent_BehaviorGenericControllableUnit.fromJson(json.genericControllableUnit);
    }
    if (json.wander != null) {
      result._oneofBehaviorTypeCase = 4;
      result._oneofBehaviorTypeValue = BehaviorComponent_BehaviorWander.fromJson(json.wander);
    }
    if (json.tdTypes != null) {
      result._oneofBehaviorTypeCase = 101;
      result._oneofBehaviorTypeValue = BehaviorComponent_BehaviorTdTypes.fromJson(json.tdTypes);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasBehaviorType) {
      result.behaviorType = BehaviorComponent_BehaviorType.toJson(this._behaviorType);
    }
    switch (this._oneofBehaviorTypeCase) {
      case 2:
        result.doNothing = BehaviorComponent_BehaviorDoNothing.toJson(this._oneofBehaviorTypeValue);
        break;
      case 3:
        result.genericControllableUnit = BehaviorComponent_BehaviorGenericControllableUnit.toJson(this._oneofBehaviorTypeValue);
        break;
      case 4:
        result.wander = BehaviorComponent_BehaviorWander.toJson(this._oneofBehaviorTypeValue);
        break;
      case 101:
        result.tdTypes = BehaviorComponent_BehaviorTdTypes.toJson(this._oneofBehaviorTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get behaviorType() {
    return this._hasBehaviorType ? this._behaviorType : BehaviorComponent_BehaviorType.default;
  }
  get hasBehaviorType() {
    return this._hasBehaviorType;
  }
  setBehaviorType(path, value) {
    return {type: 'SET', path: path.concat(['behaviorType']), value};
  }
  deleteBehaviorType(path) {
    return {type: 'DELETE', path: path.concat(['behaviorType'])};
  }
  get oneofBehaviorTypeCase() {
    return this._oneofBehaviorTypeCase;
  }
  deleteOneofBehaviorType(path) {
    switch (this._oneofBehaviorTypeCase) {
      default:
      case 2: {
        return {type: 'DELETE', path: path.concat(['doNothing'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['genericControllableUnit'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['wander'])};
      }
      case 101: {
        return {type: 'DELETE', path: path.concat(['tdTypes'])};
      }
    }
  }
  /**
   * @returns {BehaviorComponent_BehaviorDoNothing}
   */
  get doNothing() {
    return this._oneofBehaviorTypeCase === 2 ? this._oneofBehaviorTypeValue : BehaviorComponent_BehaviorDoNothing.default;
  }
  setDoNothing(path, value) {
    return {type: 'SET', path: path.concat(['doNothing']), value: value.toJson()};
  }
  deleteDoNothing(path) {
    return {type: 'DELETE', path: path.concat(['doNothing'])};
  }
  /**
   * @returns {BehaviorComponent_BehaviorGenericControllableUnit}
   */
  get genericControllableUnit() {
    return this._oneofBehaviorTypeCase === 3 ? this._oneofBehaviorTypeValue : BehaviorComponent_BehaviorGenericControllableUnit.default;
  }
  setGenericControllableUnit(path, value) {
    return {type: 'SET', path: path.concat(['genericControllableUnit']), value: value.toJson()};
  }
  deleteGenericControllableUnit(path) {
    return {type: 'DELETE', path: path.concat(['genericControllableUnit'])};
  }
  /**
   * @returns {BehaviorComponent_BehaviorWander}
   */
  get wander() {
    return this._oneofBehaviorTypeCase === 4 ? this._oneofBehaviorTypeValue : BehaviorComponent_BehaviorWander.default;
  }
  setWander(path, value) {
    return {type: 'SET', path: path.concat(['wander']), value: value.toJson()};
  }
  deleteWander(path) {
    return {type: 'DELETE', path: path.concat(['wander'])};
  }
  /**
   * @returns {BehaviorComponent_BehaviorTdTypes}
   */
  get tdTypes() {
    return this._oneofBehaviorTypeCase === 101 ? this._oneofBehaviorTypeValue : BehaviorComponent_BehaviorTdTypes.default;
  }
  setTdTypes(path, value) {
    return {type: 'SET', path: path.concat(['tdTypes']), value: value.toJson()};
  }
  deleteTdTypes(path) {
    return {type: 'DELETE', path: path.concat(['tdTypes'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "behaviorType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorComponent(this);
              copy._hasBehaviorType = true;
              copy._behaviorType = BehaviorComponent_BehaviorType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBehaviorType) {
                return this;
              }
              const copy = new BehaviorComponent(this);
              copy._hasBehaviorType = false;
              copy._behaviorType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "doNothing": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorComponent(this);
              copy._oneofBehaviorTypeCase = 2;
              copy._oneofBehaviorTypeValue = BehaviorComponent_BehaviorDoNothing.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofBehaviorTypeCase !== 2) {
                return this;
              }
              const copy = new BehaviorComponent(this);
              copy._oneofBehaviorTypeCase = 0;
              copy._oneofBehaviorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofBehaviorTypeCase !== 2) {
            const copy = new BehaviorComponent(this);
            copy._oneofBehaviorTypeCase = 2;
            copy._oneofBehaviorTypeValue = BehaviorComponent_BehaviorDoNothing.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.doNothing.apply(type, path.slice(1), value);
          if (newValue === this.doNothing) {
            return this;
          }
          const copy = new BehaviorComponent(this);
          copy._oneofBehaviorTypeCase = 2;
          copy._oneofBehaviorTypeValue = newValue;
          return copy;
        }
      }
      case "genericControllableUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorComponent(this);
              copy._oneofBehaviorTypeCase = 3;
              copy._oneofBehaviorTypeValue = BehaviorComponent_BehaviorGenericControllableUnit.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofBehaviorTypeCase !== 3) {
                return this;
              }
              const copy = new BehaviorComponent(this);
              copy._oneofBehaviorTypeCase = 0;
              copy._oneofBehaviorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofBehaviorTypeCase !== 3) {
            const copy = new BehaviorComponent(this);
            copy._oneofBehaviorTypeCase = 3;
            copy._oneofBehaviorTypeValue = BehaviorComponent_BehaviorGenericControllableUnit.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.genericControllableUnit.apply(type, path.slice(1), value);
          if (newValue === this.genericControllableUnit) {
            return this;
          }
          const copy = new BehaviorComponent(this);
          copy._oneofBehaviorTypeCase = 3;
          copy._oneofBehaviorTypeValue = newValue;
          return copy;
        }
      }
      case "wander": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorComponent(this);
              copy._oneofBehaviorTypeCase = 4;
              copy._oneofBehaviorTypeValue = BehaviorComponent_BehaviorWander.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofBehaviorTypeCase !== 4) {
                return this;
              }
              const copy = new BehaviorComponent(this);
              copy._oneofBehaviorTypeCase = 0;
              copy._oneofBehaviorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofBehaviorTypeCase !== 4) {
            const copy = new BehaviorComponent(this);
            copy._oneofBehaviorTypeCase = 4;
            copy._oneofBehaviorTypeValue = BehaviorComponent_BehaviorWander.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.wander.apply(type, path.slice(1), value);
          if (newValue === this.wander) {
            return this;
          }
          const copy = new BehaviorComponent(this);
          copy._oneofBehaviorTypeCase = 4;
          copy._oneofBehaviorTypeValue = newValue;
          return copy;
        }
      }
      case "tdTypes": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BehaviorComponent(this);
              copy._oneofBehaviorTypeCase = 101;
              copy._oneofBehaviorTypeValue = BehaviorComponent_BehaviorTdTypes.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofBehaviorTypeCase !== 101) {
                return this;
              }
              const copy = new BehaviorComponent(this);
              copy._oneofBehaviorTypeCase = 0;
              copy._oneofBehaviorTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofBehaviorTypeCase !== 101) {
            const copy = new BehaviorComponent(this);
            copy._oneofBehaviorTypeCase = 101;
            copy._oneofBehaviorTypeValue = BehaviorComponent_BehaviorTdTypes.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.tdTypes.apply(type, path.slice(1), value);
          if (newValue === this.tdTypes) {
            return this;
          }
          const copy = new BehaviorComponent(this);
          copy._oneofBehaviorTypeCase = 101;
          copy._oneofBehaviorTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {BehaviorComponent} other
   * @returns {BehaviorComponent}
   */
  merge(other) {
    const copy = new BehaviorComponent(this);
    if (other._hasBehaviorType) {
      copy._hasBehaviorType = true;
      copy._behaviorType = other._behaviorType;
    }
    if (other._oneofBehaviorTypeCase === 2) {
      if (this._oneofBehaviorTypeCase === 2) {
        copy._oneofBehaviorTypeValue = copy._oneofBehaviorTypeValue.merge(other._oneofBehaviorTypeValue);
      } else {
        copy._oneofBehaviorTypeValue = other._oneofBehaviorTypeValue;
      }
      copy._oneofBehaviorTypeCase = 2;
    }
    if (other._oneofBehaviorTypeCase === 2) {
      if (this._oneofBehaviorTypeCase === 2) {
        copy._oneofBehaviorTypeValue = copy._oneofBehaviorTypeValue.merge(other._oneofBehaviorTypeValue);
      } else {
        copy._oneofBehaviorTypeValue = other._oneofBehaviorTypeValue;
      }
      copy._oneofBehaviorTypeCase = 2;
    }
    if (other._oneofBehaviorTypeCase === 2) {
      if (this._oneofBehaviorTypeCase === 2) {
        copy._oneofBehaviorTypeValue = copy._oneofBehaviorTypeValue.merge(other._oneofBehaviorTypeValue);
      } else {
        copy._oneofBehaviorTypeValue = other._oneofBehaviorTypeValue;
      }
      copy._oneofBehaviorTypeCase = 2;
    }
    if (other._oneofBehaviorTypeCase === 2) {
      if (this._oneofBehaviorTypeCase === 2) {
        copy._oneofBehaviorTypeValue = copy._oneofBehaviorTypeValue.merge(other._oneofBehaviorTypeValue);
      } else {
        copy._oneofBehaviorTypeValue = other._oneofBehaviorTypeValue;
      }
      copy._oneofBehaviorTypeCase = 2;
    }
    return copy;
  }
}
BehaviorComponent.default = new BehaviorComponent();
BehaviorComponent.BehaviorDoNothing = BehaviorComponent_BehaviorDoNothing;
BehaviorComponent.BehaviorGenericControllableUnit = BehaviorComponent_BehaviorGenericControllableUnit;
BehaviorComponent.BehaviorWander = BehaviorComponent_BehaviorWander;
BehaviorComponent.BehaviorTdTypes = BehaviorComponent_BehaviorTdTypes;
BehaviorComponent.BehaviorType = BehaviorComponent_BehaviorType;
class BehaviorComponent_Builder {
  constructor(value) {
    this._value = new BehaviorComponent(value);
  }
  build() {
    return new BehaviorComponent(this._value);
  }
  setBehaviorType(value) {
    this._value._hasBehaviorType = true;
    this._value._behaviorType = value;
    return this;
  }
  deleteBehaviorType() {
    this._value._hasBehaviorType = false;
    this._value._behaviorType = null;
    return this;
  }
  clearoneofBehaviorType() {
    this._value._oneofBehaviorTypeCase = 0;
    this._value._oneofBehaviorTypeValue = null;
    return this;
  }
  setDoNothing(value) {
    this._value._oneofBehaviorTypeCase = 2;
    this._value._oneofBehaviorTypeValue = value;
    return this;
  }
  setGenericControllableUnit(value) {
    this._value._oneofBehaviorTypeCase = 3;
    this._value._oneofBehaviorTypeValue = value;
    return this;
  }
  setWander(value) {
    this._value._oneofBehaviorTypeCase = 4;
    this._value._oneofBehaviorTypeValue = value;
    return this;
  }
  setTdTypes(value) {
    this._value._oneofBehaviorTypeCase = 101;
    this._value._oneofBehaviorTypeValue = value;
    return this;
  }
}
BehaviorComponent.Builder = BehaviorComponent_Builder;
class BehaviorComponent_WithParent {
  /**
   * @param {BehaviorComponent} value
   * @param {BehaviorComponent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return BehaviorComponent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasBehaviorType() {
    if (this._cachedHasBehaviorType === undefined) {
      if (this._value.hasBehaviorType) {
        this._cachedHasBehaviorType = true;
      } else {
        this._cachedHasBehaviorType = this._parent ? this._parent.hasBehaviorType : false;
      }
    }
    return this._cachedHasBehaviorType;
  }
  get behaviorType() {
    if (this._cachedBehaviorType === undefined) {
      if (this._value.hasBehaviorType) {
        this._cachedBehaviorType = this._value.behaviorType;
      } else {
        this._cachedBehaviorType = this._parent ? this._parent.behaviorType : this._value.behaviorType;
      }
    }
    return this._cachedBehaviorType;
  }
  get oneofBehaviorTypeCase() {
    if (this._cachedoneofBehaviorTypeCase === undefined) {
      if (this._value._oneofBehaviorTypeCase === 0) {
        this._cachedoneofBehaviorTypeCase = this._parent ? this._parent.oneofBehaviorTypeCase : 0;
      } else {
        this._cachedoneofBehaviorTypeCase = this._value._oneofBehaviorTypeCase;
      }
    }
    return this._cachedoneofBehaviorTypeCase;
  }
  get doNothing() {
    if (!this._cachedDoNothing) {
      if (this._value._oneofBehaviorTypeCase === 0) {
        this._cachedDoNothing = this._parent ? new BehaviorComponent_BehaviorDoNothing.WithParent(BehaviorComponent_BehaviorDoNothing.default, this._parent.doNothing) : this._value.doNothing;
      } else if (this._value._oneofBehaviorTypeCase === 2) {
        this._cachedDoNothing = new BehaviorComponent_BehaviorDoNothing.WithParent(this._value.doNothing, this._parent && this._parent.oneofBehaviorTypeCase === 2 ? this._parent.doNothing : null);
      } else {
        this._cachedDoNothing = BehaviorComponent_BehaviorDoNothing.WithParent.default;
      }
    }
    return this._cachedDoNothing;
  }
  get genericControllableUnit() {
    if (!this._cachedGenericControllableUnit) {
      if (this._value._oneofBehaviorTypeCase === 0) {
        this._cachedGenericControllableUnit = this._parent ? new BehaviorComponent_BehaviorGenericControllableUnit.WithParent(BehaviorComponent_BehaviorGenericControllableUnit.default, this._parent.genericControllableUnit) : this._value.genericControllableUnit;
      } else if (this._value._oneofBehaviorTypeCase === 3) {
        this._cachedGenericControllableUnit = new BehaviorComponent_BehaviorGenericControllableUnit.WithParent(this._value.genericControllableUnit, this._parent && this._parent.oneofBehaviorTypeCase === 3 ? this._parent.genericControllableUnit : null);
      } else {
        this._cachedGenericControllableUnit = BehaviorComponent_BehaviorGenericControllableUnit.WithParent.default;
      }
    }
    return this._cachedGenericControllableUnit;
  }
  get wander() {
    if (!this._cachedWander) {
      if (this._value._oneofBehaviorTypeCase === 0) {
        this._cachedWander = this._parent ? new BehaviorComponent_BehaviorWander.WithParent(BehaviorComponent_BehaviorWander.default, this._parent.wander) : this._value.wander;
      } else if (this._value._oneofBehaviorTypeCase === 4) {
        this._cachedWander = new BehaviorComponent_BehaviorWander.WithParent(this._value.wander, this._parent && this._parent.oneofBehaviorTypeCase === 4 ? this._parent.wander : null);
      } else {
        this._cachedWander = BehaviorComponent_BehaviorWander.WithParent.default;
      }
    }
    return this._cachedWander;
  }
  get tdTypes() {
    if (!this._cachedTdTypes) {
      if (this._value._oneofBehaviorTypeCase === 0) {
        this._cachedTdTypes = this._parent ? new BehaviorComponent_BehaviorTdTypes.WithParent(BehaviorComponent_BehaviorTdTypes.default, this._parent.tdTypes) : this._value.tdTypes;
      } else if (this._value._oneofBehaviorTypeCase === 101) {
        this._cachedTdTypes = new BehaviorComponent_BehaviorTdTypes.WithParent(this._value.tdTypes, this._parent && this._parent.oneofBehaviorTypeCase === 101 ? this._parent.tdTypes : null);
      } else {
        this._cachedTdTypes = BehaviorComponent_BehaviorTdTypes.WithParent.default;
      }
    }
    return this._cachedTdTypes;
  }
  update(current, parent) {
    const result = new BehaviorComponent_WithParent(current, parent);
    if (this._cachedDoNothing && this._value._oneofBehaviorTypeCase === 2 && current._oneofBehaviorTypeCase === 2) {
      if (this._value.doNothing === current.doNothing && this._parent === parent) {
        result._cachedDoNothing = this._cachedDoNothing;
      } else {
        result._cachedDoNothing = this._cachedDoNothing.update(current.doNothing, parent && parent.oneofBehaviorTypeCase === 2 ? parent.doNothing : null);
      }
    }
    if (this._cachedGenericControllableUnit && this._value._oneofBehaviorTypeCase === 3 && current._oneofBehaviorTypeCase === 3) {
      if (this._value.genericControllableUnit === current.genericControllableUnit && this._parent === parent) {
        result._cachedGenericControllableUnit = this._cachedGenericControllableUnit;
      } else {
        result._cachedGenericControllableUnit = this._cachedGenericControllableUnit.update(current.genericControllableUnit, parent && parent.oneofBehaviorTypeCase === 3 ? parent.genericControllableUnit : null);
      }
    }
    if (this._cachedWander && this._value._oneofBehaviorTypeCase === 4 && current._oneofBehaviorTypeCase === 4) {
      if (this._value.wander === current.wander && this._parent === parent) {
        result._cachedWander = this._cachedWander;
      } else {
        result._cachedWander = this._cachedWander.update(current.wander, parent && parent.oneofBehaviorTypeCase === 4 ? parent.wander : null);
      }
    }
    if (this._cachedTdTypes && this._value._oneofBehaviorTypeCase === 101 && current._oneofBehaviorTypeCase === 101) {
      if (this._value.tdTypes === current.tdTypes && this._parent === parent) {
        result._cachedTdTypes = this._cachedTdTypes;
      } else {
        result._cachedTdTypes = this._cachedTdTypes.update(current.tdTypes, parent && parent.oneofBehaviorTypeCase === 101 ? parent.tdTypes : null);
      }
    }
    return result;
  }
}
BehaviorComponent_WithParent.default = new BehaviorComponent_WithParent(BehaviorComponent.default, null);
BehaviorComponent.WithParent = BehaviorComponent_WithParent;
class BehaviorComponent_Descriptor {
  get behaviorType() {
    if (!this._behaviorType) {
      this._behaviorType = {
        name: "behaviorType",
        Name: "BehaviorType",
        number: 1,
        protoType: 14,
        protoName: "behavior_type",
        type: BehaviorComponent_BehaviorType,
        options: {
          deprecated: {date: '2020-11-5', reason: 'Use new behavior instead.'},
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behaviorType;
  }
  get doNothing() {
    if (!this._doNothing) {
      this._doNothing = {
        name: "doNothing",
        Name: "DoNothing",
        number: 2,
        protoType: 11,
        protoName: "do_nothing",
        oneofIndex: 1,
        type: BehaviorComponent_BehaviorDoNothing,
        options: {
          comments: "The unit will have no AI behavior. This causes the unit to be unable to move, attack, or otherwise accept commands.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._doNothing;
  }
  get genericControllableUnit() {
    if (!this._genericControllableUnit) {
      this._genericControllableUnit = {
        name: "genericControllableUnit",
        Name: "GenericControllableUnit",
        number: 3,
        protoType: 11,
        protoName: "generic_controllable_unit",
        oneofIndex: 1,
        type: BehaviorComponent_BehaviorGenericControllableUnit,
        options: {
          comments: "The unit will use the basic AI behavior and accept commands. Generic controllable units with weapons will attempt to attack valid targets in range.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._genericControllableUnit;
  }
  get wander() {
    if (!this._wander) {
      this._wander = {
        name: "wander",
        Name: "Wander",
        number: 4,
        protoType: 11,
        protoName: "wander",
        oneofIndex: 1,
        type: BehaviorComponent_BehaviorWander,
        options: {
          comments: "The unit will wander aimlessly. Useful for villagers or critters.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._wander;
  }
  get tdTypes() {
    if (!this._tdTypes) {
      this._tdTypes = {
        name: "tdTypes",
        Name: "TdTypes",
        number: 101,
        protoType: 11,
        protoName: "td_types",
        oneofIndex: 1,
        type: BehaviorComponent_BehaviorTdTypes,
        options: {
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tdTypes;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.behaviorType,
        this.doNothing,
        this.genericControllableUnit,
        this.wander,
        this.tdTypes,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForBehaviorType",
        Name: "DummyOneofForBehaviorType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "oneofBehaviorType",
        Name: "OneofBehaviorType",
        fields: [
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
BehaviorComponent.descriptor = new BehaviorComponent_Descriptor();
export class ManaComponent {
  get descriptor() {
    return ManaComponent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMaxMana = false;
    this._maxMana = null;
    this._hasStartMana = false;
    this._startMana = null;
    this._hasRegeneration = false;
    this._regeneration = null;
    this._hasRegenerationDelay = false;
    this._regenerationDelay = null;
  }
  isEmpty() {
    if (this._hasMaxMana) return false;
    if (this._hasStartMana) return false;
    if (this._hasRegeneration) return false;
    if (this._hasRegenerationDelay) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ManaComponent) {
      return value;
    }
    return ManaComponent.fromJson(value);
  }
  static fromJson(json) {
    const result = new ManaComponent();
    if (json.maxMana != null) {
      result._hasMaxMana = true;
      result._maxMana = JsonToInt32.fromJson(json.maxMana);
    }
    if (json.startMana != null) {
      result._hasStartMana = true;
      result._startMana = JsonToInt32.fromJson(json.startMana);
    }
    if (json.regeneration != null) {
      result._hasRegeneration = true;
      result._regeneration = JsonToDouble.fromJson(json.regeneration);
    }
    if (json.regenerationDelay != null) {
      result._hasRegenerationDelay = true;
      result._regenerationDelay = JsonToDouble.fromJson(json.regenerationDelay);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMaxMana) {
      result.maxMana = JsonToInt32.toJson(this._maxMana);
    }
    if (this._hasStartMana) {
      result.startMana = JsonToInt32.toJson(this._startMana);
    }
    if (this._hasRegeneration) {
      result.regeneration = JsonToDouble.toJson(this._regeneration);
    }
    if (this._hasRegenerationDelay) {
      result.regenerationDelay = JsonToDouble.toJson(this._regenerationDelay);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get maxMana() {
    return this._hasMaxMana ? this._maxMana : JsonToInt32.default;
  }
  get hasMaxMana() {
    return this._hasMaxMana;
  }
  setMaxMana(path, value) {
    return {type: 'SET', path: path.concat(['maxMana']), value};
  }
  deleteMaxMana(path) {
    return {type: 'DELETE', path: path.concat(['maxMana'])};
  }
  /**
   * @returns {number}
   */
  get startMana() {
    return this._hasStartMana ? this._startMana : JsonToInt32.default;
  }
  get hasStartMana() {
    return this._hasStartMana;
  }
  setStartMana(path, value) {
    return {type: 'SET', path: path.concat(['startMana']), value};
  }
  deleteStartMana(path) {
    return {type: 'DELETE', path: path.concat(['startMana'])};
  }
  /**
   * @returns {number}
   */
  get regeneration() {
    return this._hasRegeneration ? this._regeneration : JsonToDouble.default;
  }
  get hasRegeneration() {
    return this._hasRegeneration;
  }
  setRegeneration(path, value) {
    return {type: 'SET', path: path.concat(['regeneration']), value};
  }
  deleteRegeneration(path) {
    return {type: 'DELETE', path: path.concat(['regeneration'])};
  }
  /**
   * @returns {number}
   */
  get regenerationDelay() {
    return this._hasRegenerationDelay ? this._regenerationDelay : JsonToDouble.default;
  }
  get hasRegenerationDelay() {
    return this._hasRegenerationDelay;
  }
  setRegenerationDelay(path, value) {
    return {type: 'SET', path: path.concat(['regenerationDelay']), value};
  }
  deleteRegenerationDelay(path) {
    return {type: 'DELETE', path: path.concat(['regenerationDelay'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "maxMana": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ManaComponent(this);
              copy._hasMaxMana = true;
              copy._maxMana = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxMana) {
                return this;
              }
              const copy = new ManaComponent(this);
              copy._hasMaxMana = false;
              copy._maxMana = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "startMana": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ManaComponent(this);
              copy._hasStartMana = true;
              copy._startMana = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartMana) {
                return this;
              }
              const copy = new ManaComponent(this);
              copy._hasStartMana = false;
              copy._startMana = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "regeneration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ManaComponent(this);
              copy._hasRegeneration = true;
              copy._regeneration = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRegeneration) {
                return this;
              }
              const copy = new ManaComponent(this);
              copy._hasRegeneration = false;
              copy._regeneration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "regenerationDelay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ManaComponent(this);
              copy._hasRegenerationDelay = true;
              copy._regenerationDelay = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRegenerationDelay) {
                return this;
              }
              const copy = new ManaComponent(this);
              copy._hasRegenerationDelay = false;
              copy._regenerationDelay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ManaComponent} other
   * @returns {ManaComponent}
   */
  merge(other) {
    const copy = new ManaComponent(this);
    if (other._hasMaxMana) {
      copy._hasMaxMana = true;
      copy._maxMana = other._maxMana;
    }
    if (other._hasStartMana) {
      copy._hasStartMana = true;
      copy._startMana = other._startMana;
    }
    if (other._hasRegeneration) {
      copy._hasRegeneration = true;
      copy._regeneration = other._regeneration;
    }
    if (other._hasRegenerationDelay) {
      copy._hasRegenerationDelay = true;
      copy._regenerationDelay = other._regenerationDelay;
    }
    return copy;
  }
}
ManaComponent.default = new ManaComponent();
class ManaComponent_Builder {
  constructor(value) {
    this._value = new ManaComponent(value);
  }
  build() {
    return new ManaComponent(this._value);
  }
  setMaxMana(value) {
    this._value._hasMaxMana = true;
    this._value._maxMana = value;
    return this;
  }
  deleteMaxMana() {
    this._value._hasMaxMana = false;
    this._value._maxMana = null;
    return this;
  }
  setStartMana(value) {
    this._value._hasStartMana = true;
    this._value._startMana = value;
    return this;
  }
  deleteStartMana() {
    this._value._hasStartMana = false;
    this._value._startMana = null;
    return this;
  }
  setRegeneration(value) {
    this._value._hasRegeneration = true;
    this._value._regeneration = value;
    return this;
  }
  deleteRegeneration() {
    this._value._hasRegeneration = false;
    this._value._regeneration = null;
    return this;
  }
  setRegenerationDelay(value) {
    this._value._hasRegenerationDelay = true;
    this._value._regenerationDelay = value;
    return this;
  }
  deleteRegenerationDelay() {
    this._value._hasRegenerationDelay = false;
    this._value._regenerationDelay = null;
    return this;
  }
}
ManaComponent.Builder = ManaComponent_Builder;
class ManaComponent_WithParent {
  /**
   * @param {ManaComponent} value
   * @param {ManaComponent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ManaComponent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMaxMana() {
    if (this._cachedHasMaxMana === undefined) {
      if (this._value.hasMaxMana) {
        this._cachedHasMaxMana = true;
      } else {
        this._cachedHasMaxMana = this._parent ? this._parent.hasMaxMana : false;
      }
    }
    return this._cachedHasMaxMana;
  }
  get maxMana() {
    if (this._cachedMaxMana === undefined) {
      if (this._value.hasMaxMana) {
        this._cachedMaxMana = this._value.maxMana;
      } else {
        this._cachedMaxMana = this._parent ? this._parent.maxMana : this._value.maxMana;
      }
    }
    return this._cachedMaxMana;
  }
  get hasStartMana() {
    if (this._cachedHasStartMana === undefined) {
      if (this._value.hasStartMana) {
        this._cachedHasStartMana = true;
      } else {
        this._cachedHasStartMana = this._parent ? this._parent.hasStartMana : false;
      }
    }
    return this._cachedHasStartMana;
  }
  get startMana() {
    if (this._cachedStartMana === undefined) {
      if (this._value.hasStartMana) {
        this._cachedStartMana = this._value.startMana;
      } else {
        this._cachedStartMana = this._parent ? this._parent.startMana : this._value.startMana;
      }
    }
    return this._cachedStartMana;
  }
  get hasRegeneration() {
    if (this._cachedHasRegeneration === undefined) {
      if (this._value.hasRegeneration) {
        this._cachedHasRegeneration = true;
      } else {
        this._cachedHasRegeneration = this._parent ? this._parent.hasRegeneration : false;
      }
    }
    return this._cachedHasRegeneration;
  }
  get regeneration() {
    if (this._cachedRegeneration === undefined) {
      if (this._value.hasRegeneration) {
        this._cachedRegeneration = this._value.regeneration;
      } else {
        this._cachedRegeneration = this._parent ? this._parent.regeneration : this._value.regeneration;
      }
    }
    return this._cachedRegeneration;
  }
  get hasRegenerationDelay() {
    if (this._cachedHasRegenerationDelay === undefined) {
      if (this._value.hasRegenerationDelay) {
        this._cachedHasRegenerationDelay = true;
      } else {
        this._cachedHasRegenerationDelay = this._parent ? this._parent.hasRegenerationDelay : false;
      }
    }
    return this._cachedHasRegenerationDelay;
  }
  get regenerationDelay() {
    if (this._cachedRegenerationDelay === undefined) {
      if (this._value.hasRegenerationDelay) {
        this._cachedRegenerationDelay = this._value.regenerationDelay;
      } else {
        this._cachedRegenerationDelay = this._parent ? this._parent.regenerationDelay : this._value.regenerationDelay;
      }
    }
    return this._cachedRegenerationDelay;
  }
  update(current, parent) {
    const result = new ManaComponent_WithParent(current, parent);
    return result;
  }
}
ManaComponent_WithParent.default = new ManaComponent_WithParent(ManaComponent.default, null);
ManaComponent.WithParent = ManaComponent_WithParent;
class ManaComponent_Descriptor {
  get maxMana() {
    if (!this._maxMana) {
      this._maxMana = {
        name: "maxMana",
        Name: "MaxMana",
        number: 1,
        protoType: 5,
        protoName: "max_mana",
        type: JsonToInt32,
        options: {
          comments: "The maximum mana of the unit.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxMana;
  }
  get startMana() {
    if (!this._startMana) {
      this._startMana = {
        name: "startMana",
        Name: "StartMana",
        number: 2,
        protoType: 5,
        protoName: "start_mana",
        type: JsonToInt32,
        options: {
          comments: "The starting mana of the unit. By default this will use the **Max Mana** value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startMana;
  }
  get regeneration() {
    if (!this._regeneration) {
      this._regeneration = {
        name: "regeneration",
        Name: "Regeneration",
        number: 3,
        protoType: 1,
        protoName: "regeneration",
        type: JsonToDouble,
        options: {
          comments: "The amount of mana the unit regenerates per second.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._regeneration;
  }
  get regenerationDelay() {
    if (!this._regenerationDelay) {
      this._regenerationDelay = {
        name: "regenerationDelay",
        Name: "RegenerationDelay",
        number: 4,
        protoType: 1,
        protoName: "regeneration_delay",
        type: JsonToDouble,
        options: {
          comments: "The delay after the spends mana before it begins regenerating mana.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._regenerationDelay;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.maxMana,
        this.startMana,
        this.regeneration,
        this.regenerationDelay,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMaxMana",
        Name: "DummyOneofForMaxMana",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStartMana",
        Name: "DummyOneofForStartMana",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRegeneration",
        Name: "DummyOneofForRegeneration",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRegenerationDelay",
        Name: "DummyOneofForRegenerationDelay",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
ManaComponent.descriptor = new ManaComponent_Descriptor();
export class ShieldComponent {
  get descriptor() {
    return ShieldComponent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMaxShield = false;
    this._maxShield = null;
    this._hasStartShield = false;
    this._startShield = null;
    this._hasRegeneration = false;
    this._regeneration = null;
    this._hasRegenerationDelay = false;
    this._regenerationDelay = null;
  }
  isEmpty() {
    if (this._hasMaxShield) return false;
    if (this._hasStartShield) return false;
    if (this._hasRegeneration) return false;
    if (this._hasRegenerationDelay) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ShieldComponent) {
      return value;
    }
    return ShieldComponent.fromJson(value);
  }
  static fromJson(json) {
    const result = new ShieldComponent();
    if (json.maxShield != null) {
      result._hasMaxShield = true;
      result._maxShield = JsonToInt32.fromJson(json.maxShield);
    }
    if (json.startShield != null) {
      result._hasStartShield = true;
      result._startShield = JsonToInt32.fromJson(json.startShield);
    }
    if (json.regeneration != null) {
      result._hasRegeneration = true;
      result._regeneration = JsonToDouble.fromJson(json.regeneration);
    }
    if (json.regenerationDelay != null) {
      result._hasRegenerationDelay = true;
      result._regenerationDelay = JsonToDouble.fromJson(json.regenerationDelay);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMaxShield) {
      result.maxShield = JsonToInt32.toJson(this._maxShield);
    }
    if (this._hasStartShield) {
      result.startShield = JsonToInt32.toJson(this._startShield);
    }
    if (this._hasRegeneration) {
      result.regeneration = JsonToDouble.toJson(this._regeneration);
    }
    if (this._hasRegenerationDelay) {
      result.regenerationDelay = JsonToDouble.toJson(this._regenerationDelay);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get maxShield() {
    return this._hasMaxShield ? this._maxShield : JsonToInt32.default;
  }
  get hasMaxShield() {
    return this._hasMaxShield;
  }
  setMaxShield(path, value) {
    return {type: 'SET', path: path.concat(['maxShield']), value};
  }
  deleteMaxShield(path) {
    return {type: 'DELETE', path: path.concat(['maxShield'])};
  }
  /**
   * @returns {number}
   */
  get startShield() {
    return this._hasStartShield ? this._startShield : JsonToInt32.default;
  }
  get hasStartShield() {
    return this._hasStartShield;
  }
  setStartShield(path, value) {
    return {type: 'SET', path: path.concat(['startShield']), value};
  }
  deleteStartShield(path) {
    return {type: 'DELETE', path: path.concat(['startShield'])};
  }
  /**
   * @returns {number}
   */
  get regeneration() {
    return this._hasRegeneration ? this._regeneration : JsonToDouble.default;
  }
  get hasRegeneration() {
    return this._hasRegeneration;
  }
  setRegeneration(path, value) {
    return {type: 'SET', path: path.concat(['regeneration']), value};
  }
  deleteRegeneration(path) {
    return {type: 'DELETE', path: path.concat(['regeneration'])};
  }
  /**
   * @returns {number}
   */
  get regenerationDelay() {
    return this._hasRegenerationDelay ? this._regenerationDelay : JsonToDouble.default;
  }
  get hasRegenerationDelay() {
    return this._hasRegenerationDelay;
  }
  setRegenerationDelay(path, value) {
    return {type: 'SET', path: path.concat(['regenerationDelay']), value};
  }
  deleteRegenerationDelay(path) {
    return {type: 'DELETE', path: path.concat(['regenerationDelay'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "maxShield": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShieldComponent(this);
              copy._hasMaxShield = true;
              copy._maxShield = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxShield) {
                return this;
              }
              const copy = new ShieldComponent(this);
              copy._hasMaxShield = false;
              copy._maxShield = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "startShield": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShieldComponent(this);
              copy._hasStartShield = true;
              copy._startShield = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartShield) {
                return this;
              }
              const copy = new ShieldComponent(this);
              copy._hasStartShield = false;
              copy._startShield = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "regeneration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShieldComponent(this);
              copy._hasRegeneration = true;
              copy._regeneration = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRegeneration) {
                return this;
              }
              const copy = new ShieldComponent(this);
              copy._hasRegeneration = false;
              copy._regeneration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "regenerationDelay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShieldComponent(this);
              copy._hasRegenerationDelay = true;
              copy._regenerationDelay = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRegenerationDelay) {
                return this;
              }
              const copy = new ShieldComponent(this);
              copy._hasRegenerationDelay = false;
              copy._regenerationDelay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ShieldComponent} other
   * @returns {ShieldComponent}
   */
  merge(other) {
    const copy = new ShieldComponent(this);
    if (other._hasMaxShield) {
      copy._hasMaxShield = true;
      copy._maxShield = other._maxShield;
    }
    if (other._hasStartShield) {
      copy._hasStartShield = true;
      copy._startShield = other._startShield;
    }
    if (other._hasRegeneration) {
      copy._hasRegeneration = true;
      copy._regeneration = other._regeneration;
    }
    if (other._hasRegenerationDelay) {
      copy._hasRegenerationDelay = true;
      copy._regenerationDelay = other._regenerationDelay;
    }
    return copy;
  }
}
ShieldComponent.default = new ShieldComponent();
class ShieldComponent_Builder {
  constructor(value) {
    this._value = new ShieldComponent(value);
  }
  build() {
    return new ShieldComponent(this._value);
  }
  setMaxShield(value) {
    this._value._hasMaxShield = true;
    this._value._maxShield = value;
    return this;
  }
  deleteMaxShield() {
    this._value._hasMaxShield = false;
    this._value._maxShield = null;
    return this;
  }
  setStartShield(value) {
    this._value._hasStartShield = true;
    this._value._startShield = value;
    return this;
  }
  deleteStartShield() {
    this._value._hasStartShield = false;
    this._value._startShield = null;
    return this;
  }
  setRegeneration(value) {
    this._value._hasRegeneration = true;
    this._value._regeneration = value;
    return this;
  }
  deleteRegeneration() {
    this._value._hasRegeneration = false;
    this._value._regeneration = null;
    return this;
  }
  setRegenerationDelay(value) {
    this._value._hasRegenerationDelay = true;
    this._value._regenerationDelay = value;
    return this;
  }
  deleteRegenerationDelay() {
    this._value._hasRegenerationDelay = false;
    this._value._regenerationDelay = null;
    return this;
  }
}
ShieldComponent.Builder = ShieldComponent_Builder;
class ShieldComponent_WithParent {
  /**
   * @param {ShieldComponent} value
   * @param {ShieldComponent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ShieldComponent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMaxShield() {
    if (this._cachedHasMaxShield === undefined) {
      if (this._value.hasMaxShield) {
        this._cachedHasMaxShield = true;
      } else {
        this._cachedHasMaxShield = this._parent ? this._parent.hasMaxShield : false;
      }
    }
    return this._cachedHasMaxShield;
  }
  get maxShield() {
    if (this._cachedMaxShield === undefined) {
      if (this._value.hasMaxShield) {
        this._cachedMaxShield = this._value.maxShield;
      } else {
        this._cachedMaxShield = this._parent ? this._parent.maxShield : this._value.maxShield;
      }
    }
    return this._cachedMaxShield;
  }
  get hasStartShield() {
    if (this._cachedHasStartShield === undefined) {
      if (this._value.hasStartShield) {
        this._cachedHasStartShield = true;
      } else {
        this._cachedHasStartShield = this._parent ? this._parent.hasStartShield : false;
      }
    }
    return this._cachedHasStartShield;
  }
  get startShield() {
    if (this._cachedStartShield === undefined) {
      if (this._value.hasStartShield) {
        this._cachedStartShield = this._value.startShield;
      } else {
        this._cachedStartShield = this._parent ? this._parent.startShield : this._value.startShield;
      }
    }
    return this._cachedStartShield;
  }
  get hasRegeneration() {
    if (this._cachedHasRegeneration === undefined) {
      if (this._value.hasRegeneration) {
        this._cachedHasRegeneration = true;
      } else {
        this._cachedHasRegeneration = this._parent ? this._parent.hasRegeneration : false;
      }
    }
    return this._cachedHasRegeneration;
  }
  get regeneration() {
    if (this._cachedRegeneration === undefined) {
      if (this._value.hasRegeneration) {
        this._cachedRegeneration = this._value.regeneration;
      } else {
        this._cachedRegeneration = this._parent ? this._parent.regeneration : this._value.regeneration;
      }
    }
    return this._cachedRegeneration;
  }
  get hasRegenerationDelay() {
    if (this._cachedHasRegenerationDelay === undefined) {
      if (this._value.hasRegenerationDelay) {
        this._cachedHasRegenerationDelay = true;
      } else {
        this._cachedHasRegenerationDelay = this._parent ? this._parent.hasRegenerationDelay : false;
      }
    }
    return this._cachedHasRegenerationDelay;
  }
  get regenerationDelay() {
    if (this._cachedRegenerationDelay === undefined) {
      if (this._value.hasRegenerationDelay) {
        this._cachedRegenerationDelay = this._value.regenerationDelay;
      } else {
        this._cachedRegenerationDelay = this._parent ? this._parent.regenerationDelay : this._value.regenerationDelay;
      }
    }
    return this._cachedRegenerationDelay;
  }
  update(current, parent) {
    const result = new ShieldComponent_WithParent(current, parent);
    return result;
  }
}
ShieldComponent_WithParent.default = new ShieldComponent_WithParent(ShieldComponent.default, null);
ShieldComponent.WithParent = ShieldComponent_WithParent;
class ShieldComponent_Descriptor {
  get maxShield() {
    if (!this._maxShield) {
      this._maxShield = {
        name: "maxShield",
        Name: "MaxShield",
        number: 1,
        protoType: 5,
        protoName: "max_shield",
        type: JsonToInt32,
        options: {
          comments: "The maximum shields of the unit.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxShield;
  }
  get startShield() {
    if (!this._startShield) {
      this._startShield = {
        name: "startShield",
        Name: "StartShield",
        number: 2,
        protoType: 5,
        protoName: "start_shield",
        type: JsonToInt32,
        options: {
          comments: "The starting shields of the unit. By default this will use the **Max Shield** value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startShield;
  }
  get regeneration() {
    if (!this._regeneration) {
      this._regeneration = {
        name: "regeneration",
        Name: "Regeneration",
        number: 3,
        protoType: 1,
        protoName: "regeneration",
        type: JsonToDouble,
        options: {
          comments: "The amount of shields the unit regenerates per second.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._regeneration;
  }
  get regenerationDelay() {
    if (!this._regenerationDelay) {
      this._regenerationDelay = {
        name: "regenerationDelay",
        Name: "RegenerationDelay",
        number: 4,
        protoType: 1,
        protoName: "regeneration_delay",
        type: JsonToDouble,
        options: {
          comments: "The delay after the unit takes damage before it begins regenerating shields.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._regenerationDelay;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.maxShield,
        this.startShield,
        this.regeneration,
        this.regenerationDelay,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMaxShield",
        Name: "DummyOneofForMaxShield",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStartShield",
        Name: "DummyOneofForStartShield",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRegeneration",
        Name: "DummyOneofForRegeneration",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRegenerationDelay",
        Name: "DummyOneofForRegenerationDelay",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
ShieldComponent.descriptor = new ShieldComponent_Descriptor();
export class UnitBattleData {
  get descriptor() {
    return UnitBattleData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasEnemySearchRange = false;
    this._enemySearchRange = null;
    this._hasEngageRadius = false;
    this._engageRadius = null;
    this._hasResetRadius = false;
    this._resetRadius = null;
    this._hasChaseInDefenseAreaOnly = false;
    this._chaseInDefenseAreaOnly = null;
    this._hasForceRescanPeriod = false;
    this._forceRescanPeriod = null;
  }
  isEmpty() {
    if (this._hasEnemySearchRange) return false;
    if (this._hasEngageRadius) return false;
    if (this._hasResetRadius) return false;
    if (this._hasChaseInDefenseAreaOnly) return false;
    if (this._hasForceRescanPeriod) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UnitBattleData) {
      return value;
    }
    return UnitBattleData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UnitBattleData();
    if (json.enemySearchRange != null) {
      result._hasEnemySearchRange = true;
      result._enemySearchRange = JsonToDouble.fromJson(json.enemySearchRange);
    }
    if (json.engageRadius != null) {
      result._hasEngageRadius = true;
      result._engageRadius = JsonToDouble.fromJson(json.engageRadius);
    }
    if (json.resetRadius != null) {
      result._hasResetRadius = true;
      result._resetRadius = JsonToDouble.fromJson(json.resetRadius);
    }
    if (json.chaseInDefenseAreaOnly != null) {
      result._hasChaseInDefenseAreaOnly = true;
      result._chaseInDefenseAreaOnly = JsonToBoolean.fromJson(json.chaseInDefenseAreaOnly);
    }
    if (json.forceRescanPeriod != null) {
      result._hasForceRescanPeriod = true;
      result._forceRescanPeriod = JsonToDouble.fromJson(json.forceRescanPeriod);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasEnemySearchRange) {
      result.enemySearchRange = JsonToDouble.toJson(this._enemySearchRange);
    }
    if (this._hasEngageRadius) {
      result.engageRadius = JsonToDouble.toJson(this._engageRadius);
    }
    if (this._hasResetRadius) {
      result.resetRadius = JsonToDouble.toJson(this._resetRadius);
    }
    if (this._hasChaseInDefenseAreaOnly) {
      result.chaseInDefenseAreaOnly = JsonToBoolean.toJson(this._chaseInDefenseAreaOnly);
    }
    if (this._hasForceRescanPeriod) {
      result.forceRescanPeriod = JsonToDouble.toJson(this._forceRescanPeriod);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get enemySearchRange() {
    return this._hasEnemySearchRange ? this._enemySearchRange : JsonToDouble.default;
  }
  get hasEnemySearchRange() {
    return this._hasEnemySearchRange;
  }
  setEnemySearchRange(path, value) {
    return {type: 'SET', path: path.concat(['enemySearchRange']), value};
  }
  deleteEnemySearchRange(path) {
    return {type: 'DELETE', path: path.concat(['enemySearchRange'])};
  }
  /**
   * @returns {number}
   */
  get engageRadius() {
    return this._hasEngageRadius ? this._engageRadius : JsonToDouble.default;
  }
  get hasEngageRadius() {
    return this._hasEngageRadius;
  }
  setEngageRadius(path, value) {
    return {type: 'SET', path: path.concat(['engageRadius']), value};
  }
  deleteEngageRadius(path) {
    return {type: 'DELETE', path: path.concat(['engageRadius'])};
  }
  /**
   * @returns {number}
   */
  get resetRadius() {
    return this._hasResetRadius ? this._resetRadius : JsonToDouble.default;
  }
  get hasResetRadius() {
    return this._hasResetRadius;
  }
  setResetRadius(path, value) {
    return {type: 'SET', path: path.concat(['resetRadius']), value};
  }
  deleteResetRadius(path) {
    return {type: 'DELETE', path: path.concat(['resetRadius'])};
  }
  /**
   * @returns {boolean}
   */
  get chaseInDefenseAreaOnly() {
    return this._hasChaseInDefenseAreaOnly ? this._chaseInDefenseAreaOnly : JsonToBoolean.default;
  }
  get hasChaseInDefenseAreaOnly() {
    return this._hasChaseInDefenseAreaOnly;
  }
  setChaseInDefenseAreaOnly(path, value) {
    return {type: 'SET', path: path.concat(['chaseInDefenseAreaOnly']), value};
  }
  deleteChaseInDefenseAreaOnly(path) {
    return {type: 'DELETE', path: path.concat(['chaseInDefenseAreaOnly'])};
  }
  /**
   * @returns {number}
   */
  get forceRescanPeriod() {
    return this._hasForceRescanPeriod ? this._forceRescanPeriod : JsonToDouble.default;
  }
  get hasForceRescanPeriod() {
    return this._hasForceRescanPeriod;
  }
  setForceRescanPeriod(path, value) {
    return {type: 'SET', path: path.concat(['forceRescanPeriod']), value};
  }
  deleteForceRescanPeriod(path) {
    return {type: 'DELETE', path: path.concat(['forceRescanPeriod'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "enemySearchRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitBattleData(this);
              copy._hasEnemySearchRange = true;
              copy._enemySearchRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEnemySearchRange) {
                return this;
              }
              const copy = new UnitBattleData(this);
              copy._hasEnemySearchRange = false;
              copy._enemySearchRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "engageRadius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitBattleData(this);
              copy._hasEngageRadius = true;
              copy._engageRadius = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEngageRadius) {
                return this;
              }
              const copy = new UnitBattleData(this);
              copy._hasEngageRadius = false;
              copy._engageRadius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "resetRadius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitBattleData(this);
              copy._hasResetRadius = true;
              copy._resetRadius = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasResetRadius) {
                return this;
              }
              const copy = new UnitBattleData(this);
              copy._hasResetRadius = false;
              copy._resetRadius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chaseInDefenseAreaOnly": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitBattleData(this);
              copy._hasChaseInDefenseAreaOnly = true;
              copy._chaseInDefenseAreaOnly = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChaseInDefenseAreaOnly) {
                return this;
              }
              const copy = new UnitBattleData(this);
              copy._hasChaseInDefenseAreaOnly = false;
              copy._chaseInDefenseAreaOnly = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "forceRescanPeriod": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitBattleData(this);
              copy._hasForceRescanPeriod = true;
              copy._forceRescanPeriod = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasForceRescanPeriod) {
                return this;
              }
              const copy = new UnitBattleData(this);
              copy._hasForceRescanPeriod = false;
              copy._forceRescanPeriod = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UnitBattleData} other
   * @returns {UnitBattleData}
   */
  merge(other) {
    const copy = new UnitBattleData(this);
    if (other._hasEnemySearchRange) {
      copy._hasEnemySearchRange = true;
      copy._enemySearchRange = other._enemySearchRange;
    }
    if (other._hasEngageRadius) {
      copy._hasEngageRadius = true;
      copy._engageRadius = other._engageRadius;
    }
    if (other._hasResetRadius) {
      copy._hasResetRadius = true;
      copy._resetRadius = other._resetRadius;
    }
    if (other._hasChaseInDefenseAreaOnly) {
      copy._hasChaseInDefenseAreaOnly = true;
      copy._chaseInDefenseAreaOnly = other._chaseInDefenseAreaOnly;
    }
    if (other._hasForceRescanPeriod) {
      copy._hasForceRescanPeriod = true;
      copy._forceRescanPeriod = other._forceRescanPeriod;
    }
    return copy;
  }
}
UnitBattleData.default = new UnitBattleData();
class UnitBattleData_Builder {
  constructor(value) {
    this._value = new UnitBattleData(value);
  }
  build() {
    return new UnitBattleData(this._value);
  }
  setEnemySearchRange(value) {
    this._value._hasEnemySearchRange = true;
    this._value._enemySearchRange = value;
    return this;
  }
  deleteEnemySearchRange() {
    this._value._hasEnemySearchRange = false;
    this._value._enemySearchRange = null;
    return this;
  }
  setEngageRadius(value) {
    this._value._hasEngageRadius = true;
    this._value._engageRadius = value;
    return this;
  }
  deleteEngageRadius() {
    this._value._hasEngageRadius = false;
    this._value._engageRadius = null;
    return this;
  }
  setResetRadius(value) {
    this._value._hasResetRadius = true;
    this._value._resetRadius = value;
    return this;
  }
  deleteResetRadius() {
    this._value._hasResetRadius = false;
    this._value._resetRadius = null;
    return this;
  }
  setChaseInDefenseAreaOnly(value) {
    this._value._hasChaseInDefenseAreaOnly = true;
    this._value._chaseInDefenseAreaOnly = value;
    return this;
  }
  deleteChaseInDefenseAreaOnly() {
    this._value._hasChaseInDefenseAreaOnly = false;
    this._value._chaseInDefenseAreaOnly = null;
    return this;
  }
  setForceRescanPeriod(value) {
    this._value._hasForceRescanPeriod = true;
    this._value._forceRescanPeriod = value;
    return this;
  }
  deleteForceRescanPeriod() {
    this._value._hasForceRescanPeriod = false;
    this._value._forceRescanPeriod = null;
    return this;
  }
}
UnitBattleData.Builder = UnitBattleData_Builder;
class UnitBattleData_WithParent {
  /**
   * @param {UnitBattleData} value
   * @param {UnitBattleData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UnitBattleData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasEnemySearchRange() {
    if (this._cachedHasEnemySearchRange === undefined) {
      if (this._value.hasEnemySearchRange) {
        this._cachedHasEnemySearchRange = true;
      } else {
        this._cachedHasEnemySearchRange = this._parent ? this._parent.hasEnemySearchRange : false;
      }
    }
    return this._cachedHasEnemySearchRange;
  }
  get enemySearchRange() {
    if (this._cachedEnemySearchRange === undefined) {
      if (this._value.hasEnemySearchRange) {
        this._cachedEnemySearchRange = this._value.enemySearchRange;
      } else {
        this._cachedEnemySearchRange = this._parent ? this._parent.enemySearchRange : this._value.enemySearchRange;
      }
    }
    return this._cachedEnemySearchRange;
  }
  get hasEngageRadius() {
    if (this._cachedHasEngageRadius === undefined) {
      if (this._value.hasEngageRadius) {
        this._cachedHasEngageRadius = true;
      } else {
        this._cachedHasEngageRadius = this._parent ? this._parent.hasEngageRadius : false;
      }
    }
    return this._cachedHasEngageRadius;
  }
  get engageRadius() {
    if (this._cachedEngageRadius === undefined) {
      if (this._value.hasEngageRadius) {
        this._cachedEngageRadius = this._value.engageRadius;
      } else {
        this._cachedEngageRadius = this._parent ? this._parent.engageRadius : this._value.engageRadius;
      }
    }
    return this._cachedEngageRadius;
  }
  get hasResetRadius() {
    if (this._cachedHasResetRadius === undefined) {
      if (this._value.hasResetRadius) {
        this._cachedHasResetRadius = true;
      } else {
        this._cachedHasResetRadius = this._parent ? this._parent.hasResetRadius : false;
      }
    }
    return this._cachedHasResetRadius;
  }
  get resetRadius() {
    if (this._cachedResetRadius === undefined) {
      if (this._value.hasResetRadius) {
        this._cachedResetRadius = this._value.resetRadius;
      } else {
        this._cachedResetRadius = this._parent ? this._parent.resetRadius : this._value.resetRadius;
      }
    }
    return this._cachedResetRadius;
  }
  get hasChaseInDefenseAreaOnly() {
    if (this._cachedHasChaseInDefenseAreaOnly === undefined) {
      if (this._value.hasChaseInDefenseAreaOnly) {
        this._cachedHasChaseInDefenseAreaOnly = true;
      } else {
        this._cachedHasChaseInDefenseAreaOnly = this._parent ? this._parent.hasChaseInDefenseAreaOnly : false;
      }
    }
    return this._cachedHasChaseInDefenseAreaOnly;
  }
  get chaseInDefenseAreaOnly() {
    if (this._cachedChaseInDefenseAreaOnly === undefined) {
      if (this._value.hasChaseInDefenseAreaOnly) {
        this._cachedChaseInDefenseAreaOnly = this._value.chaseInDefenseAreaOnly;
      } else {
        this._cachedChaseInDefenseAreaOnly = this._parent ? this._parent.chaseInDefenseAreaOnly : this._value.chaseInDefenseAreaOnly;
      }
    }
    return this._cachedChaseInDefenseAreaOnly;
  }
  get hasForceRescanPeriod() {
    if (this._cachedHasForceRescanPeriod === undefined) {
      if (this._value.hasForceRescanPeriod) {
        this._cachedHasForceRescanPeriod = true;
      } else {
        this._cachedHasForceRescanPeriod = this._parent ? this._parent.hasForceRescanPeriod : false;
      }
    }
    return this._cachedHasForceRescanPeriod;
  }
  get forceRescanPeriod() {
    if (this._cachedForceRescanPeriod === undefined) {
      if (this._value.hasForceRescanPeriod) {
        this._cachedForceRescanPeriod = this._value.forceRescanPeriod;
      } else {
        this._cachedForceRescanPeriod = this._parent ? this._parent.forceRescanPeriod : this._value.forceRescanPeriod;
      }
    }
    return this._cachedForceRescanPeriod;
  }
  update(current, parent) {
    const result = new UnitBattleData_WithParent(current, parent);
    return result;
  }
}
UnitBattleData_WithParent.default = new UnitBattleData_WithParent(UnitBattleData.default, null);
UnitBattleData.WithParent = UnitBattleData_WithParent;
class UnitBattleData_Descriptor {
  get enemySearchRange() {
    if (!this._enemySearchRange) {
      this._enemySearchRange = {
        name: "enemySearchRange",
        Name: "EnemySearchRange",
        number: 1,
        protoType: 1,
        protoName: "enemy_search_range",
        type: JsonToDouble,
        options: {
          comments: "The unit will search for enemies to attack within this radius.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enemySearchRange;
  }
  get engageRadius() {
    if (!this._engageRadius) {
      this._engageRadius = {
        name: "engageRadius",
        Name: "EngageRadius",
        number: 2,
        protoType: 1,
        protoName: "engage_radius",
        type: JsonToDouble,
        options: {
          comments: "The unit will search for enemies to engage within this radius.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._engageRadius;
  }
  get resetRadius() {
    if (!this._resetRadius) {
      this._resetRadius = {
        name: "resetRadius",
        Name: "ResetRadius",
        number: 3,
        protoType: 1,
        protoName: "reset_radius",
        type: JsonToDouble,
        options: {
          comments: "The unit will leash if it leaves this radius.",
          propertyRange: "0, \"EnemySearchRange\"",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._resetRadius;
  }
  get chaseInDefenseAreaOnly() {
    if (!this._chaseInDefenseAreaOnly) {
      this._chaseInDefenseAreaOnly = {
        name: "chaseInDefenseAreaOnly",
        Name: "ChaseInDefenseAreaOnly",
        number: 4,
        protoType: 8,
        protoName: "chase_in_defense_area_only",
        type: JsonToBoolean,
        options: {
          comments: "Used for generic controllable unit. If target is outside of the range, the unit will stop chasing and go back",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chaseInDefenseAreaOnly;
  }
  get forceRescanPeriod() {
    if (!this._forceRescanPeriod) {
      this._forceRescanPeriod = {
        name: "forceRescanPeriod",
        Name: "ForceRescanPeriod",
        number: 5,
        protoType: 1,
        protoName: "force_rescan_period",
        type: JsonToDouble,
        options: {
          comments: "Time in seconds for weapons to be forced to rescan targets.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._forceRescanPeriod;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.enemySearchRange,
        this.engageRadius,
        this.resetRadius,
        this.chaseInDefenseAreaOnly,
        this.forceRescanPeriod,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForEnemySearchRange",
        Name: "DummyOneofForEnemySearchRange",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEngageRadius",
        Name: "DummyOneofForEngageRadius",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForResetRadius",
        Name: "DummyOneofForResetRadius",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChaseInDefenseAreaOnly",
        Name: "DummyOneofForChaseInDefenseAreaOnly",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForForceRescanPeriod",
        Name: "DummyOneofForForceRescanPeriod",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
UnitBattleData.descriptor = new UnitBattleData_Descriptor();
export class Tag {
  get descriptor() {
    return Tag.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasCount = false;
    this._count = null;
    this._hasDuration = false;
    this._duration = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasCount) return false;
    if (this._hasDuration) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Tag) {
      return value;
    }
    return Tag.fromJson(value);
  }
  static fromJson(json) {
    const result = new Tag();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.count != null) {
      result._hasCount = true;
      result._count = JsonToInt32.fromJson(json.count);
    }
    if (json.duration != null) {
      result._hasDuration = true;
      result._duration = JsonToInt32.fromJson(json.duration);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasCount) {
      result.count = JsonToInt32.toJson(this._count);
    }
    if (this._hasDuration) {
      result.duration = JsonToInt32.toJson(this._duration);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {number}
   */
  get count() {
    return this._hasCount ? this._count : JsonToInt32.default;
  }
  get hasCount() {
    return this._hasCount;
  }
  setCount(path, value) {
    return {type: 'SET', path: path.concat(['count']), value};
  }
  deleteCount(path) {
    return {type: 'DELETE', path: path.concat(['count'])};
  }
  /**
   * @returns {number}
   */
  get duration() {
    return this._hasDuration ? this._duration : JsonToInt32.default;
  }
  get hasDuration() {
    return this._hasDuration;
  }
  setDuration(path, value) {
    return {type: 'SET', path: path.concat(['duration']), value};
  }
  deleteDuration(path) {
    return {type: 'DELETE', path: path.concat(['duration'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Tag(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new Tag(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "count": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Tag(this);
              copy._hasCount = true;
              copy._count = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCount) {
                return this;
              }
              const copy = new Tag(this);
              copy._hasCount = false;
              copy._count = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "duration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Tag(this);
              copy._hasDuration = true;
              copy._duration = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDuration) {
                return this;
              }
              const copy = new Tag(this);
              copy._hasDuration = false;
              copy._duration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Tag} other
   * @returns {Tag}
   */
  merge(other) {
    const copy = new Tag(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasCount) {
      copy._hasCount = true;
      copy._count = other._count;
    }
    if (other._hasDuration) {
      copy._hasDuration = true;
      copy._duration = other._duration;
    }
    return copy;
  }
}
Tag.default = new Tag();
class Tag_Builder {
  constructor(value) {
    this._value = new Tag(value);
  }
  build() {
    return new Tag(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setCount(value) {
    this._value._hasCount = true;
    this._value._count = value;
    return this;
  }
  deleteCount() {
    this._value._hasCount = false;
    this._value._count = null;
    return this;
  }
  setDuration(value) {
    this._value._hasDuration = true;
    this._value._duration = value;
    return this;
  }
  deleteDuration() {
    this._value._hasDuration = false;
    this._value._duration = null;
    return this;
  }
}
Tag.Builder = Tag_Builder;
class Tag_WithParent {
  /**
   * @param {Tag} value
   * @param {Tag_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Tag.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasCount() {
    if (this._cachedHasCount === undefined) {
      if (this._value.hasCount) {
        this._cachedHasCount = true;
      } else {
        this._cachedHasCount = this._parent ? this._parent.hasCount : false;
      }
    }
    return this._cachedHasCount;
  }
  get count() {
    if (this._cachedCount === undefined) {
      if (this._value.hasCount) {
        this._cachedCount = this._value.count;
      } else {
        this._cachedCount = this._parent ? this._parent.count : this._value.count;
      }
    }
    return this._cachedCount;
  }
  get hasDuration() {
    if (this._cachedHasDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedHasDuration = true;
      } else {
        this._cachedHasDuration = this._parent ? this._parent.hasDuration : false;
      }
    }
    return this._cachedHasDuration;
  }
  get duration() {
    if (this._cachedDuration === undefined) {
      if (this._value.hasDuration) {
        this._cachedDuration = this._value.duration;
      } else {
        this._cachedDuration = this._parent ? this._parent.duration : this._value.duration;
      }
    }
    return this._cachedDuration;
  }
  update(current, parent) {
    const result = new Tag_WithParent(current, parent);
    return result;
  }
}
Tag_WithParent.default = new Tag_WithParent(Tag.default, null);
Tag.WithParent = Tag_WithParent;
class Tag_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
          comments: "The name of the tag to apply.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get count() {
    if (!this._count) {
      this._count = {
        name: "count",
        Name: "Count",
        number: 2,
        protoType: 5,
        protoName: "count",
        type: JsonToInt32,
        options: {
          comments: "The number of stacks of the tag to apply.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._count;
  }
  get duration() {
    if (!this._duration) {
      this._duration = {
        name: "duration",
        Name: "Duration",
        number: 3,
        protoType: 5,
        protoName: "duration",
        type: JsonToInt32,
        options: {
          comments: "The duration the tag will last (the default setting will last indefinitely).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._duration;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.count,
        this.duration,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCount",
        Name: "DummyOneofForCount",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDuration",
        Name: "DummyOneofForDuration",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
Tag.descriptor = new Tag_Descriptor();
export class UnitReferences {
  get descriptor() {
    return UnitReferences.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._weaponList = [];
    this._abilityList = [];
    this._passiveList = [];
    this._behaviorList = [];
    this._hasOnStartAbility = false;
    this._onStartAbility = null;
    this._tagList = [];
  }
  isEmpty() {
    if (this._weaponList.length > 0) return false;
    if (this._abilityList.length > 0) return false;
    if (this._passiveList.length > 0) return false;
    if (this._behaviorList.length > 0) return false;
    if (this._hasOnStartAbility) return false;
    if (this._tagList.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UnitReferences) {
      return value;
    }
    return UnitReferences.fromJson(value);
  }
  static fromJson(json) {
    const result = new UnitReferences();
    result._weaponList = JsonToList(json.weaponList, JsonToString);
    result._abilityList = JsonToList(json.abilityList, JsonToString);
    result._passiveList = JsonToList(json.passiveList, JsonToString);
    result._behaviorList = JsonToList(json.behaviorList, JsonToString);
    if (json.onStartAbility != null) {
      result._hasOnStartAbility = true;
      result._onStartAbility = JsonToString.fromJson(json.onStartAbility);
    }
    result._tagList = JsonToList(json.tagList, Tag);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._weaponList.length > 0) {
      result.weaponList = ArrayToJson(this._weaponList, JsonToString);
    }
    if (this._abilityList.length > 0) {
      result.abilityList = ArrayToJson(this._abilityList, JsonToString);
    }
    if (this._passiveList.length > 0) {
      result.passiveList = ArrayToJson(this._passiveList, JsonToString);
    }
    if (this._behaviorList.length > 0) {
      result.behaviorList = ArrayToJson(this._behaviorList, JsonToString);
    }
    if (this._hasOnStartAbility) {
      result.onStartAbility = JsonToString.toJson(this._onStartAbility);
    }
    if (this._tagList.length > 0) {
      result.tagList = ArrayToJson(this._tagList, Tag);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get weaponList() {
    return this._weaponList;
  }
  addWeaponList(path, value) {
    return {type: 'ADD', path: path.concat(['weaponList']), value};
  }
  setWeaponList(path, value) {
    return {type: 'SET', path: path.concat(['weaponList']), value: ArrayToJson(value, JsonToString)};
  }
  setWeaponListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['weaponList', key]), value};
  }
  deleteWeaponList(path) {
    return {type: 'DELETE', path: path.concat(['weaponList'])};
  }
  deleteWeaponListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['weaponList', key])};
  }
  /**
   * @returns {string[]}
   */
  get abilityList() {
    return this._abilityList;
  }
  addAbilityList(path, value) {
    return {type: 'ADD', path: path.concat(['abilityList']), value};
  }
  setAbilityList(path, value) {
    return {type: 'SET', path: path.concat(['abilityList']), value: ArrayToJson(value, JsonToString)};
  }
  setAbilityListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['abilityList', key]), value};
  }
  deleteAbilityList(path) {
    return {type: 'DELETE', path: path.concat(['abilityList'])};
  }
  deleteAbilityListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['abilityList', key])};
  }
  /**
   * @returns {string[]}
   */
  get passiveList() {
    return this._passiveList;
  }
  addDeprecatedPassiveList(path, value) {
    return {type: 'ADD', path: path.concat(['passiveList']), value};
  }
  setDeprecatedPassiveList(path, value) {
    return {type: 'SET', path: path.concat(['passiveList']), value: ArrayToJson(value, JsonToString)};
  }
  setDeprecatedPassiveListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['passiveList', key]), value};
  }
  deleteDeprecatedPassiveList(path) {
    return {type: 'DELETE', path: path.concat(['passiveList'])};
  }
  deleteDeprecatedPassiveListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['passiveList', key])};
  }
  /**
   * @returns {string[]}
   */
  get behaviorList() {
    return this._behaviorList;
  }
  addBehaviorList(path, value) {
    return {type: 'ADD', path: path.concat(['behaviorList']), value};
  }
  setBehaviorList(path, value) {
    return {type: 'SET', path: path.concat(['behaviorList']), value: ArrayToJson(value, JsonToString)};
  }
  setBehaviorListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['behaviorList', key]), value};
  }
  deleteBehaviorList(path) {
    return {type: 'DELETE', path: path.concat(['behaviorList'])};
  }
  deleteBehaviorListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['behaviorList', key])};
  }
  /**
   * @returns {string}
   */
  get onStartAbility() {
    return this._hasOnStartAbility ? this._onStartAbility : JsonToString.default;
  }
  get hasOnStartAbility() {
    return this._hasOnStartAbility;
  }
  setOnStartAbility(path, value) {
    return {type: 'SET', path: path.concat(['onStartAbility']), value};
  }
  deleteOnStartAbility(path) {
    return {type: 'DELETE', path: path.concat(['onStartAbility'])};
  }
  /**
   * @returns {Tag[]}
   */
  get tagList() {
    return this._tagList;
  }
  addTagList(path, value) {
    return {type: 'ADD', path: path.concat(['tagList']), value: value.toJson()};
  }
  setTagList(path, value) {
    return {type: 'SET', path: path.concat(['tagList']), value: ArrayToJson(value, Tag)};
  }
  setTagListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['tagList', key]), value: value.toJson()};
  }
  deleteTagList(path) {
    return {type: 'DELETE', path: path.concat(['tagList'])};
  }
  deleteTagListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['tagList', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "weaponList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitReferences(this);
              copy._weaponList = [];        for (let i of value) {
                copy._weaponList.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UnitReferences(this);
              copy._weaponList = copy._weaponList.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._weaponList.length === 0) {
                return this;
              }
              const copy = new UnitReferences(this);
              copy._weaponList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._weaponList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UnitReferences(this);
              copy._weaponList = copy._weaponList.slice();
              copy._weaponList[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UnitReferences(this);
              copy._weaponList = copy._weaponList.slice(0, path[1]).concat(copy._weaponList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._weaponList.length) {
            return this;
          }
          const oldValue = this._weaponList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UnitReferences(this);
          copy._weaponList = copy._weaponList.slice();
          copy._weaponList[key] = newValue;
          return copy;
        }
      }
      case "abilityList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitReferences(this);
              copy._abilityList = [];        for (let i of value) {
                copy._abilityList.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UnitReferences(this);
              copy._abilityList = copy._abilityList.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._abilityList.length === 0) {
                return this;
              }
              const copy = new UnitReferences(this);
              copy._abilityList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._abilityList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UnitReferences(this);
              copy._abilityList = copy._abilityList.slice();
              copy._abilityList[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UnitReferences(this);
              copy._abilityList = copy._abilityList.slice(0, path[1]).concat(copy._abilityList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._abilityList.length) {
            return this;
          }
          const oldValue = this._abilityList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UnitReferences(this);
          copy._abilityList = copy._abilityList.slice();
          copy._abilityList[key] = newValue;
          return copy;
        }
      }
      case "passiveList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitReferences(this);
              copy._passiveList = [];        for (let i of value) {
                copy._passiveList.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UnitReferences(this);
              copy._passiveList = copy._passiveList.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._passiveList.length === 0) {
                return this;
              }
              const copy = new UnitReferences(this);
              copy._passiveList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._passiveList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UnitReferences(this);
              copy._passiveList = copy._passiveList.slice();
              copy._passiveList[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UnitReferences(this);
              copy._passiveList = copy._passiveList.slice(0, path[1]).concat(copy._passiveList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._passiveList.length) {
            return this;
          }
          const oldValue = this._passiveList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UnitReferences(this);
          copy._passiveList = copy._passiveList.slice();
          copy._passiveList[key] = newValue;
          return copy;
        }
      }
      case "behaviorList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitReferences(this);
              copy._behaviorList = [];        for (let i of value) {
                copy._behaviorList.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UnitReferences(this);
              copy._behaviorList = copy._behaviorList.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._behaviorList.length === 0) {
                return this;
              }
              const copy = new UnitReferences(this);
              copy._behaviorList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._behaviorList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UnitReferences(this);
              copy._behaviorList = copy._behaviorList.slice();
              copy._behaviorList[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UnitReferences(this);
              copy._behaviorList = copy._behaviorList.slice(0, path[1]).concat(copy._behaviorList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._behaviorList.length) {
            return this;
          }
          const oldValue = this._behaviorList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UnitReferences(this);
          copy._behaviorList = copy._behaviorList.slice();
          copy._behaviorList[key] = newValue;
          return copy;
        }
      }
      case "onStartAbility": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitReferences(this);
              copy._hasOnStartAbility = true;
              copy._onStartAbility = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOnStartAbility) {
                return this;
              }
              const copy = new UnitReferences(this);
              copy._hasOnStartAbility = false;
              copy._onStartAbility = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tagList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitReferences(this);
              copy._tagList = [];        for (let i of value) {
                copy._tagList.push(Tag.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UnitReferences(this);
              copy._tagList = copy._tagList.concat([Tag.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._tagList.length === 0) {
                return this;
              }
              const copy = new UnitReferences(this);
              copy._tagList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._tagList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UnitReferences(this);
              copy._tagList = copy._tagList.slice();
              copy._tagList[path[1]] = Tag.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UnitReferences(this);
              copy._tagList = copy._tagList.slice(0, path[1]).concat(copy._tagList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._tagList.length) {
            return this;
          }
          const oldValue = this._tagList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UnitReferences(this);
          copy._tagList = copy._tagList.slice();
          copy._tagList[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UnitReferences} other
   * @returns {UnitReferences}
   */
  merge(other) {
    const copy = new UnitReferences(this);
    copy._weaponList = this._weaponList.concat(other._weaponList);
    copy._abilityList = this._abilityList.concat(other._abilityList);
    copy._passiveList = this._passiveList.concat(other._passiveList);
    copy._behaviorList = this._behaviorList.concat(other._behaviorList);
    if (other._hasOnStartAbility) {
      copy._hasOnStartAbility = true;
      copy._onStartAbility = other._onStartAbility;
    }
    copy._tagList = this._tagList.concat(other._tagList);
    return copy;
  }
}
UnitReferences.default = new UnitReferences();
class UnitReferences_Builder {
  constructor(value) {
    this._value = new UnitReferences(value);
  }
  build() {
    return new UnitReferences(this._value);
  }
  addAllWeaponList(values) {
    this._value._weaponList = this._value._weaponList.concat(values);
    return this;
  }
  addWeaponList(value) {
    this._value._weaponList = this._value._weaponList.concat([value]);
    return this;
  }
  setWeaponList(index, value) {
    this._value._weaponList = this._value._weaponList.concat();
    this._value._weaponList[index] = value;
    return this;
  }
  clearWeaponList() {
    this._value._weaponList = [];
    return this;
  }
  addAllAbilityList(values) {
    this._value._abilityList = this._value._abilityList.concat(values);
    return this;
  }
  addAbilityList(value) {
    this._value._abilityList = this._value._abilityList.concat([value]);
    return this;
  }
  setAbilityList(index, value) {
    this._value._abilityList = this._value._abilityList.concat();
    this._value._abilityList[index] = value;
    return this;
  }
  clearAbilityList() {
    this._value._abilityList = [];
    return this;
  }
  addAllDeprecatedPassiveList(values) {
    this._value._passiveList = this._value._passiveList.concat(values);
    return this;
  }
  addDeprecatedPassiveList(value) {
    this._value._passiveList = this._value._passiveList.concat([value]);
    return this;
  }
  setDeprecatedPassiveList(index, value) {
    this._value._passiveList = this._value._passiveList.concat();
    this._value._passiveList[index] = value;
    return this;
  }
  clearDeprecatedPassiveList() {
    this._value._passiveList = [];
    return this;
  }
  addAllBehaviorList(values) {
    this._value._behaviorList = this._value._behaviorList.concat(values);
    return this;
  }
  addBehaviorList(value) {
    this._value._behaviorList = this._value._behaviorList.concat([value]);
    return this;
  }
  setBehaviorList(index, value) {
    this._value._behaviorList = this._value._behaviorList.concat();
    this._value._behaviorList[index] = value;
    return this;
  }
  clearBehaviorList() {
    this._value._behaviorList = [];
    return this;
  }
  setOnStartAbility(value) {
    this._value._hasOnStartAbility = true;
    this._value._onStartAbility = value;
    return this;
  }
  deleteOnStartAbility() {
    this._value._hasOnStartAbility = false;
    this._value._onStartAbility = null;
    return this;
  }
  addAllTagList(values) {
    this._value._tagList = this._value._tagList.concat(values);
    return this;
  }
  addTagList(value) {
    this._value._tagList = this._value._tagList.concat([value]);
    return this;
  }
  setTagList(index, value) {
    this._value._tagList = this._value._tagList.concat();
    this._value._tagList[index] = value;
    return this;
  }
  clearTagList() {
    this._value._tagList = [];
    return this;
  }
}
UnitReferences.Builder = UnitReferences_Builder;
class UnitReferences_WithParent {
  /**
   * @param {UnitReferences} value
   * @param {UnitReferences_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UnitReferences.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfWeaponList() {
    return this._value.weaponList;
  }
  get inherentWeaponList() {
    if (!this._inherentWeaponList) {
      this._inherentWeaponList = this._parent ? this._parent.weaponList : [];
    }
    return this._inherentWeaponList;
  }
  get weaponList() {
    if (!this._allWeaponList) {
      this._allWeaponList = this._parent ? this._parent.weaponList.concat(this.selfWeaponList) : this.selfWeaponList;
    }
    return this._allWeaponList;
  }
  get selfAbilityList() {
    return this._value.abilityList;
  }
  get inherentAbilityList() {
    if (!this._inherentAbilityList) {
      this._inherentAbilityList = this._parent ? this._parent.abilityList : [];
    }
    return this._inherentAbilityList;
  }
  get abilityList() {
    if (!this._allAbilityList) {
      this._allAbilityList = this._parent ? this._parent.abilityList.concat(this.selfAbilityList) : this.selfAbilityList;
    }
    return this._allAbilityList;
  }
  get selfDeprecatedPassiveList() {
    return this._value.passiveList;
  }
  get inherentDeprecatedPassiveList() {
    if (!this._inherentDeprecatedPassiveList) {
      this._inherentDeprecatedPassiveList = this._parent ? this._parent.passiveList : [];
    }
    return this._inherentDeprecatedPassiveList;
  }
  get passiveList() {
    if (!this._allDeprecatedPassiveList) {
      this._allDeprecatedPassiveList = this._parent ? this._parent.passiveList.concat(this.selfDeprecatedPassiveList) : this.selfDeprecatedPassiveList;
    }
    return this._allDeprecatedPassiveList;
  }
  get selfBehaviorList() {
    return this._value.behaviorList;
  }
  get inherentBehaviorList() {
    if (!this._inherentBehaviorList) {
      this._inherentBehaviorList = this._parent ? this._parent.behaviorList : [];
    }
    return this._inherentBehaviorList;
  }
  get behaviorList() {
    if (!this._allBehaviorList) {
      this._allBehaviorList = this._parent ? this._parent.behaviorList.concat(this.selfBehaviorList) : this.selfBehaviorList;
    }
    return this._allBehaviorList;
  }
  get hasOnStartAbility() {
    if (this._cachedHasOnStartAbility === undefined) {
      if (this._value.hasOnStartAbility) {
        this._cachedHasOnStartAbility = true;
      } else {
        this._cachedHasOnStartAbility = this._parent ? this._parent.hasOnStartAbility : false;
      }
    }
    return this._cachedHasOnStartAbility;
  }
  get onStartAbility() {
    if (this._cachedOnStartAbility === undefined) {
      if (this._value.hasOnStartAbility) {
        this._cachedOnStartAbility = this._value.onStartAbility;
      } else {
        this._cachedOnStartAbility = this._parent ? this._parent.onStartAbility : this._value.onStartAbility;
      }
    }
    return this._cachedOnStartAbility;
  }
  get selfTagList() {
    if (!this._selfTagList) {
      this._selfTagList = [];
      for (let i of this._value.tagList) {
        this._selfTagList.push(new Tag.WithParent(i, null));
      }
    }
    return this._selfTagList;
  }
  get inherentTagList() {
    if (!this._inherentTagList) {
      this._inherentTagList = this._parent ? this._parent.tagList : [];
    }
    return this._inherentTagList;
  }
  get tagList() {
    if (!this._allTagList) {
      this._allTagList = this._parent ? this._parent.tagList.concat(this.selfTagList) : this.selfTagList;
    }
    return this._allTagList;
  }
  update(current, parent) {
    const result = new UnitReferences_WithParent(current, parent);
    if (this._selfTagList) {
      if (this._value.tagList === current.tagList) {
        result._selfTagList = this._selfTagList;
      } else {
        result._selfTagList = [];
        for (let i = 0; i < current.tagList.length; i++) {
          const oldValue = this._value.tagList[i];
          if (oldValue) {
            const oldCache = this._selfTagList[i];
            if (oldValue === current.tagList[i]) {
              result._selfTagList[i] = oldCache;
            } else {
              result._selfTagList[i] = oldCache.update(current.tagList[i], null);
            }
          } else {
            result._selfTagList[i] = new Tag.WithParent(current.tagList[i], null);
          }
        }
      }
    }
    return result;
  }
}
UnitReferences_WithParent.default = new UnitReferences_WithParent(UnitReferences.default, null);
UnitReferences.WithParent = UnitReferences_WithParent;
class UnitReferences_Descriptor {
  get weaponList() {
    if (!this._weaponList) {
      this._weaponList = {
        name: "weaponList",
        Name: "WeaponList",
        number: 1,
        protoType: 9,
        protoName: "weapon_list",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "SupportedWeaponListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._weaponList;
  }
  get abilityList() {
    if (!this._abilityList) {
      this._abilityList = {
        name: "abilityList",
        Name: "AbilityList",
        number: 2,
        protoType: 9,
        protoName: "ability_list",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "SupportedAbilityListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityList;
  }
  get passiveList() {
    if (!this._passiveList) {
      this._passiveList = {
        name: "passiveList",
        Name: "DeprecatedPassiveList",
        number: 3,
        protoType: 9,
        protoName: "deprecated_passive_list",
        type: JsonToString,
        isRepeated: true,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._passiveList;
  }
  get behaviorList() {
    if (!this._behaviorList) {
      this._behaviorList = {
        name: "behaviorList",
        Name: "BehaviorList",
        number: 4,
        protoType: 9,
        protoName: "behavior_list",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "SupportedBehaviorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behaviorList;
  }
  get onStartAbility() {
    if (!this._onStartAbility) {
      this._onStartAbility = {
        name: "onStartAbility",
        Name: "OnStartAbility",
        number: 5,
        protoType: 9,
        protoName: "on_start_ability",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedAbilityListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._onStartAbility;
  }
  get tagList() {
    if (!this._tagList) {
      this._tagList = {
        name: "tagList",
        Name: "TagList",
        number: 6,
        protoType: 11,
        protoName: "tag_list",
        type: Tag,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tagList;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.weaponList,
        this.abilityList,
        this.passiveList,
        this.behaviorList,
        this.onStartAbility,
        this.tagList,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForOnStartAbility",
        Name: "DummyOneofForOnStartAbility",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
UnitReferences.descriptor = new UnitReferences_Descriptor();
class RallyPointComponent_Offset {
  get descriptor() {
    return RallyPointComponent_Offset.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasX = false;
    this._x = null;
    this._hasY = false;
    this._y = null;
    this._hasZ = false;
    this._z = null;
  }
  isEmpty() {
    if (this._hasX) return false;
    if (this._hasY) return false;
    if (this._hasZ) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RallyPointComponent_Offset) {
      return value;
    }
    return RallyPointComponent_Offset.fromJson(value);
  }
  static fromJson(json) {
    const result = new RallyPointComponent_Offset();
    if (json.x != null) {
      result._hasX = true;
      result._x = JsonToDouble.fromJson(json.x);
    }
    if (json.y != null) {
      result._hasY = true;
      result._y = JsonToDouble.fromJson(json.y);
    }
    if (json.z != null) {
      result._hasZ = true;
      result._z = JsonToDouble.fromJson(json.z);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasX) {
      result.x = JsonToDouble.toJson(this._x);
    }
    if (this._hasY) {
      result.y = JsonToDouble.toJson(this._y);
    }
    if (this._hasZ) {
      result.z = JsonToDouble.toJson(this._z);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get x() {
    return this._hasX ? this._x : JsonToDouble.default;
  }
  get hasX() {
    return this._hasX;
  }
  setX(path, value) {
    return {type: 'SET', path: path.concat(['x']), value};
  }
  deleteX(path) {
    return {type: 'DELETE', path: path.concat(['x'])};
  }
  /**
   * @returns {number}
   */
  get y() {
    return this._hasY ? this._y : JsonToDouble.default;
  }
  get hasY() {
    return this._hasY;
  }
  setY(path, value) {
    return {type: 'SET', path: path.concat(['y']), value};
  }
  deleteY(path) {
    return {type: 'DELETE', path: path.concat(['y'])};
  }
  /**
   * @returns {number}
   */
  get z() {
    return this._hasZ ? this._z : JsonToDouble.default;
  }
  get hasZ() {
    return this._hasZ;
  }
  setZ(path, value) {
    return {type: 'SET', path: path.concat(['z']), value};
  }
  deleteZ(path) {
    return {type: 'DELETE', path: path.concat(['z'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "x": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RallyPointComponent_Offset(this);
              copy._hasX = true;
              copy._x = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasX) {
                return this;
              }
              const copy = new RallyPointComponent_Offset(this);
              copy._hasX = false;
              copy._x = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "y": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RallyPointComponent_Offset(this);
              copy._hasY = true;
              copy._y = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasY) {
                return this;
              }
              const copy = new RallyPointComponent_Offset(this);
              copy._hasY = false;
              copy._y = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "z": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RallyPointComponent_Offset(this);
              copy._hasZ = true;
              copy._z = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasZ) {
                return this;
              }
              const copy = new RallyPointComponent_Offset(this);
              copy._hasZ = false;
              copy._z = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RallyPointComponent_Offset} other
   * @returns {RallyPointComponent_Offset}
   */
  merge(other) {
    const copy = new RallyPointComponent_Offset(this);
    if (other._hasX) {
      copy._hasX = true;
      copy._x = other._x;
    }
    if (other._hasY) {
      copy._hasY = true;
      copy._y = other._y;
    }
    if (other._hasZ) {
      copy._hasZ = true;
      copy._z = other._z;
    }
    return copy;
  }
}
RallyPointComponent_Offset.default = new RallyPointComponent_Offset();
class RallyPointComponent_Offset_Builder {
  constructor(value) {
    this._value = new RallyPointComponent_Offset(value);
  }
  build() {
    return new RallyPointComponent_Offset(this._value);
  }
  setX(value) {
    this._value._hasX = true;
    this._value._x = value;
    return this;
  }
  deleteX() {
    this._value._hasX = false;
    this._value._x = null;
    return this;
  }
  setY(value) {
    this._value._hasY = true;
    this._value._y = value;
    return this;
  }
  deleteY() {
    this._value._hasY = false;
    this._value._y = null;
    return this;
  }
  setZ(value) {
    this._value._hasZ = true;
    this._value._z = value;
    return this;
  }
  deleteZ() {
    this._value._hasZ = false;
    this._value._z = null;
    return this;
  }
}
RallyPointComponent_Offset.Builder = RallyPointComponent_Offset_Builder;
class RallyPointComponent_Offset_WithParent {
  /**
   * @param {RallyPointComponent_Offset} value
   * @param {RallyPointComponent_Offset_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RallyPointComponent_Offset.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasX() {
    if (this._cachedHasX === undefined) {
      if (this._value.hasX) {
        this._cachedHasX = true;
      } else {
        this._cachedHasX = this._parent ? this._parent.hasX : false;
      }
    }
    return this._cachedHasX;
  }
  get x() {
    if (this._cachedX === undefined) {
      if (this._value.hasX) {
        this._cachedX = this._value.x;
      } else {
        this._cachedX = this._parent ? this._parent.x : this._value.x;
      }
    }
    return this._cachedX;
  }
  get hasY() {
    if (this._cachedHasY === undefined) {
      if (this._value.hasY) {
        this._cachedHasY = true;
      } else {
        this._cachedHasY = this._parent ? this._parent.hasY : false;
      }
    }
    return this._cachedHasY;
  }
  get y() {
    if (this._cachedY === undefined) {
      if (this._value.hasY) {
        this._cachedY = this._value.y;
      } else {
        this._cachedY = this._parent ? this._parent.y : this._value.y;
      }
    }
    return this._cachedY;
  }
  get hasZ() {
    if (this._cachedHasZ === undefined) {
      if (this._value.hasZ) {
        this._cachedHasZ = true;
      } else {
        this._cachedHasZ = this._parent ? this._parent.hasZ : false;
      }
    }
    return this._cachedHasZ;
  }
  get z() {
    if (this._cachedZ === undefined) {
      if (this._value.hasZ) {
        this._cachedZ = this._value.z;
      } else {
        this._cachedZ = this._parent ? this._parent.z : this._value.z;
      }
    }
    return this._cachedZ;
  }
  update(current, parent) {
    const result = new RallyPointComponent_Offset_WithParent(current, parent);
    return result;
  }
}
RallyPointComponent_Offset_WithParent.default = new RallyPointComponent_Offset_WithParent(RallyPointComponent_Offset.default, null);
RallyPointComponent_Offset.WithParent = RallyPointComponent_Offset_WithParent;
class RallyPointComponent_Offset_Descriptor {
  get x() {
    if (!this._x) {
      this._x = {
        name: "x",
        Name: "X",
        number: 1,
        protoType: 1,
        protoName: "x",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._x;
  }
  get y() {
    if (!this._y) {
      this._y = {
        name: "y",
        Name: "Y",
        number: 2,
        protoType: 1,
        protoName: "y",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._y;
  }
  get z() {
    if (!this._z) {
      this._z = {
        name: "z",
        Name: "Z",
        number: 3,
        protoType: 1,
        protoName: "z",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._z;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.x,
        this.y,
        this.z,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForX",
        Name: "DummyOneofForX",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForY",
        Name: "DummyOneofForY",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForZ",
        Name: "DummyOneofForZ",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
RallyPointComponent_Offset.descriptor = new RallyPointComponent_Offset_Descriptor();
export class RallyPointComponent {
  get descriptor() {
    return RallyPointComponent.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDeprecatedRange = false;
    this._range = null;
    this._hasOffset = false;
    this._offset = null;
  }
  isEmpty() {
    if (this._hasDeprecatedRange) return false;
    if (this._hasOffset && !this._offset.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RallyPointComponent) {
      return value;
    }
    return RallyPointComponent.fromJson(value);
  }
  static fromJson(json) {
    const result = new RallyPointComponent();
    if (json.range != null) {
      result._hasDeprecatedRange = true;
      result._range = JsonToDouble.fromJson(json.range);
    }
    if (json.offset != null) {
      result._hasOffset = true;
      result._offset = RallyPointComponent_Offset.fromJson(json.offset);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDeprecatedRange) {
      result.range = JsonToDouble.toJson(this._range);
    }
    if (this._hasOffset && !this._offset.isEmpty()) {
      result.offset = RallyPointComponent_Offset.toJson(this._offset);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get range() {
    return this._hasDeprecatedRange ? this._range : JsonToDouble.default;
  }
  get hasDeprecatedRange() {
    return this._hasDeprecatedRange;
  }
  setDeprecatedRange(path, value) {
    return {type: 'SET', path: path.concat(['range']), value};
  }
  deleteDeprecatedRange(path) {
    return {type: 'DELETE', path: path.concat(['range'])};
  }
  /**
   * @returns {RallyPointComponent_Offset}
   */
  get offset() {
    return this._hasOffset ? this._offset : RallyPointComponent_Offset.default;
  }
  get hasOffset() {
    return this._hasOffset;
  }
  setOffset(path, value) {
    return {type: 'SET', path: path.concat(['offset']), value: value.toJson()};
  }
  deleteOffset(path) {
    return {type: 'DELETE', path: path.concat(['offset'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "range": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RallyPointComponent(this);
              copy._hasDeprecatedRange = true;
              copy._range = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedRange) {
                return this;
              }
              const copy = new RallyPointComponent(this);
              copy._hasDeprecatedRange = false;
              copy._range = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "offset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RallyPointComponent(this);
              copy._hasOffset = true;
              copy._offset = RallyPointComponent_Offset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffset) {
                return this;
              }
              const copy = new RallyPointComponent(this);
              copy._hasOffset = false;
              copy._offset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasOffset) {
            const copy = new RallyPointComponent(this);
            copy._hasOffset = true;
            copy._offset = RallyPointComponent_Offset.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._offset.apply(type, path.slice(1), value);
          if (newValue === this._offset) {
            return this;
          }
          const copy = new RallyPointComponent(this);
          copy._offset = copy._offset.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RallyPointComponent} other
   * @returns {RallyPointComponent}
   */
  merge(other) {
    const copy = new RallyPointComponent(this);
    if (other._hasDeprecatedRange) {
      copy._hasDeprecatedRange = true;
      copy._range = other._range;
    }
    if (other._hasOffset) {
      if (copy._hasOffset) {
        copy._offset = copy.offset.merge(other.offset);
      } else {
        copy._offset = other._offset;
      }
      copy._hasOffset = true;
    }
    return copy;
  }
}
RallyPointComponent.default = new RallyPointComponent();
RallyPointComponent.Offset = RallyPointComponent_Offset;
class RallyPointComponent_Builder {
  constructor(value) {
    this._value = new RallyPointComponent(value);
  }
  build() {
    return new RallyPointComponent(this._value);
  }
  setDeprecatedRange(value) {
    this._value._hasDeprecatedRange = true;
    this._value._range = value;
    return this;
  }
  deleteDeprecatedRange() {
    this._value._hasDeprecatedRange = false;
    this._value._range = null;
    return this;
  }
  setOffset(value) {
    this._value._hasOffset = true;
    this._value._offset = value;
    return this;
  }
  deleteOffset() {
    this._value._hasOffset = false;
    this._value._offset = null;
    return this;
  }
}
RallyPointComponent.Builder = RallyPointComponent_Builder;
class RallyPointComponent_WithParent {
  /**
   * @param {RallyPointComponent} value
   * @param {RallyPointComponent_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RallyPointComponent.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDeprecatedRange() {
    if (this._cachedHasDeprecatedRange === undefined) {
      if (this._value.hasDeprecatedRange) {
        this._cachedHasDeprecatedRange = true;
      } else {
        this._cachedHasDeprecatedRange = this._parent ? this._parent.hasDeprecatedRange : false;
      }
    }
    return this._cachedHasDeprecatedRange;
  }
  get range() {
    if (this._cachedDeprecatedRange === undefined) {
      if (this._value.hasDeprecatedRange) {
        this._cachedDeprecatedRange = this._value.range;
      } else {
        this._cachedDeprecatedRange = this._parent ? this._parent.range : this._value.range;
      }
    }
    return this._cachedDeprecatedRange;
  }
  get hasOffset() {
    if (this._cachedHasOffset === undefined) {
      if (this._value.hasOffset) {
        this._cachedHasOffset = true;
      } else {
        this._cachedHasOffset = this._parent ? this._parent.hasOffset : false;
      }
    }
    return this._cachedHasOffset;
  }
  get offset() {
    if (!this._cachedOffset) {
      if (this._value.hasOffset) {
        this._cachedOffset = new RallyPointComponent_Offset.WithParent(this._value.offset, this._parent && this._parent.hasOffset ? this._parent.offset : null);
      } else {
        this._cachedOffset = this._parent ? new RallyPointComponent_Offset.WithParent(RallyPointComponent_Offset.default, this._parent.offset) : RallyPointComponent_Offset.WithParent.default;
      }
    }
    return this._cachedOffset;
  }
  update(current, parent) {
    const result = new RallyPointComponent_WithParent(current, parent);
    if (this._cachedOffset && this._value.hasOffset && current.hasOffset) {
      if (this._value.offset === current.offset && this._parent === parent) {
        result._cachedOffset = this._cachedOffset;
      } else {
        result._cachedOffset = this._cachedOffset.update(current.offset, parent && parent.hasOffset ? parent.offset : null);
      }
    }
    return result;
  }
}
RallyPointComponent_WithParent.default = new RallyPointComponent_WithParent(RallyPointComponent.default, null);
RallyPointComponent.WithParent = RallyPointComponent_WithParent;
class RallyPointComponent_Descriptor {
  get range() {
    if (!this._range) {
      this._range = {
        name: "range",
        Name: "DeprecatedRange",
        number: 1,
        protoType: 1,
        protoName: "deprecated_range",
        type: JsonToDouble,
        options: {
          hideInInspector: true,
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._range;
  }
  get offset() {
    if (!this._offset) {
      this._offset = {
        name: "offset",
        Name: "Offset",
        number: 2,
        protoType: 11,
        protoName: "offset",
        type: RallyPointComponent_Offset,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offset;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.range,
        this.offset,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDeprecatedRange",
        Name: "DummyOneofForDeprecatedRange",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOffset",
        Name: "DummyOneofForOffset",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
RallyPointComponent.descriptor = new RallyPointComponent_Descriptor();
